import React, { Component } from "react";
import {
    Box, Tabs, Tab, Modal, Paper, Typography, IconButton, Button,
    DialogTitle, DialogContent, DialogContentText, DialogActions, Dialog,
    Card, Tooltip, TextField, Stack, FormControlLabel, Radio, RadioGroup,
    Checkbox, FormHelperText, Switch, InputAdornment, MenuItem,
    ButtonGroup, CircularProgress, Autocomplete, Badge, styled,
    FormControl,
    InputLabel,
    Select,
    Grid,
    Menu
} from "@mui/material";
import { ImagePaths } from '../../Utility/ImagePaths';
import {
    DataGrid, GridCsvExportMenuItem, GridToolbarColumnsButton, GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExportContainer, GridToolbarFilterButton,
    GridToolbarQuickFilter
} from '@mui/x-data-grid';
import "./commonComponents.css";
import { Colors } from "../../Styles/Colors";
import { useStopwatch } from 'react-timer-hook';
import { useState, useEffect } from "react";
import { formatDate, OpenDirectPrint, timeOnlyConvert, CheckAccessFunc, CheckCashCounterAccess, checkTransationMandatory, dataURItoFile } from "../CommonFunctions/CommonFunctions";
import CommonValidation from "../CommonFunctions/CommonValidation";
import RestAPIService from "../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../Utility/API/Serviceurls";
import { cmt_Char_limit, creditCorpTypes, TXN_MSG_MAX, TXN_MSG_MAX_LEN } from "../../Utility/Constants";
import CloseIcon from '@mui/icons-material/Close';
import { DateTimePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { clearCachevalue, localGetItem } from "../../Utility/Services/CacheProviderService";
import MaleIcon from '@mui/icons-material/Male';
import FemaleIcon from '@mui/icons-material/Female';
import ToastMsg from "../ToastMsg/ToastMsg";
import '../../App.css';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicOutlinedIcon from '@mui/icons-material/FormatItalicOutlined';
import FormatUnderlinedOutlinedIcon from '@mui/icons-material/FormatUnderlinedOutlined';
import FormatAlignLeftOutlinedIcon from '@mui/icons-material/FormatAlignLeftOutlined';
import FormatAlignCenterOutlinedIcon from '@mui/icons-material/FormatAlignCenterOutlined';
import FormatAlignRightOutlinedIcon from '@mui/icons-material/FormatAlignRightOutlined';
import { AmountFormat } from "../CommonFunctions/CommonFunctions";
import VoiceToText from "./VoiceToText";
import MicIcon from '@mui/icons-material/Mic';
import { grey } from '@mui/material/colors';
import Webcam from "react-webcam";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { DateTime } from 'luxon';
import CancelIcon from '@mui/icons-material/Cancel';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import TableChartIcon from '@mui/icons-material/TableChart';


const checkSetFrom = new Set(["dischargeSummary", "NurseNotes", "nurseAssessment", "NoNeedButton"]);

export class CommonNavigationHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: props.menu && props.menu.length > 0 ? props.menu : [],
            tabId: props.selectedTabID ? props.selectedTabID : 0
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.selectedTabID != this.props.selectedTabID) {
            this.setState({
                tabId: this.props.selectedTabID
            })
        }
    }
    handleChange = (event, newValue) => {
        this.setState({
            tabId: newValue
        }, () => {
            this.props.NavigateScreen(newValue);
        })
    };
    render() {
        let { menu } = this.state
        return (
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={this.state.tabId}
                        onChange={this.handleChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{ minHeight: '1vw' }}
                    >
                        {menu && menu.length > 0 && menu.map((data) => (
                            <Tab sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }} key={data.id} value={data.id} label={data.TabName} />
                        )
                        )}
                    </Tabs>
                </Box>
            </Box>
        )
    }
}

export class CommonTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: this.props.rows.length > 0 ? this.props.rows : [],
            columns: this.props.columns.length > 0 ? this.props.columns : []
        }
    }
    render() {
        return (
            <div style={{ height: "18.75vw", width: '100%' }}>
                <DataGrid rows={this.state.rows} columns={this.state.columns} />
            </div>
        )
    }
}
export class ClickableCard extends Component {
    render() {
        return (
            <Button emed_tid={this.props.testID} className="eMed_Click_card_hover" disabled={this.props.disable}>
                <Card elevation={3} onClick={() => { this.props.onClick() }} className="eMed_Clickable_card" sx={{ backgroundColor: this.props.isSelected ? Colors.ThemeColor : "" }}>
                    <div style={{ color: this.props.isSelected ? "white" : '' }}>{ }</div>
                    <div style={{ color: this.props.isSelected ? "white" : '', }} >
                        <img style={{ width: this.props.width ? this.props.width : "2vw", height: this.props.height ? this.props.height : "2vw" }} src={this.props.icon} alt={this.props.label} />
                    </div>
                    <div className="eMed_Clickable_label" style={{ color: this.props.isSelected ? "white" : '' }}>{this.props.label}</div>
                    {this.props.labelTwo ? <div className="eMed_Clickable_label" style={{ color: this.props.isSelected ? "white" : '' }}>{this.props.labelTwo}</div> : null}
                </Card>
            </Button>
        )
    }
}
export class AppointmentCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Count: this.props.count ? this.props.count : "0",
            Label: this.props.label ? this.props.label : "-",
            Color: this.props.color ? this.props.color : "",
            isSelectedCard: this.props.isSelectedCard ? this.props.isSelectedCard : false
        }
    }
    componentDidUpdate() {
        if (this.props.count != this.state.Count) {
            this.setState({
                Count: this.props.count
            })
        }
    }
    render() {
        const showArrow = this.state.Label === "Arrived" || this.state.Label === "With Doctor";
        return (
            <Box className="AppointmentCardWrapper">
                <Button className="eMed_App_Card Common_Btn_Min_Width" sx={{ padding: '0.5dvw 0.25dvw' }} onClick={() => { this.props.onClick() }}>
                    <Card elevation={3} className='eMed_ApoinmtCards_div' sx={{ backgroundColor: this.props.isSelected ? Colors.EditBtnColor : "" }} emed_tid={this.props.emed_tid}>
                        <div className="eMed_ApoinmtCards_Content">
                            {this.props.icon ? <img className="eMed_ApoinmtCards_icon" src={this.props.icon} alt={this.state.Label} /> : null}
                            <div className="eMed_ApoinmtCards_count">{this.state.Count}</div>
                            {/* Show arrow only for Arrived and With Doctor */}
                            {showArrow && (
                                <Box sx={{ display: 'flex', alignItems: 'flex-end', marginLeft: '1vw'}}>
                                    <img src={ImagePaths.ArrowDrop.default}
                                        fontSize="small"
                                        style={{color: "#555", width: '.8vw', height: '.8vw' }}
                                    />
                                </Box>
                            )}
                        </div>
                        <div >{ }</div>
                        {this.state.Label?.length > 10 ?
                            <Tooltip title={this.state.Label} placement={'top'} arrow>
                                <div className="eMed_ApoinmtCards_label">{(this.state.Label ? this.state.Label?.slice(0, 10) + '...' : '-')}</div>
                            </Tooltip> :
                            <div className="eMed_ApoinmtCards_label">{this.state.Label ? this.state.Label : '-'}</div>}
                        <div className="eMed_ApoinmtCards_color" style={{ backgroundColor: this.props.color, height: this.props.isSelectedCard ? '15%' : '5%' }}></div>
                    </Card>
                </Button>
                {/* ✅ Child section (expand when parent selected) */}
                {this.props.isSelectedCard && this.props.children ? (
                    <div className="AppointmentCardChildren">
                        {this.props.children}
                    </div>
                ) : null}
            </Box>
        )
    }
}
export class CommonEditButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: this.props.size ? this.props.size : "1.3vw"
        }
    }
    render() {
        return (
            <Tooltip title="Edit" placement="top" arrow>
                <Button emed_tid={this.props.testID} className="eMed_Edit_btn eMed_usrconf_btn" disabled={this.props.disable} size='small'>
                    <img src={this.props.disable ? ImagePaths.DisabledEdit.default : ImagePaths.LabEditButton.default} style={{ height: this.state.size, width: this.state.size }} alt='Edit'
                        onClick={() => { this.props.onClick() }} />
                </Button>
            </Tooltip>
        )
    }
}
export class CommonDeleteButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: this.props.size ? this.props.size : "1.3vw"
        }
    }
    render() {
        return (
            <Tooltip title= {this.props.isCancel ? "Cancel" : "Delete"} placement="top" arrow>
                <IconButton emed_tid={this.props.testID} className={`${this.props.isCancel ? "" : "eMed_Edit_btn"} eMed_usrconf_btn`} disabled={this.props.disable} size='small' onClick={() => { this.props.onClick() }}>
                    {this.props.isCancel ? <CancelIcon color={ this.props.disable ? 'disable' : 'error'} sx={{ height: this.state.size, width: this.state.size }} /> 
                    : <img src={this.props.disable ? ImagePaths.DisabledDelete.default : ImagePaths.LabDeleteButton.default} style={{ height: this.state.size, width: this.state.size }} alt='Delete' />}
                </IconButton>
            </Tooltip>
        )
    }
}



export class CommonPopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true
        }
    }

    handleClose = () => {
        this.props.popUpClose();
    }
    buttonOneAction = () => {
        this.props.buttonOneAction();
    }
    buttonTwoAction = () => {
        this.setState({ disableBtn: this.props?.disableBtn2 === false ? false : true }, () => {
            setTimeout(() => { this.setState({ disableBtn: false }) }, 1500)
            this.props.buttonTwoAction()
        })
    }
    render() {
        let { open } = this.state;
        let width = this.props.width ? this.props.width : "85vw"
        let height = this.props.height ? this.props.height : null
        let testID = this.props.testID ? this.props.testID : "test"
        return (
            <Modal open={open}>
                <Paper elevation={3} id="emedhub_popup_mainBox" sx={{ width: width, height: height }}>
                    <div id="emedhub_popup_header" style={{ backgroundColor: this.props.backgroundColor ? this.props.backgroundColor : Colors.DataTblHeaderbg }}>
                        <Stack direction="row" spacing={2} alignItems={"center"}>
                            <Typography sx={{ color: "#616161", fontWeight: 600 }}>{this.props.title}</Typography>
                            {this.props.titleIconImg ? <Tooltip placement="top" title={this.props.iconTitle} arrow>
                                <IconButton emed_tid={`cmn_${testID}_${this.props.iconTitle}`} size="small" onClick={() => this.props.IconAction()}>
                                    <img className="emedhub_directPo_img" src={this.props.titleIconImg} alt={this.props.iconTitle} />
                                </IconButton>
                            </Tooltip> : null}
                        </Stack>
                        <IconButton emed_tid={`cmn_${testID}_close`} onClick={this.handleClose} size="small" ><img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt={"close"} /></IconButton>
                    </div>
                    <div id="emedhub_popup_content" emed_tid={`cmn_${testID}_cnt`}>
                        {this.props.component()}
                    </div>
                    {this.props.footerTitle1 || this.props.buttonOne ?
                        <Stack id="emedhub_popup_footer" direction="row" justifyContent={this.props.footerTitle1 ? "space-between" : this.props.justifyRight ? "flex-end" : "center"} alignItems="center" sx={{ height: this.props.footerTitle1 ? "4vw" : "3vw" }}>
                            {this.props.footerTitle1 ?
                                <div style={{ marginLeft: "0.5vw" }}>
                                    <div className="emedhub_popup_footer_subdiv">
                                        <div className="emedhub_popup_bulletin"></div>
                                        <p className="emedhub_popup_footer_Text emedhub_popup_footer_Text1">{this.props.footerTitle1}</p>
                                        <p className="emedhub_popup_footer_Text emedhub_popup_footer_Text2">{this.props.footerContent1}</p>
                                    </div>
                                    {
                                        this.props.footerTitle2 ?
                                            <div className="emedhub_popup_footer_subdiv">
                                                <div className="emedhub_popup_bulletin"></div>
                                                <p className="emedhub_popup_footer_Text emedhub_popup_footer_Text1">{this.props.footerTitle2}</p>
                                                <p className="emedhub_popup_footer_Text emedhub_popup_footer_Text2">{this.props.footerContent2}</p>
                                            </div>
                                            : null
                                    }
                                </div>
                                : null
                            }
                            <div>
                                <Button emed_tid={`cmn_${testID}_${this.props.buttonOne}`} size="small" sx={{ marginRight: this.props.buttonTwo ? "1vw" : 0, textTransform: "capitalize" }} variant={this.props.buttonTwo ? "outlined" : "contained"} onClick={() => { this.buttonOneAction() }}>{this.props.buttonOne}</Button>
                                {this.props.buttonTwo ? <Button emed_tid={`cmn_${testID}_${this.props.buttonTwo}`} variant="contained" size="small" disabled={this.props.disableBtn2 || this.state.disableBtn} sx={{ textTransform: "capitalize" }} onClick={() => { this.buttonTwoAction() }}>{this.props.buttonTwo}</Button> : null}
                            </div>
                        </Stack>
                        : null
                    }
                </Paper>
            </Modal>
        )
    }
}

export class DeletePopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            deleteDialog: true,
            disableBtn: false,
        }
    }

    handleClose = () => {
        this.setState({ disableBtn: false })
        this.props.deleteAlertPopupClose();
    };

    removeFunction = () => {
        this.props.removeData(false)
        setTimeout(() => {
            this.setState({ disableBtn: false })
        }, 1500);
    }

    render() {
        let testID = this.props.testID ? this.props.testID : "test"
        return (
            <Dialog
                open={this.state.deleteDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0.5vw', marginBottom: '0vw' }}>
                    <img emed_tid={`dlt_${testID}_close`} className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={this.handleClose} />
                </div>
                <DialogTitle id="alert-dialog-title">
                    {this.props.DeletTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ fontSize: '0.8vw' }} id="alert-dialog-description">
                        {this.props.DeletContent ? this.props.DeletContent : ""}
                    </DialogContentText>
                    {
                            this.props.AlertNote !== undefined ?
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '0.5vw' }}>
                                    <div style={{ marginRight: '0.5vw' }} id="alert-dialog-description">
                                        <ErrorOutlineIcon color="error" fontSize="medium" />
                                    </div>
                                    <DialogContentText sx={{ fontSize: '0.9vw', marginLeft: '0.5vw', fontWeight: 600, color: 'red' }} id="alert-dialog-description">
                                        {this.props.AlertNote}
                                    </DialogContentText>
                                </div> : null
                        }
                </DialogContent>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <DialogContent>
                        {
                            this.props.DeleteNotify !== undefined ?
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <div className="eMed_DeletedPopup_bullet"></div>
                                    <div style={{ fontSize: '0.6vw', color: '#616161', marginRight: '0.5vw' }} id="alert-dialog-description">
                                        {this.props.ButtonText ? this.props.ButtonText : "Remove"}
                                    </div>
                                    <div className="eMed_DeletedPopup_Border"></div>
                                    <DialogContentText sx={{ fontSize: '0.6vw', marginLeft: '0.5vw', fontWeight: 600, color: this.props.color }} id="alert-dialog-description">
                                        {this.props.DeleteNotify}
                                    </DialogContentText>
                                </div> : null
                        }
                        {
                            this.props.NotesContent !== undefined ?
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <DialogContentText sx={{ fontSize: '0.6vw', marginLeft: '0.5vw', fontWeight: 600, color: this.props.color }} id="alert-dialog-description">
                                        {this.props.NotesContent}
                                    </DialogContentText>
                                </div> : null
                        }

                    </DialogContent>
                    <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        {this.props?.BillType === "Saved Bill" ? <Button disabled={this.props.disable} emed_tid={`dlt_${testID}_${this.props.ButtonText1 ? this.props.ButtonText1 : "Cancel"}`} color="error" size="small" variant="contained" sx={{ textTransform: "capitalize" }} onClick={this.handleClose}>
                            {this.props?.ButtonText1 ? this.props?.ButtonText1 : "Cancel"}
                        </Button> : null}
                        <Button disabled={this.props.disable ? this.props.disable : this.state.disableBtn} emed_tid={`dlt_${testID}_${this.props.ButtonText ? this.props.ButtonText : "Remove"}`} color="error" size="small" variant="contained" sx={{ textTransform: "capitalize" }} onClick={() => this.setState({ disableBtn: true }, () => this.removeFunction())}>
                            {this.props.ButtonText ? this.props.ButtonText : "Remove"}
                        </Button>
                    </DialogActions>
                </div>
            </Dialog>
        )
    }
}
export class CommonGridToolBarWithButton extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isButtonClick: false,
            isToggled: false
        }
    }
    render() {
        let isToggle = this.props.toggleLeft && this.props.toggleRight;
        return (
            <GridToolbarContainer className={isToggle ? 'eMed_tgleBar_grid' : 'eMed_refdoc_grid'} >
                {this.props.ViewBtn ? <Button variant='contained' size="small" id="eMed_recPayment_btn" onClick={() => {
                    this.setState({
                        isButtonClick: true
                    }, () => {
                        this.props.onClickCommonButton(this.state.isButtonClick)
                    })
                }} endIcon={this.props.endIcon}>{this.props.label}</Button>
                    : isToggle ? <Box className="eMed_tgleBar_grid_action">
                        <label id="eMed_tgleBar_grid_txt" style={{ paddingRight: '0.8vw', paddingTop: '0.1vw' }}>{this.props.toggleLeft}</label>
                        <FormControlLabel
                            value="end"
                            id="eMed_tgleBar_grid_txt"
                            control={
                                <Switch
                                    size='small'
                                    color="primary"
                                    checked={this.state.isToggled}
                                    onChange={(e) => {
                                        this.setState({ isToggled: e.target.checked },
                                            () => { this.props.onClickToggleBtn(this.state.isToggled) })
                                    }} />}
                            label={this.props.toggleRight}
                            labelPlacement="end"
                        />
                    </Box>
                        : null}
                <div>
                    <Tooltip placement='top' title='Show/Hide Column' arrow><GridToolbarColumnsButton /></Tooltip>
                    <GridToolbarFilterButton placement='top' />
                    <Tooltip placement='top' title='Table Density' arrow><GridToolbarDensitySelector /></Tooltip>
                    <Tooltip placement='top' title='Export' arrow><GridToolbarExportContainer>
                        <GridCsvExportMenuItem />
                    </GridToolbarExportContainer></Tooltip>
                    <GridToolbarQuickFilter />
                </div>
            </GridToolbarContainer>
        )
    }
}
export class CommonGridToolBarWithFilterText extends Component {
    constructor(props) {
        super(props)

    }
    render() {
        return (
            <GridToolbarContainer className='eMed_refdoc_grid' sx={{ flexWrap:'nowrap' }}>
                {this.props.isDelete ? <Box sx={{ display: 'flex', width: this.props?.fromStore ? "70vw" : '60vw' }}>
                    <Button size="small" variant="contained" color="error" sx={{ textTransform: 'capitalize' }} onClick={() => { this.props.removeData() }}>{this.props?.DeleteBtnText ? this.props?.DeleteBtnText : "Delete"}</Button>
                </Box> : null}
                {this.props.FName ?
                    <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                        <Typography fontSize={'0.8vw'} color={"#888888"} marginX={"0.3vw"}>Name: </Typography> <Typography fontSize={'0.9vw'} color={"#616161"} marginX={"0.3vw"} fontWeight={600}>{this.props.FName}</Typography>
                    </Box> : null}
                {this.props.FilterTextArray && this.props.FilterTextArray.length > 0 ?
                    this.props.FilterTextArray.map((list, index) => (
                        <Box key={index} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                            <Typography fontSize={'0.8vw'} color={"#888888"} marginX={"0.3vw"}>{list.label} : </Typography> <Typography fontSize={'0.9vw'} color={"#616161"} marginX={"0.3vw"} fontWeight={600}>{list.value}</Typography>
                        </Box>
                    )) : null}
                {this.props?.renderComponent ?
                    <>
                        {this.props?.renderComponent()}
                        <Tooltip placement='top' title='Export' arrow><GridToolbarExportContainer>
                            {this.props.noExport ? null : <GridCsvExportMenuItem />}
                        </GridToolbarExportContainer></Tooltip>
                    </>
                    :
                    <>
                        <Tooltip placement='top' title='Show/Hide Column' arrow><GridToolbarColumnsButton /></Tooltip>
                        <GridToolbarFilterButton placement='top' />
                        <Tooltip placement='top' title='Table Density' arrow><GridToolbarDensitySelector /></Tooltip>
                        <Tooltip placement='top' title='Export' arrow><GridToolbarExportContainer>
                            {this.props.noExport ? null : <GridCsvExportMenuItem />}
                        </GridToolbarExportContainer></Tooltip>
                    </>}

                {
                    this.props?.onChangingSearch ?  // for custom search text box with value and onchange
                        <GridToolbarQuickFilter placeholder={this.props.searchHolder ? this.props.searchHolder : "Search"} value={this.props?.value} onChange={(e) => {
                            this.props.onChangetrigger(e.target.value)
                        }} />
                        :
                        <GridToolbarQuickFilter placeholder={this.props.searchHolder ? this.props.searchHolder : "Search"} />
                }
            </GridToolbarContainer>
        )
    }
}
export class CommonGridToolBarWithExtraFilter extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <GridToolbarContainer sx={{ display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: 'flex-end', height: '6.5vh' }} >
                <GridToolbarQuickFilter sx={{ mr: '0.25vw' }} placeholder={this.props.searchHolder ? this.props.searchHolder : "Search"} />
            </GridToolbarContainer>
        )
    }
}

export class CommonGridToolBarWithFilterTextCustom extends Component {
    constructor(props) {
        super(props)
    }
    convertArrayToCSV = (data) => {
        const headers = Object.keys(data[0]);
        var FromPeriod = this.props?.FilterTextArray ? this.props?.FilterTextArray[0]?.value : null
        var ToPeriod = this.props?.FilterTextArray ? this.props?.FilterTextArray[1]?.value : null
        var title = this.props?.title ? this.props?.title : ""
        if(this.props.withoutheaderSpace || title ==="Insurance Patient Report" || title === "Counsellor Home" || title === "DotorModule Home" || title === "OT Home" || title === "Department Master" || title === "Container Master" || title === "Specimen Master" || title === "Method Master" ||  title === "Antibiotic Master" || title === "Organism Master"  || title ==="Organism Vs Antibiotic Name" || title ==="Analyser Master"){
            const csvContent = [
                headers?.join(','),
                ...data.map((row) => headers.map((header) => row[header])?.join(',')),
            ]?.join('\n');

            return csvContent;
        } else {
            const titleRow = [title]
            const extraRow1 = FromPeriod ? ['From Date', FromPeriod] : []
            const extraRow2 = ToPeriod ? ['To Date', ToPeriod] : []
            const csvContent = [
                titleRow?.join(','),
                extraRow1?.join(','),
                extraRow2?.join(','),
                headers?.join(','),
                ...data.map((row) => headers.map((header) => row[header])?.join(',')),
            ]?.join('\n');

            return csvContent;
        }

    }

    downloadCSV = (csvContent, fileName) => {
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    }

    filterClick = () => {
        const csvContent = this.convertArrayToCSV(this.props.data);
        const fileName = `${this.props.filename}.csv`;
        this.downloadCSV(csvContent, fileName);
    }
    render() {
        return (
            <GridToolbarContainer className='eMed_refdoc_grid' >
                {this.props.FilterTextArray && this.props.FilterTextArray.length > 0 ?
                    this.props.FilterTextArray.map((list, index) => (
                        <Box key={index} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                            <Typography fontSize={'0.8vw'} color={"#888888"} marginX={"0.3vw"}>{list.label} : </Typography> <Typography fontSize={'0.9vw'} color={"#616161"} marginX={"0.3vw"} fontWeight={600}>{list.value}</Typography>
                        </Box>
                    )) : null}
                <Tooltip placement='top' title='Show/Hide Column' arrow><GridToolbarColumnsButton /></Tooltip>
                <GridToolbarFilterButton placement='top' />
                <Tooltip placement='top' title='Table Density' arrow><GridToolbarDensitySelector /></Tooltip>
                <Tooltip placement='top' title='Export' arrow>
                    <GridToolbarExportContainer>
                        <MenuItem disabled={this.props.data == 0} onClick={this.filterClick} color='secondary' size='small'>{"Download CSV"}</MenuItem>
                        {/* <Button ></Button> */}
                    </GridToolbarExportContainer>
                </Tooltip>
                <GridToolbarQuickFilter placeholder={this.props.searchHolder ? this.props.searchHolder : "Search"} />
            </GridToolbarContainer>
        )
    }
}
export class CommonGridToolBarWithFilterTextCustomRevenue extends Component {
    constructor(props) {
        super(props)

    }
    downloadCSV = (csvContent, fileName) => {
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    }
    DashBoardconvertArrayToCSV = (data) => {
        const headers = Object.keys(data[0])
        const csvContent = [
            headers.join(','),
            ...data.map((row) => headers.map((header) => row[header]).join(',')),
        ].join('\n');
        return csvContent;
    }
    DashBoardfilterClick = () => {
        const csvContent = this.DashBoardconvertArrayToCSV(this.props.data);
        const fileName = `${this.props.filename}.csv`;
        this.downloadCSV(csvContent, fileName);
    }
    render() {
        return (
            <GridToolbarContainer sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '5vh' }} >
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <Typography fontSize={'0.85vw'} fontWeight={600} marginX={"0.3vw"}>{this.props.title}</Typography>
                </Box>
                <Tooltip placement='top' title='Export' arrow>
                    <GridToolbarExportContainer>
                        <MenuItem disabled={this.props.data == 0} color='secondary' size='small' onClick={this.DashBoardfilterClick}>{"Download CSV"}  </MenuItem>
                        {/* <Button ></Button> */}
                    </GridToolbarExportContainer>
                </Tooltip>
            </GridToolbarContainer>
        )
    }
}


export class CommonGridToolBarTitleWithExport extends Component {
    constructor(props) {
        super(props)

    }
    render() {
        return (
            <GridToolbarContainer sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '5vh' }} >
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <Typography fontSize={'0.85vw'} fontWeight={600} marginX={"0.3vw"}>{this.props.title}</Typography>
                </Box>
                <Tooltip placement='top' title='Export' arrow><GridToolbarExportContainer>
                    <GridCsvExportMenuItem />
                </GridToolbarExportContainer></Tooltip>
            </GridToolbarContainer>
        )
    }
}
export default class CommonGridHeader {
    static CommonToolBar = ({ fromIPnursenotes, onViewGraphClick }) => {
        return (
            <GridToolbarContainer className='eMed_refdoc_grid' >
                {fromIPnursenotes && (
                    <Tooltip placement='top' title='View Graph' arrow>
                        <Button
                            variant="contained"
                            size="small"
                            onClick={onViewGraphClick}
                            style={{ marginRight: '10px' }}
                        >
                            View Graph
                        </Button>
                    </Tooltip>
                )}
                <Tooltip placement='top' title='Show/Hide Column' arrow><GridToolbarColumnsButton /></Tooltip>
                <GridToolbarFilterButton placement='top' />
                <Tooltip placement='top' title='Table Density' arrow><GridToolbarDensitySelector /></Tooltip>
                <Tooltip placement='top' title='Export' arrow><GridToolbarExportContainer>
                    <GridCsvExportMenuItem />
                </GridToolbarExportContainer></Tooltip>
                <GridToolbarQuickFilter />
            </GridToolbarContainer>
        )
    }

}
export class CommonGridHeaderOnlySearch {
    static CommonToolBarOnlySearch = () => {
        return (
            <GridToolbarContainer className='eMed_refdoc_grid' >
                <GridToolbarQuickFilter />
            </GridToolbarContainer>
        )
    }

}

export const renderOutSourceBadge = (data = {}) => {
    if (!data?.outsource_lab_name && !data?.outsourced_due_date) return null;
    const tooltipTitle = (
        <Box>
            <Typography fontSize={"0.85vw"} fontWeight={"bold"}>Outsource Due Details</Typography>
            <Typography fontSize={"0.85vw"}>Outsource Lab : {data?.outsource_lab_name}</Typography>
            <Typography fontSize={"0.85vw"}>Due Date : {data?.outsourced_due_date}</Typography>
        </Box>
    );

    const tooltipProps = {
        placement: "top",
        title: tooltipTitle,
        arrow: true,
    };

    return (
        <Tooltip {...tooltipProps}>
            <Button size="small" variant="outlined" color="error"
                sx={{
                    width: "2vw", minWidth: "2vw",
                    fontSize: "0.8vw", textTransform: "capitalize",
                    lineHeight: 1, padding: 0, marginLeft: "0.3vw"
                }}>
                Due</Button>
        </Tooltip>
    )
}

export const renderInsCorpDetails = (data = {}, forcedOpen) => {
    if (!data) return null;
    const primary_type = data?.primary_payment_type || data?.credit_type;
    const isInsurance = primary_type === "Insurance credit";
    const isCorporate = primary_type === "Corporate credit" || primary_type === 'Corporate credit';

    const insurance_name = isInsurance ? (data?.insurance_name || data?.patient_insurance_company || data?.insurance_company_name) : "";
    const company_name = isCorporate ? (data?.corp_company_name || data?.corp_company || data?.company_name || data?.employer_name) : "";
    const policy_number = isInsurance ? (data?.policy_number || data?.policy_no) : "";
    const employee_id = isCorporate ? (data?.employee_id || data?.id_no) : "";

    const label = insurance_name ? "Insurance Details" : "Corporate Details";
    const companyLabel = insurance_name ? "Insurance Company" : "Corporate Name";
    const policyLabel = insurance_name ? "Policy Number" : "Employee ID";

    if (!insurance_name && !company_name) return null;
    const tooltipTitle = (
        <Box>
            <Typography fontSize={"0.85vw"} fontWeight={"bold"}>{label}</Typography>
            <Typography fontSize={"0.85vw"}>{companyLabel} : {insurance_name || company_name || ""}</Typography>
            <Typography fontSize={"0.85vw"}>{policyLabel} : {policy_number || employee_id || ""}</Typography>
        </Box>
    );

    const tooltipProps = {
        placement: "bottom",
        title: tooltipTitle,
        arrow: true,
    };

    if (typeof forcedOpen === 'boolean' && forcedOpen === true) {
        tooltipProps.open = forcedOpen;
    }
    return (
        <Tooltip {...tooltipProps} key={forcedOpen ? "forced" : "hover"}>
            <img
                src={insurance_name ? ImagePaths.InsuranceIcon.default : ImagePaths.CorporateIcon.default}
                alt={insurance_name ? "Insurance" : "Corporate"}
                style={{ width: '1vw', height: "1vw", marginLeft: "0.3vw" }}
            />
        </Tooltip>
    )
}
export class CommonPatientDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            forcedTooltipOpen: true
        }
    }

    componentDidMount() {
          this.timeout = setTimeout(() => {
            this.setState({ forcedTooltipOpen: undefined });
        }, 2000);
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    render() {
        const { data } = this.props
        let fullName = this.props.fromPurchase ? `${data.first_name} ${data.last_name}` : data?.login_fname + " " + data?.login_lname;
        let admission_date = data?.admission_date ? formatDate(data?.admission_date) : data?.approx_check_in_date ? formatDate(data?.approx_check_in_date) : data?.appointment_date ? formatDate(data?.appointment_date) : "-";
        let surgery_date = data?.surgery_date ? formatDate(data?.surgery_date) : "-";
        let admissionDetails = `${admission_date} | ${data?.admission_time ? data?.admission_time : "-"}`
        let SurgeryDetails = `${surgery_date} | ${data?.surgery_time ? this.props.isFromOTList === true ? timeOnlyConvert(data?.surgery_time) : data?.surgery_time : "-"}`
        let PatientAccNumber = data?.patient_account_numbers ? data?.patient_account_numbers : data?.patient_account_number ? data?.patient_account_number : data?.uhid ? data?.uhid : data?.patient_acc_no ? data?.patient_acc_no : data?.patient_uhid ? data?.patient_uhid : data?.patient__patient_account_number ? data?.patient__patient_account_number : data?.patient_acc_number ? data?.patient_acc_number : "-";
        let photo_url = data?.patient_photo_url || data?.photo_url || data?.patient__photo_url;
        let patient_name = data?.patient_name ? data?.patient_name : data?.name ? data?.name : data?.first_name ? data?.first_name : data?.patient_names ? data?.patient_names : "-";
        let mobile_number = (data?.patient_mobile_number || null) || (data?.patient__mobile_number || null) || (data?.mobile_number || null) || (data?.patients_mobile_number || null) || (data?.patient_mobile_no || null) || (data?.patient_mobile || null) || (data?.patients_mobile || null) || (data?.mobile_no || null);
        let patient_age = data?.patient_age?.toString()?.includes("Y") ? data?.patient_age : data?.age?.toString()?.includes("Y") ? data?.age : data?.patient_age_str ? data?.patient_age_str : data?.age?.toString()?.includes("Y") ? data?.age : (data?.age ? (data?.age + "Y") : "-");
        let patient_gender = data?.patient_gender || data?.gender || data?.patient__gender;
        let whatGender = ((data?.patient_gender === 'Male' || data?.patient_gender === 'M' || data?.patient_gender === 'm' || data?.gender === "m" || data?.gender === "M" || data?.gender === 'Male' || data?.patient__gender === "m") ? "M" : (data?.patient_gender === 'Female' || data?.patient_gender === 'f' || data?.gender === "f" || data?.patient_gender === 'F' || data?.gender === "Female" || data?.gender === "F" || data?.patient__gender === "f") ? "F" : (data?.patient_gender === "Trans" || data?.patient_gender === 't' || data?.patient_gender === 'T' || data?.gender === "t" || data?.gender === "T" || data?.patient__gender === "t") ? "T" : "-");
        let branchName = data?.branch_name ? data?.branch_name : null

        const tooltipOpen = this.props.forceOpen ?? this.state.forcedTooltipOpen;
        return (
            <div className="eMed_Com_Patient_Details">
                {this.props.disablePhoto ? null :
                    <div>
                        {this.props.fromUserAccess ?
                            <div className="eMed_Com_Patient_Avatar">
                                <img className="eMed_Com_Patient_AvaIcon" style={{ borderColor: (data?.patient_type === "new_patient" || data?.patient__patient_type === 1) ? "#F1584A" : (data?.patient_type === "old_patient") || (data?.patient_type === "establish_patient") || (data?.patient_type === "established_patient") || (data?.patient__patient_type === 3) ? "#800080" : '#29B6F6' }}
                                    src={data?.user_image ? data?.user_image : ImagePaths.Male.default} alt={'Avatar'} />
                            </div> :
                            <div className="eMed_Com_Patient_Avatar">
                                <img className="eMed_Com_Patient_AvaIcon" style={{ borderColor: (data?.patient_type === "new_patient" || data?.patient__patient_type === 1) ? "#F1584A" : (data?.patient_type === "old_patient") || (data?.patient_type === "establish_patient") || (data?.patient_type === "established_patient") || (data?.patient__patient_type === 3) ? "#800080" : '#29B6F6' }}
                                    src={photo_url === null || photo_url === "" || photo_url === undefined ? data?.patient_gender === "Male" || data?.patient_gender === "m" || data?.gender === "m" || data?.gender === "Male" ? ImagePaths.Male.default : ImagePaths.Female.default : photo_url} alt={'Avatar'} />
                            </div>}
                    </div>
                }
                <div>
                    <Box component={'div'} className="eMed_Pateint_Detail_LongData">
                        {this.props.fromUserAccess ?
                            <Box component={'div'}>
                                <Typography component={'div'}>
                                    {(fullName?.length) > 20 ?
                                        <Tooltip title={fullName} placement={'top'}>
                                            <div><Typography id='eMed_Com_Patient_Name' style={{ fontSize: this.props.packageDetail ? "1.25vw" : "0.8vw" }}>{((fullName) ? ((fullName.slice(0, 20) + '...')) : '-')}</Typography>
                                            </div></Tooltip> : <Typography id='eMed_Com_Patient_Name' style={{ fontSize: this.props.packageDetail ? "1.25vw" : "0.8vw" }}>{(fullName ? fullName : '-')}</Typography>}
                                </Typography>
                                <Typography id='eMed_Com_Patient_UhidText'>{(data?.phone_number ? data?.phone_number : "-")}</Typography>
                            </Box> :
                            <Box component={'div'}>
                                <div style={{ display: "flex", alignItems: "center"}}>
                                    {(patient_name?.length) > 20 ?
                                        <Tooltip title={patient_name} placement={'top'} arrow>
                                            <Typography id='eMed_Com_Patient_Name' style={{ fontSize: this.props.packageDetail ? "1.25vw" : "0.8vw", whiteSpace: "nowrap" }}>{(patient_name ? ((patient_name?.slice(0, 15) + '...')) : '-') + ' ' + (patient_age ? patient_age : '-') + '/' + (patient_gender ? whatGender : '-')}</Typography>
                                        </Tooltip> :
                                        <Typography id='eMed_Com_Patient_Name' style={{ fontSize: this.props.packageDetail ? "1.25vw" : "0.8vw" }}>{(patient_name ? patient_name : '-') + ' ' + (patient_age ? patient_age : '-') + '/' + (patient_gender ? whatGender : '-')}</Typography>
                                    }
                                    {data?.is_outsource_over_due ? renderOutSourceBadge(data) : !this.props.hideInsurance ? renderInsCorpDetails(data, tooltipOpen) : null}
                                    {this.props.icon ? <div style={{ marginLeft: "0.5vw" }}>
                                        {whatGender === "M" ? <MaleIcon sx={{ fontSize: "1vw", color: '#616161' }} /> : whatGender === "F" ? <FemaleIcon sx={{ fontSize: "1vw", color: '#616161' }} /> : null}
                                    </div> : null}
                                </div>
                                <Typography id='eMed_Com_Patient_UhidText'>{(PatientAccNumber) + ' | ' + (mobile_number ? mobile_number : '-')}</Typography>
                                {this.props.isCommonUhid ? <Typography id='eMed_Com_Patient_UhidText'>Branch Name: {branchName?.length > 22 ? <Tooltip placement="top" title={branchName} arrow><span id='eMed_Com_Patient_UhidText'>{branchName?.slice(0, 19) + "..."}</span></Tooltip> : branchName ? branchName : "-"}</Typography> : null}
                            </Box>
                        }

                        {this.props.showDetailed === true ?
                            <Box component={'div'}>
                                {this.props?.fromDoctor ?
                                    <Typography id='eMed_Com_Patient_Name'>
                                        {data?.op_number?.length > 15 ?
                                            <Tooltip title={data?.op_number} placement={'top'} arrow>
                                                <Typography id='eMed_Com_Patient_Name'>{data?.op_number ? data?.op_number?.length > 9 ? ('...' + data?.op_number.slice(10)) : data?.op_number : '-'}</Typography>
                                            </Tooltip> : <Typography id='eMed_Com_Patient_Name'>{data?.op_number ? data?.op_number : '-'}</Typography>}
                                    </Typography>
                                    :
                                    <Typography id='eMed_Com_Patient_Name'>
                                        {(data?.ip_number?.length > 15) || (data?.op_number?.length > 15) ?
                                            <Tooltip title={data?.ip_number ? data?.ip_number : data?.op_number} placement={'top'} arrow>
                                                <Typography id='eMed_Com_Patient_Name'>{data?.ip_number ? (data?.ip_number?.length > 9 ? ('...' + data?.ip_number.slice(10)) : data?.ip_number) : data?.op_number ? data?.op_number?.length > 9 ? ('...' + data?.op_number.slice(10)) : data?.op_number : '-'}</Typography>
                                            </Tooltip> : <Typography id='eMed_Com_Patient_Name'>{data?.ip_number ? data?.ip_number : data?.op_number ? data?.op_number : '-'}</Typography>}
                                    </Typography>
                                }
                                <Typography id='eMed_Com_Patient_UhidText'>{admission_date ? `| ${admission_date}` : '-'}</Typography>
                            </Box> : null}
                    </Box>
                    {
                        this.props.showTag === true ?
                            <Typography component={'div'}>
                                {data?.patient_tag_name?.length > 15 ?
                                    <Tooltip title={data?.patient_tag_name} placement={'top'} arrow>
                                        <Typography id='eMed_Com_Patient_UhidText' style={{ fontSize: '0.8vw', fontWeight: "bold", color: data?.patient_tag_color ? data?.patient_tag_color : "#000000" }}>{'Tag: ' + (data?.patient_tag_name ? data?.patient_tag_name.slice(0, 15) + '...' : '-')}</Typography>
                                    </Tooltip> : <Typography id='eMed_Com_Patient_UhidText' style={{ fontSize: '0.8vw', fontWeight: "bold", color: data?.patient_tag_color ? data?.patient_tag_color : "#000000" }}>{'Tag: ' + (data?.patient_tag_name ? data?.patient_tag_name : '-')}</Typography>}
                            </Typography> : null
                    }
                    {
                        this.props.showAdmission === true ?
                            <Typography component={'div'}>
                                {admissionDetails?.length > 15 ?
                                    <Tooltip title={admissionDetails} placement={'top'} arrow>
                                        <Typography id='eMed_Com_Patient_UhidText'>{this.props.showAproxDate ? `Approx.Admission:` : `Admission Date&Time: `}<span id='eMed_Com_Patient_admissionTxt'>{admissionDetails ? admissionDetails.slice(0, 13) + '...' : '-'}</span></Typography>
                                    </Tooltip> : <Typography id='eMed_Com_Patient_UhidText'>{this.props.showAproxDate ? `Approx.Admission:` : `Admission Date&Time: `}<span id='eMed_Com_Patient_admissionTxt'>{admissionDetails ? admissionDetails : '-'}</span></Typography>}
                            </Typography> : null
                    }
                    {
                        this.props.showAdmissionDateOnly === true ?
                            <Box component={'div'}>
                                <Typography id='eMed_Com_Patient_UhidText'>{this.props.showAproxDate ? `Approx.Admission:` : `Admission Date&Time: `}<span id='eMed_Com_Patient_admissionTxt'>{admission_date ? admission_date : '-'}</span></Typography>
                            </Box> : null
                    }
                    {
                        this.props.isFromOTList === true ?
                            <Typography component={'div'}>
                                {SurgeryDetails?.length > 15 ?
                                    <Tooltip title={SurgeryDetails} placement={'top'} arrow>
                                        <Typography id='eMed_Com_Patient_UhidText'>{`Surgery Date&Time: `}<span id='eMed_Com_Patient_admissionTxt'>{SurgeryDetails ? SurgeryDetails.slice(0, 13) + '...' : '-'}</span></Typography>
                                    </Tooltip> : <Typography id='eMed_Com_Patient_UhidText'>{`Surgery Date&Time: `}<span id='eMed_Com_Patient_admissionTxt'>{SurgeryDetails ? SurgeryDetails : '-'}</span></Typography>}
                            </Typography> : null
                    }
                </div>
            </div>
        )
    }
}
export class BasicPatientDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    render() {
        const { data } = this.props
        return (
            <div className="eMed_Com_Patient_Details">
                <div className="eMed_Com_Patient_Avatar">
                    <img className="eMed_Com_Patient_AvaIcon" style={{ borderColor: Colors.themeDark }}
                        src={data.photo_url === null || data.photo_url === "" ? ImagePaths.Male.default : data.photo_url} alt={'Avatar'} />
                </div>
                <div>
                    <Typography component={'div'}>
                        {data?.patient_name ? data?.patient_name?.length > 20 ?
                            <Tooltip placement='top' title={data?.patient_name} arrow>
                                <div>{data?.patient_name.slice(0, 20) + "..."}</div></Tooltip> :
                            data?.patient_name : "-"}
                    </Typography>
                    <Typography component={'div'}>
                        {data?.text ? data?.text?.length > 20 ?
                            <Tooltip placement='top' title={data?.text} arrow>
                                <div>{data?.text.slice(0, 20) + "..."}</div></Tooltip> :
                            data?.text : "-"}
                    </Typography>
                </div>
            </div>
        )
    }
}

export function StopWatch(props) {
    const [Start, setStart] = useState(false)
    const {
        seconds,
        minutes,
        hours,
        start,
        pause
    } = useStopwatch({ autoStart: true });
    return (
        <div>
            {props.data.status == "Arrived" && props.selected_id === props.data.id ?
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '100px' }}>
                        <p>{hours + ': ' + minutes + ': ' + seconds}</p>
                        {console.log(hours + ': ' + minutes + ': ' + seconds)}
                    </div>
                </div> : <p>{0 + ': ' + 0 + ': ' + 0}</p>}
        </div>
    )
}

export class ReasonPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dialogBox: true,
            comments: this.props.defaultComment || '',
            ReasonError: false,
            isBtnClked: false,
        }
    }

    closePopup = () => {
        this.props.AlertPopupClose();
    };

    // removeFunction = () => {
    //     this.props.removeData()
    // }

    render() {
        let testID = this.props.testID ? this.props.testID : "test";
        const is_cmt_mandatory = this.props.isCmtMandatory === false ? false : true;
        return (
            <Dialog
                open={this.state.dialogBox}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div className="eMed_DialogBox_Title" style={{ padding: '0.5vw', marginLeft: "1vw", marginTop: this.props.note ? '1vw' : '0vw' }}>
                    <div>
                        {this.props.title}
                    </div>
                    <div className="eMed_DialogBox_Close">
                        <img emed_tid={`rsn_${testID}_close`} className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={this.closePopup} />
                    </div>
                </div>
                <DialogContent sx={{ width: this.props.isConfigured ? '36vw' : this.props.note ? '31vw' : "30vw" }}>
                    {this.props.note ?
                        <Typography style={{ color: "red", fontSize: "0.85vw", fontWeight: 600, marginBottom: "0.5vw", marginTop: this.props.note ? "-1vw" : '0vw' }}>{this.props.subTitle} </Typography>
                        : null}
                    <TextField
                        sx={{ width: this.props.isConfigured ? '32.5vw' : this.props.note ? '27vw' : '26vw' }}
                        multiline
                        rows={3}
                        inputProps={{ maxLength: cmt_Char_limit, emed_tid: `rsn_${testID}_txt` }}
                        placeholder={this.props.label}
                        variant="outlined"
                        value={this.state.comments || ""}
                        onChange={(e) => {
                            this.setState({ comments: e.target.value, ReasonError: false })
                        }}
                        error={this.state.ReasonError}
                        helperText={this.state.ReasonError ? "Enter the Reason" : ""} />
                    {this?.props?.ErrorNotes ? <Typography sx={{ color: "red", margin: "0.3vw", fontSize: "0.9vw" }}>{this?.props?.ErrorNotes}</Typography> : null}
                    {this.props.DeleteNotify ?
                        <div className="eMed_DelCnf_msg">
                            <div className="eMed_DeletedPopup_bullet"></div>
                            <div className="eMed_Delcnf_txt" id="alert-dialog-description">
                                Remove
                            </div>
                            <div className="eMed_DeletedPopup_Border"></div>
                            <DialogContentText sx={{ fontSize: '0.6vw', marginLeft: '0.5vw', color: this.props.color }} id="alert-dialog-description">
                                {this.props.DeleteNotify}
                            </DialogContentText>
                        </div> : null}
                </DialogContent>
                <DialogActions id="eMed_DialogBox_Btn">
                    <Button emed_tid={`rsn_${testID}_${this.props.btntext}`} size="small" variant={this.props.btnvarient} id="eMed_Dia_Btn" color="error" onClick={this.closePopup}>
                        {this.props.btntext}
                    </Button>
                    <Button emed_tid={`rsn_${testID}_${this.props.btntext1}`} disabled={this.props.btntextDis || this.state.isBtnClked}
                        color={this.props.btncolor} size="small" variant={this.props.btnvarient1} id="eMed_Dia_Btn"
                        onClick={() => {
                            if (is_cmt_mandatory) {
                                if (CommonValidation.removeSpace(this.state.comments) !== "") {
                                    this.props.sendCmt(CommonValidation.removeSpace(this.state.comments))
                                } else {
                                    this.setState({ ReasonError: true })
                                }
                            } else {
                                this.setState({ isBtnClked: true })
                                this.props.sendCmt(CommonValidation.removeSpace(this.state.comments))
                            }
                        }}>
                        {this.props.btntext1}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export class ReasonPopupWithRefund extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dialogBox: true,
            comments: '',
            ReasonError: "",
            isCash: this.props?.paymentMode === 1 ? true : false,
            isUPI: this.props?.paymentMode === 3 ? true : false,
            isBankTranfer: this.props?.paymentMode === 5 ? true : false,
            CashAmount: this.props?.paymentMode === 1 ? this.props?.payableAmount : "",
            UPINumber: "",
            UPIAmount: this.props?.paymentMode === 3 ? this.props?.payableAmount : "",
            BankTfrAmount: this.props?.paymentMode === 5 ? this.props?.payableAmount : "",
            BankTfrNumber: "",
            totalPayableAmount: this.props?.payableAmount,
            receiptType: "Cancel",
            BtnDisable: false,
            SelectedCashCounter: null,
            cashCounterList : []
        }
    }

    componentDidMount(){
        if(this.props?.fromHospBilling && !CheckCashCounterAccess()){
            this.GetCorporateList()
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.enableBtnText1 && (prevProps.enableBtnText1 !== this.props.enableBtnText1)) {
            const newBtnDisableState = !(this.props.enableBtnText1 === "fail");

            if (this.state.BtnDisable !== newBtnDisableState) {
                this.setState({ BtnDisable: newBtnDisableState });
            }
        }
    }

    GetCorporateList() {
        try {
            RestAPIService.getAll(Serviceurls.CASH_COUNTER_MODULES_GET).
                then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            cashCounterList: response.data.data
                        })
                    }
                    else {
                        this.setState({
                            ReasonError: response.data.message
                        })
                    }
                }).catch((error) => {
                    this.setState({
                        ReasonError: error.message
                    })
                })
        }
        catch (error) {
            this.setState({
                ReasonError: error.message
            })
        }
    }

    closePopup = () => {
        this.props.AlertPopupClose();
    };

    renderAmountTextFields = (label, key, Icon) => {
        var states = this.state
        let { t } = this.props;
        return (
            <TextField
                sx={{ padding: 0, margin: 0, width: "10vw" }}
                className='eMed_CrdPop_Amount_TextFields'
                size='small'
                // disabled={this.state.forCancel}
                label={label}
                autoComplete='off'
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <img src={Icon} alt={label} className='eMed_action_img_small' />
                        </InputAdornment>
                    ),
                }}
                value={states[key]}
                onChange={(e) => {
                    let number = CommonValidation.NumberWithDot(e.target.value);
                    if ((number && +e.target.value > 0) || e.target.value === "") {
                        states[key] = e.target.value
                        this.setState({
                            states,
                            ReasonError: ""
                        })
                    }
                }}
            />
        )
    }

    renderNumberTextFields = (label, key, Right = false) => {
        var states = this.state
        let { t } = this.props;
        return (
            <TextField
                className='eMed_CrdPop_Amount_TextFields'
                sx={{ marginLeft: Right ? "1vw" : 0, width: "10vw" }}
                inputProps={{ maxLength: 20 }}
                // disabled={this.state.forCancel}
                size='small'
                label={label}
                value={states[key]}
                autoComplete='off'
                onChange={(e) => {
                    let number = CommonValidation.gstnumberValidation(e.target.value);
                    if (number || e.target.value === "") {
                        states[key] = e.target.value.toUpperCase()
                        this.setState({
                            states,
                            ReasonError: ""
                        })
                    }
                }}
            />
        )
    }

    handleCheckBox = (e, key) => {
        var states = this.state
        states[key] = e.target.checked
        this.setState({ states }, () => {
            if (!states.isCash) { this.setState({ CashAmount: "" }) }
            if (!states.isUPI) { this.setState({ UPIAmount: "", UPINumber: "" }) }
            if (!states.isBankTranfer) { this.setState({ BankTfrAmount: "", BankTfrNumber: "" }) }
            if (states.isCash && !states.isCard && !states.isUPI && !states.isBankTranfer) {
                this.setState({ CashAmount: this.state.totalPayableAmount, })  // Fetch Full amount in Cash Amount, when only the cash is selected
            }
        })
    }

    FullAmountEntered() {
        try {
            let states = this.state;
            let CashAmt = states.CashAmount === "" ? 0 : +states.CashAmount;
            let UPIAmt = states.UPIAmount === "" ? 0 : +states.UPIAmount;
            let bankTransferAmt = states.BankTfrAmount === "" ? 0 : +states.BankTfrAmount;
            if (((CashAmt + UPIAmt + bankTransferAmt) == +states.totalPayableAmount) || this.state.receiptType === "Advance") {
                if (
                    (states.UPINumber !== "" && states.UPINumber?.length < TXN_MSG_MAX_LEN) ||
                    (states.BankTfrNumber !== "" && states.BankTfrNumber?.length < TXN_MSG_MAX_LEN)
                ) {
                    this.setState({
                        BtnDisable: false,
                        ReasonError: TXN_MSG_MAX
                    })
                } else {
                    const isTxnValid = checkTransationMandatory()
                        ? (
                            (UPIAmt === 0 || states.UPINumber !== "") &&
                            (bankTransferAmt === 0 || states.BankTfrNumber !== "")
                        )
                        : true;
                    if (isTxnValid || this.state.receiptType === "Advance") {
                        if (this.props?.isForLab) {
                            this.props.cancelPost(this.state);
                        } else if (this.props?.fromHospBilling || this.props?.RevertFinal) {
                            this.props?.RefundPost(this.state);
                        } else {
                            this.props.IPRefundPost(this.state);
                        }
                    } else {
                        this.setState({
                            BtnDisable: false,
                            ReasonError: "Enter Transaction Details"
                        });
                    }
                }

                // if (
                //     ((UPIAmt === 0 || states.UPINumber !== "") &&
                //         (bankTransferAmt === 0 || states.BankTfrNumber !== "")) ||
                //     this.state.receiptType === "Advance"
                // ) {
                //     if (this.props?.isForLab) {
                //         this.props.cancelPost(this.state)
                //     } else if(this.props?.fromHospBilling){
                //         this.props?.RefundPost(this.state)
                //     }else {
                //         this.props.IPRefundPost(this.state)
                //     }
                // } else {
                //     this.setState({
                //         BtnDisable: false,
                //         ReasonError: "Enter Transaction Details"
                //     })
                // }
            } else if (
                (states.UPINumber !== "" && states.UPINumber?.length < TXN_MSG_MAX_LEN) ||
                (states.BankTfrNumber !== "" && states.BankTfrNumber?.length < TXN_MSG_MAX_LEN)
            ) {
                this.setState({
                    BtnDisable: false,
                    ReasonError: TXN_MSG_MAX
                })
            } else {
                this.setState({
                    BtnDisable: false,
                    ReasonError: "Amount Not Matched"
                })
            }
        }
        catch (e) {
            console.log(e?.message);
        }
    }

    render() {
        return (
            <Dialog
                open={this.state.dialogBox}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div className="eMed_DialogBox_Title" style={{ padding: '0.5vw' }}>
                    <Typography sx={{ fontSize: '1vw', fontWeight: "bold" }}>
                        {this.props.title}
                    </Typography>
                    <div className="eMed_DialogBox_Close">
                        <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={this.closePopup} />
                    </div>
                </div>
                <DialogContent sx={{ width: "30vw" }}>
                    {this.props?.AdjectedAdvance ?
                        <Box>
                            <Typography sx={{ fontSize:"0.9vw", color : Colors?.red}}>{`After revert, the available advance will be revised to ${AmountFormat(this.props?.AdjectedAdvance)}. `}</Typography>
                        </Box> : null}
                    {this.props?.payableAmount && this.props?.RevertFinal ?
                        <Box>
                            <Typography sx={{ fontSize:"0.9vw", color : Colors?.red}}>{`The paid amount of ${AmountFormat(this.props?.payableAmount)} needs to be refunded.`}</Typography>
                        </Box> : null}
                    {(this.props.BillReceivedAmount || this.props.fromHospBilling && this.props.payableAmount) ?
                        <RadioGroup
                            value={this.state.receiptType}
                            sx={{ display: 'flex', flexDirection: 'row', marginBottom: '1vw' }}
                            onChange={(e) => {
                                this.setState({ receiptType: e.target.value }, () => {
                                    if (this.state.receiptType === "Advance") {
                                        this.setState({
                                            isCash: false,
                                            isUPI: false,
                                            isBankTranfer: false,
                                            CashAmount: "",
                                            UPINumber: "",
                                            UPIAmount: "",
                                            BankTfrAmount: "",
                                            BankTfrNumber: "",
                                        })
                                    }
                                })
                            }}
                        >
                            <FormControlLabel value={'Cancel'} control={<Radio size='small' />} label="Cancel Receipt" />
                            <FormControlLabel value={"Refund"} control={<Radio size='small' />} label="Refund Receipt" />
                            {this.props?.ShowAdvance ? <FormControlLabel value={"Advance"} control={<Radio size='small' />} label="Add to Advance" /> : null}
                        </RadioGroup> : null
                    }
                    <TextField
                        sx={{ width: '26vw' }}
                        multiline
                        rows={3}
                        inputProps={{ maxLength: cmt_Char_limit }}
                        placeholder={this.props.label}
                        variant="outlined"
                        onChange={(e) => {
                            this.setState({ comments: e.target.value, ReasonError: "" })
                        }} />
                    {
                        ((this.props?.RevertFinal || this.props?.fromIP || this.props.isForLab || this.props?.fromReservation || (this.props?.fromHospBilling && CheckCashCounterAccess())) && this.state?.totalPayableAmount !== 0 && this.state.receiptType !== "Advance") ?
                            <Box component={'div'}>
                                <Typography fontSize={"0.9vw"} paddingY={"0.5vw"}>{this.state?.totalPayableAmount ? `Total Refundable Amount - ${AmountFormat(this.state?.totalPayableAmount || 0)}` : AmountFormat(0)}</Typography>
                                <Box ml={"0.5vw"} visibility={this.state.forCancel && this.state.totalPayableAmount === 0 ? 'hidden' : 'visible'}>
                                    <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' control={<Checkbox checked={this.state.isCash} onChange={(e) => { this.handleCheckBox(e, "isCash") }} size='small' />} label={"Cash"} />
                                    <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' control={<Checkbox checked={this.state.isUPI} onChange={(e) => { this.handleCheckBox(e, "isUPI") }} size='small' />} label={"UPI"} />
                                    <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' sx={{ width: "10vw" }} control={<Checkbox checked={this.state.isBankTranfer} onChange={(e) => { this.handleCheckBox(e, "isBankTranfer") }} size='small' />} label={"Bank Transfer"} />
                                </Box>

                                <Box component={'div'} display={'flex'} flexDirection={'column'} ml={'0.5vw'} overflow={'scroll'} mt={'-0.3vw'}>
                                    {
                                        this.state.isCash ?
                                            <Box component={"div"} display={"flex"} flexDirection={"row"} ml={"0.5vw"}>
                                                {this.renderAmountTextFields("CashAmount", "CashAmount", ImagePaths.CashIcon.default)}
                                            </Box> : null
                                    }
                                    {
                                        this.state.isUPI ?
                                            <Box component={"div"} display={"flex"} flexDirection={"row"} ml={"0.5vw"}>
                                                {this.renderAmountTextFields("UPIAmount", "UPIAmount", ImagePaths.UPIIcon.default)}
                                                {this.renderNumberTextFields("UPITransactionNumber", "UPINumber", true)}
                                            </Box>
                                            : null
                                    }
                                    {
                                        this.state.isBankTranfer ?
                                            <Box component={"div"} display={"flex"} flexDirection={"row"} ml={"0.5vw"}>
                                                {this.renderAmountTextFields("BankTransferAmount", "BankTfrAmount", ImagePaths.BankTransferIcon.default)}
                                                {this.renderNumberTextFields("BankTransactionNumber", "BankTfrNumber", true)}
                                            </Box>
                                            : null
                                    }
                                </Box>
                            </Box> :
                            (this.props?.fromHospBilling && !CheckCashCounterAccess() && this.state?.totalPayableAmount !== 0) ?
                                <Box>
                                    <FormControl size='small' style={{ width: '26dvw', marginTop : "2dvh" }}>
                                        <InputLabel id="Dis_lay_Diet">{"Cash Counter to Process Refund Request"}</InputLabel>
                                        <Select
                                            value={this.state.SelectedCashCounter ? this.state.SelectedCashCounter : ""}
                                            label={"Cash Counter to Process Refund Request"}
                                            onChange={(event) => {
                                                let values = event.target.value;
                                                this.setState({
                                                    SelectedCashCounter: values,
                                                })
                                            }}
                                        >
                                            {this.state.cashCounterList?.length > 0 ? this.state.cashCounterList.map((item, index) => {
                                                return <MenuItem key={index} value={item}>{item}</MenuItem>
                                            }) : null}
                                        </Select>
                                    </FormControl>
                                </Box> : null
                    }
                    <Box height={'1vw'} marginTop={'0.5vw'} width={'100%'} textAlign={'center'}>
                        <Typography color={'red'} fontSize={'0.8vw'}>{this.state.ReasonError !== "" ? this.state.ReasonError : ""}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions id="eMed_DialogBox_Btn">
                    <Button size="small" variant={this.props.btnvarient} id="eMed_Dia_Btn" color="error" onClick={this.closePopup}>
                        {this.props.btntext}
                    </Button>
                    <Button color={this.props.btncolor} size="small" variant={this.props.btnvarient1} id="eMed_Dia_Btn" disabled={this.state.BtnDisable} onClick={() => {
                        if (CommonValidation.removeSpace(this.state.comments) !== "") {
                            this.setState({
                                BtnDisable: true
                            }, () => {
                                if (this.props?.fromIP || this.props?.isForLab || this.props?.fromReservation  || this.props?.RevertFinal) {
                                    this.FullAmountEntered()
                                } else if (this.props?.fromHospBilling) {
                                    if (CheckCashCounterAccess()) {
                                        this.FullAmountEntered()
                                    } else {
                                        this.props?.RefundPost(this.state)
                                    }
                                } else {
                                    this.props.sendCmt(CommonValidation.removeSpace(this.state.comments), this.state.receiptType)
                                }
                            })

                        } else {
                            this.setState({ ReasonError: this.props?.ReasonError ? this.props?.ReasonError : (this.props?.RevertFinal ? "Enter reason for revert" : "Enter reason for cancel") })
                        }

                    }}>
                        {this.props.btntext1}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export class PharmacyReturnPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dialogBox: true,
            comments: '',
            ReasonError: "",
            isCash: false,
            isUPI: false,
            isBankTranfer: false,
            CashAmount: "",
            UPINumber: "",
            UPIAmount: "",
            BankTfrAmount: "",
            BankTfrNumber: "",
            returnType: 0,
            refundAmt: 0,
            AdvanceAmt: 0,
            returnAmt: this.props.returnAmt,
            paidAmt: this.props.paidAmt,
            outstandingAmt: this.props.outstandingAmt,
            isCurrentIP: this.props.isCurrentIP,
            SelectedCashCounter: null,
            cashCounterList : [],
            AdvanceRemainAmt: this.props.AdvanceRemainAmt,
            condition : this.props?.condition
        }
    }

    componentDidMount() {
        if (!CheckCashCounterAccess()) {
            this.getCashCounterList()
        }
    }

    getCashCounterList() {
        try {
            RestAPIService.getAll(Serviceurls.CASH_COUNTER_MODULES_GET).
                then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            cashCounterList: response.data.data
                        })
                    }
                    else {
                        this.setState({
                            ReasonError: response.data.message
                        })
                    }
                }).catch((error) => {
                    this.setState({
                        ReasonError: error.message
                    })
                })
        }
        catch (error) {
            this.setState({
                ReasonError: error.message
            })
        }
    }

    closePopup = () => {
        this.props.AlertPopupClose();
    };

    renderAmountTextFields = (label, key, Icon) => {
        var states = this.state
        let { t } = this.props;
        return (
            <TextField
                sx={{ padding: 0, margin: 0, width: "10vw" }}
                className='eMed_CrdPop_Amount_TextFields'
                size='small'
                label={label}
                autoComplete='off'
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <img src={Icon} alt={label} className='eMed_action_img_small' />
                        </InputAdornment>
                    ),
                }}
                value={states[key]}
                onChange={(e) => {
                    let number = CommonValidation.NumberWithDot(e.target.value);
                    if ((number && +e.target.value > 0) || e.target.value === "") {
                        states[key] = e.target.value
                        this.setState({
                            states,
                            ReasonError: ""
                        })
                    }
                }}
            />
        )
    }

    renderNumberTextFields = (label, key, Right = false) => {
        var states = this.state
        let { t } = this.props;
        return (
            <TextField
                className='eMed_CrdPop_Amount_TextFields'
                sx={{ marginLeft: Right ? "1vw" : 0, width: "10vw" }}
                inputProps={{ maxLength: 20 }}
                size='small'
                label={label}
                value={states[key]}
                autoComplete='off'
                onChange={(e) => {
                    let number = CommonValidation.gstnumberValidation(e.target.value);
                    if (number || e.target.value === "") {
                        states[key] = e.target.value.toUpperCase()
                        this.setState({
                            states,
                            ReasonError: ""
                        })
                    }
                }}
            />
        )
    }

    handleCheckBox = (e, key) => {
        var states = this.state
        states[key] = e.target.checked
        this.setState({ states }, () => {
            if (!states.isCash) { this.setState({ CashAmount: "" }) }
            if (!states.isUPI) { this.setState({ UPIAmount: "", UPINumber: "" }) }
            if (!states.isBankTranfer) { this.setState({ BankTfrAmount: "", BankTfrNumber: "" }) }
            if (states.isCash && !states.isCard && !states.isUPI && !states.isBankTranfer) {
                this.setState({ CashAmount: this.state.refundAmt, })  // Fetch Full amount in Cash Amount, when only the cash is selected
            }
        })
    }

    FullAmountEntered() {
        try {
            if (CheckCashCounterAccess()) {
                let states = this.state;
                let CashAmt = states.CashAmount === "" ? 0 : +states.CashAmount;
                let UPIAmt = states.UPIAmount === "" ? 0 : +states.UPIAmount;
                let bankTransferAmt = states.BankTfrAmount === "" ? 0 : +states.BankTfrAmount;
                if (((CashAmt + UPIAmt + bankTransferAmt) == +states.refundAmt) || states.AdvanceAmt) {
                    if (checkTransationMandatory() &&
                        ((states.UPIAmount !== "" && states.UPINumber === '') ||
                        (states.BankTfrAmount !== "" && states.BankTfrNumber === ""))
                    ) {
                        this.setState({
                            ReasonError: "Enter Transaction Details"
                        })
                    } else if ((states.UPINumber !== "" && states.UPINumber?.length < TXN_MSG_MAX_LEN) ||
                        (states.BankTfrNumber !== "" && states.BankTfrNumber?.length < TXN_MSG_MAX_LEN)
                    ) {
                        this.setState({ ReasonError: TXN_MSG_MAX })
                    } else {
                        this.props.PharmaReturnData(this.state)
                    }
                    // const isTxnValid = checkTransationMandatory() ?
                    //     (
                    //         (UPIAmt === 0 || states.UPINumber !== "") &&
                    //         (bankTransferAmt === 0 || states.BankTfrNumber !== "")
                    //     ) : true
                    // if (isTxnValid) {
                    //     if (
                    //         (states.UPINumber !== "" && states.UPINumber?.length < TXN_MSG_MAX_LEN) ||
                    //         (states.BankTfrNumber !== "" && states.BankTfrNumber?.length < TXN_MSG_MAX_LEN)
                    //     ) {
                    //         this.setState({ ReasonError: TXN_MSG_MAX })
                    //     } else {
                    //         this.props.PharmaReturnData(this.state)
                        // }

                        // if (
                        //     (UPIAmt === 0 || states.UPINumber !== "") &&
                        //     (bankTransferAmt === 0 || states.BankTfrNumber !== "")
                        // ) {
                        //     this.props.PharmaReturnData(this.state)
                        // } else {
                        //     this.setState({
                        //         ReasonError: "Enter Transaction Details"
                        //     })
                        // }
                    // }
                }
                else {
                    this.setState({
                        ReasonError: "Amount Not Matched"
                    })
                }
            } else {
                this.props.PharmaReturnData(this.state)
            }
        }
        catch (e) {
            console.log(e?.message);
        }
    }

    render() {
        var { returnAmt, outstandingAmt, paidAmt, isCurrentIP, AdvanceRemainAmt } = this.state
        let returnOptions = []
        if (this.props.condition == 1) {
            returnOptions = [
                { Value: 1, Label: "₹" + returnAmt + " to be Refunded", Refund: returnAmt, Advance: 0 },
                { Value: 2, Label: "₹" + returnAmt + " to be reduced from Outstanding" + " ( ₹" + outstandingAmt + " )", Refund: 0, Advance: 0 },
            ]
            if(localGetItem('isNewBilling') === 'false'){
                if (isCurrentIP) {
                    returnOptions.push(
                        { Value: 3, Label: "₹" + returnAmt + " to be added with IP Advance", Refund: 0, Advance: returnAmt }
                    )
                }
            }
        } else if (this.props.condition == 2) {
            returnOptions = [
                { Value: 1, Label: "₹" + returnAmt + " to be Refunded", Refund: returnAmt, Advance: 0 },
                { Value: 2, Label: "₹" + (returnAmt - outstandingAmt) + " to be refunded & " + "₹" + outstandingAmt + " to be reduced from Outstanding" + " ( ₹" + outstandingAmt + " )", Refund: (returnAmt - outstandingAmt), Advance: 0 },
            ]
            if(localGetItem('isNewBilling') === 'false'){
                if (isCurrentIP) {
                    returnOptions.push(
                        { Value: 3, Label: "₹" + returnAmt + " to be added with IP Advance", Refund: 0, Advance: returnAmt },
                        { Value: 4, Label: "₹" + (returnAmt - outstandingAmt) + " to be added with IP Advance & " + "₹" + outstandingAmt + " to be reduced from Outstanding" + " ( ₹" + outstandingAmt + " )", Refund: 0, Advance: (returnAmt - outstandingAmt) },
                    )
                }
            }
        } else if (this.props.condition == 3) {
            returnOptions = [
                { Value: 1, Label: "₹" + paidAmt + " to be refunded & " + "₹" + (returnAmt - paidAmt) + " to be reduced from Outstanding" + " ( ₹" + outstandingAmt + " )", Refund: paidAmt, Advance: 0 },
                { Value: 2, Label: "₹" + (returnAmt - outstandingAmt) + " to be refunded & " + "₹" + outstandingAmt + " to be reduced from Outstanding" + " ( ₹" + outstandingAmt + " )", Refund: (returnAmt - outstandingAmt), Advance: 0 },
            ]
            if(localGetItem('isNewBilling') === 'false'){
                if (isCurrentIP) {
                    returnOptions.push(
                        { Value: 3, Label: "₹" + paidAmt + " to be added with IP Advance & " + "₹" + (returnAmt - paidAmt) + " to be reduced from Outstanding" + " ( ₹" + outstandingAmt + " )", Refund: 0, Advance: paidAmt },
                        { Value: 4, Label: "₹" + (returnAmt - outstandingAmt) + " to be added with IP Advance & " + "₹" + outstandingAmt + " to be reduced from Outstanding" + " ( ₹" + outstandingAmt + " )", Refund: 0, Advance: (returnAmt - outstandingAmt) },
                    )
                }
            }
        } else if (this.props.condition == 4) {
            returnOptions = [
                { Value: 1, Label: "₹" + returnAmt + " to be reduced from Outstanding" + " ( ₹" + outstandingAmt + " )", Refund: 0, Advance: 0 },
                { Value: 2, Label: "₹" + paidAmt + " to be refunded & " + "₹" + (returnAmt - paidAmt) + " to be reduced from Outstanding" + " ( ₹" + outstandingAmt + " )", Refund: paidAmt, Advance: 0 },
            ]
            if(localGetItem('isNewBilling') === 'false'){
                if (isCurrentIP) {
                    returnOptions.push(
                        { Value: 3, Label: "₹" + paidAmt + " to be added with IP Advance & " + "₹" + (returnAmt - paidAmt) + " to be reduced from Outstanding" + " ( ₹" + outstandingAmt + " )", Refund: 0, Advance: paidAmt },
                    )
                }
            }
        } else if(this.props.condition === 5){
            returnOptions = [
                { Value: 1, Label: "₹" + returnAmt + " to be refunded", Refund: returnAmt, Advance: 0 },
            ]
        } else if (this.props.condition === 6) {
            returnOptions = [
                { Value: 1, Label: 'Are you Sure ?.Do you need to return ?', Refund: 0, Advance: 0 },
            ]
        } else if (this.props.condition === 7) {
            if (returnAmt <= paidAmt) {
                returnOptions.push({
                    Value: 1,
                    Label: `₹${returnAmt} to be added to Advance`,
                    Refund: 0,
                    Advance: returnAmt
                });

                if (outstandingAmt > 0 && returnAmt <= outstandingAmt) {
                    returnOptions.push({
                        Value: 2,
                        Label: `₹${returnAmt} to be reduced from Outstanding (₹${outstandingAmt})`,
                        Refund: 0,
                        Advance: 0,
                        Outstanding: returnAmt
                    });
                }

            } else {
                const advancePart = paidAmt;
                const outstandingPart = returnAmt - paidAmt;

                returnOptions.push({
                    Value: 1,
                    Label: `₹${advancePart} to be added to Advance & ₹${outstandingPart} to be reduced from Outstanding (₹${outstandingAmt})`,
                    Refund: 0,
                    Advance: advancePart,
                    Outstanding: outstandingPart
                });

                if (outstandingAmt > 0 && returnAmt <= outstandingAmt) {
                    returnOptions.push({
                        Value: 2,
                        Label: `₹${returnAmt} to be reduced from Outstanding (₹${outstandingAmt})`,
                        Refund: 0,
                        Advance: 0,
                        Outstanding: returnAmt
                    });
                }
            }
        } else if (this.props.condition === 8) {
            let NetPaid = ((paidAmt - AdvanceRemainAmt) || paidAmt);
            if (returnAmt <= (paidAmt + outstandingAmt)) {

                // --- Option A: Pure Refund (if returnAmt <= paidAmt) ---
                if (returnAmt <= NetPaid) {
                    returnOptions.push({
                        Value: 1,
                        Label: `₹${returnAmt} to be refunded`,
                        Refund: returnAmt,
                        Advance: 0,
                        Outstanding: 0
                    });
                }

                // --- Option B: Pure Advance (if returnAmt <= AdvanceRemainAmt) ---
                if (returnAmt <= AdvanceRemainAmt) {
                    returnOptions.push({
                        Value: 2,
                        Label: `₹${returnAmt} to be added to Advance`,
                        Refund: 0,
                        Advance: returnAmt,
                        Outstanding: 0
                    });
                }

                // --- Option C: Pure Outstanding (if returnAmt <= outstandingAmt) ---
                if (returnAmt <= outstandingAmt) {
                    returnOptions.push({
                        Value: 3,
                        Label: `₹${returnAmt} to be reduced from Outstanding`,
                        Refund: 0,
                        Advance: 0,
                        Outstanding: returnAmt
                    });
                }

                // --- Option D: Refund + Advance (when returnAmt > AdvanceRemainAmt but <= paidAmt) ---
                if (returnAmt > AdvanceRemainAmt && returnAmt <= paidAmt) {
                    let advPart = AdvanceRemainAmt;
                    let refundPart = returnAmt - advPart;

                    returnOptions.push({
                        Value: 4,
                        Label: `₹${advPart} to be added to Advance & ₹${refundPart} to be refunded`,
                        Refund: refundPart,
                        Advance: advPart,
                        Outstanding: 0
                    });
                }

                // --- Option E: Outstanding + Advance (when returnAmt > AdvanceRemainAmt and within outstanding + advance) ---
                if (returnAmt > AdvanceRemainAmt && returnAmt <= (AdvanceRemainAmt + outstandingAmt)) {
                    let advPart = AdvanceRemainAmt;
                    let outPart = returnAmt - advPart;

                    returnOptions.push({
                        Value: 5,
                        Label: `₹${outPart} to be reduced from Outstanding & ₹${advPart} to be added to Advance`,
                        Refund: 0,
                        Advance: advPart,
                        Outstanding: outPart
                    });
                }

                // --- Option F: Refund + Advance + Outstanding (when returnAmt > paidAmt) ---
                if (returnAmt > paidAmt) {
                    let advPart = AdvanceRemainAmt;
                    let refundPart = paidAmt - advPart >= 0 ? paidAmt - advPart : 0;
                    let outPart = returnAmt - (refundPart + advPart);

                    if (outPart <= outstandingAmt) {
                        let labelParts = [];
                        if (refundPart > 0) labelParts.push(`₹${refundPart} to be refunded`);
                        if (advPart > 0) labelParts.push(`₹${advPart} to be added to Advance`);
                        if (outPart > 0) labelParts.push(`₹${outPart} to be reduced from Outstanding`);

                        returnOptions.push({
                            Value: 6,
                            Label: labelParts.join(" & "),
                            Refund: refundPart,
                            Advance: advPart,
                            Outstanding: outPart
                        });
                    }
                }
            }
            returnOptions = returnOptions.filter(opt =>
                (opt.Refund + opt.Advance + opt.Outstanding) === returnAmt
            );
        }
        let cashcounterAccess = CheckCashCounterAccess();
        const disableCnfrmBtn = (this.state.refundAmt && this.props.condition !== 7 && localGetItem('isNewBilling') === 'true' && !this.state.SelectedCashCounter && cashcounterAccess === false);
        return (
            <Dialog
                open={this.state.dialogBox}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div className="eMed_DialogBox_Title" style={{ padding: '0.5vw' }}>
                    <Typography sx={{ fontSize: '1vw', fontWeight: "bold" }}>
                        {this.props.title}
                    </Typography>
                    <div className="eMed_DialogBox_Close">
                        <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={this.closePopup} />
                    </div>
                </div>
                <DialogContent sx={{ width: "30vw" }}>
                    {this.props.condition === 6 ? 
                    <Box>
                        <Typography fontSize={'1rem'} fontWeight={600} color={Colors.red}>Are you sure.Do you need to Return ?</Typography>
                    </Box> : 
                    <RadioGroup
                        value={this.state.returnType}
                        sx={{ display: 'flex', flexDirection: 'column', marginBottom: '0.5vw' }}
                        onChange={(e) => {
                            let refundObj = returnOptions.find(li => li.Value == (e.target.value))
                            this.setState({
                                returnType: +(e.target.value),
                                refundAmt: refundObj.Refund,
                                isCash: false,
                                isUPI: false,
                                isBankTranfer: false,
                                CashAmount: "",
                                UPINumber: "",
                                UPIAmount: "",
                                BankTfrAmount: "",
                                BankTfrNumber: "",
                                AdvanceAmt: refundObj.Advance
                            })
                        }}
                    >
                        {returnOptions.map((item) => (
                            <FormControlLabel value={item.Value} control={<Radio size='small' />} label={item.Label} />
                        ))}
                    </RadioGroup>}

                    {(this.state.refundAmt && this.props.condition !== 7) ?
                        CheckCashCounterAccess() || (localGetItem('isNewBilling') === 'false') ?
                            <Box component={'div'}>
                                <Box ml={"0.5vw"} >
                                    <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' control={<Checkbox checked={this.state.isCash} onChange={(e) => { this.handleCheckBox(e, "isCash") }} size='small' />} label={"Cash"} />
                                    <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' control={<Checkbox checked={this.state.isUPI} onChange={(e) => { this.handleCheckBox(e, "isUPI") }} size='small' />} label={"UPI"} />
                                    <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' sx={{ width: "10vw" }} control={<Checkbox checked={this.state.isBankTranfer} onChange={(e) => { this.handleCheckBox(e, "isBankTranfer") }} size='small' />} label={"Bank Transfer"} />
                                </Box>

                                <Box component={'div'} display={'flex'} flexDirection={'column'} ml={'0.5vw'} overflow={'scroll'} mt={'-0.3vw'}>
                                    {
                                        this.state.isCash ?
                                            <Box component={"div"} display={"flex"} flexDirection={"row"} ml={"0.5vw"}>
                                                {this.renderAmountTextFields("CashAmount", "CashAmount", ImagePaths.CashIcon.default)}
                                            </Box> : null
                                    }
                                    {
                                        this.state.isUPI ?
                                            <Box component={"div"} display={"flex"} flexDirection={"row"} ml={"0.5vw"}>
                                                {this.renderAmountTextFields("UPIAmount", "UPIAmount", ImagePaths.UPIIcon.default)}
                                                {this.renderNumberTextFields("UPITransactionNumber", "UPINumber", true)}
                                            </Box>
                                            : null
                                    }
                                    {
                                        this.state.isBankTranfer ?
                                            <Box component={"div"} display={"flex"} flexDirection={"row"} ml={"0.5vw"}>
                                                {this.renderAmountTextFields("BankTransferAmount", "BankTfrAmount", ImagePaths.BankTransferIcon.default)}
                                                {this.renderNumberTextFields("BankTransactionNumber", "BankTfrNumber", true)}
                                            </Box>
                                            : null
                                    }
                                </Box>
                            </Box> : 
                            <Box>
                                <FormControl size='small' style={{ width: '26dvw', marginTop: "2dvh" }}>
                                    <InputLabel id="Dis_lay_Diet">{"Cash Counter to Process Refund Request"}</InputLabel>
                                    <Select
                                        value={this.state.SelectedCashCounter ? this.state.SelectedCashCounter : ""}
                                        label={"Cash Counter to Process Refund Request"}
                                        onChange={(event) => {
                                            let values = event.target.value;
                                            this.setState({
                                                SelectedCashCounter: values,
                                            })
                                        }}
                                    >
                                        {this.state.cashCounterList?.length > 0 ? this.state.cashCounterList.map((item, index) => {
                                            return <MenuItem key={index} value={item}>{item}</MenuItem>
                                        }) : null}
                                    </Select>
                                </FormControl>
                            </Box> : null    
                    }
                    <Box height={'1vw'} marginTop={'0.5vw'} width={'100%'} textAlign={'center'}>
                        <Typography color={'red'} fontSize={'0.8vw'}>{this.state.ReasonError !== "" ? this.state.ReasonError : ""}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions id="eMed_DialogBox_Btn">
                    <Button size="small" variant={this.props.btnvarient} id="eMed_Dia_Btn" color="error" onClick={this.closePopup}>
                        {this.props.btntext}
                    </Button>
                    <Button color={this.props.btncolor} size="small" disabled={disableCnfrmBtn || !this.state.returnType} variant={this.props.btnvarient1} id="eMed_Dia_Btn" onClick={() => {
                        this.FullAmountEntered()
                    }}>
                        {this.props.btntext1}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export class CommonPatientCard extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        const { details } = this.props
        return (
            <Box className="eMed_Patient_Card" sx={{
                width: this.props.width ? this.props.width :
                    this.props.showDetailed === true ? '23vw' :
                        this.props?.smallWidth ? "10.5vw" : "14.5vw"
            }}
                emed_tid={details.lineOne}>
                <Box component={'div'} className='eMed_patient_image'>
                    <img style={{ width: details.width ? details.width : "3vw", height: details.height ? details.height : "3vw" }} src={details.image ? details.image : ImagePaths.Male.default} alt="male" />
                </Box>
                <Box component={'div'} className="eMed_Pateint_Detail_LongData">
                    <Box component={'div'} className='eMed_patient_txt' >
                        <Typography fontSize={"0.7vw"}>{details.lineOne}</Typography>
                        {details.lineTwo.length > (this.props.toolLen || 25) ?
                            <Tooltip title={details.lineTwo} placement='top' arrow>
                                <Typography fontSize={details.lineTwo.length > 30 ? "0.7vw" : "0.9vw"} sx={{ color: details.colorCode, marginTop: details.lineThree ? "-0.22vw" : '0' }} fontWeight={600}>{details.lineTwo ? details.lineTwo.slice(0, (this.props.toolLen || 27)) + '...' : '-'}</Typography>
                            </Tooltip>
                            : <Typography fontSize={details.lineTwo.length > 25 ? "0.7vw" : "0.9vw"} sx={{ color: details.colorCode, marginTop: details.lineThree ? "-0.22vw" : '0' }} fontWeight={600}>{details.lineTwo}</Typography>}
                        <Typography fontSize={"0.6vw"} sx={{ color: details.colorCode, marginTop:"-0.22vw" }} fontWeight={600}>{details.lineThree}</Typography>
                    </Box>
                    {this.props.showOnecard === true ?
                        <Box>
                            <Typography fontSize={"0.7vw"}>{details.secHead}</Typography>
                            <Typography fontSize={"0.8vw"} fontWeight={600}>{details.secAmt}</Typography></Box> : null}
                    {this.props.showDetailed === true ?
                        <Box component={'div'} className='eMed_patient_txt'>
                            <Typography fontSize={"0.7vw"}>{details.lineFour}</Typography>
                            <Typography fontSize={"0.9vw"} fontWeight={600}>{details.LineFive}</Typography>
                        </Box> : null}
                </Box>
                {
                    this.props.ShowCross === true ? <IconButton onClick={() => { this.props.onClick() }}><CloseIcon color="error" /></IconButton> : null
                }
            </Box>
        )
    }
}

export class ConsultantPatientCard extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        const { name, width } = this.props
        return (
            <Box className="eMed_Patient_Card" sx={{ width: width ? width : '25dvw' }}>
                <Box component={'div'} className='eMed_patient_image'>
                    <img style={{ width: name.width ? name.width : "3vw", height: name.height ? name.height : "3vw" }} src={name.image ? name.image : ImagePaths.Male.default} alt="male" />
                </Box>
                <Box component={'div'} className="eMed_Pateint_Detail_LenthData">
                    <Box component={'div'} className='eMed_patient_txt'>
                        <Typography fontSize={"0.7vw"}>{name.lineOne}</Typography>
                        {(this.props.showTooltip && name.lineTwo.length > 30) ?
                            <Tooltip title={name.lineTwo} placement='top' arrow>
                                <Typography fontSize={name.lineTwo.length > 25 ? "0.7vw" : "0.9vw"} sx={{ color: name.colorCode }} fontWeight={600}>{name.lineTwo ? name.lineTwo.slice(0, 30) + '...' : '-'}</Typography>
                            </Tooltip>
                            : <Typography fontSize={name.lineTwo.length > 25 ? "0.7vw" : "0.9vw"} sx={{ color: name.colorCode }} fontWeight={600}>{name.lineTwo}</Typography>
                        }
                    </Box>
                </Box>
                {
                    this.props.ShowCross === true ? <IconButton onClick={() => { this.props.onClick() }}><CloseIcon color="error" /></IconButton> : null
                }
            </Box>
        )
    }
}

export class CommonImgPreviewPop extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        const { details } = this.props
        return (
            <Modal open={true}>
                <Box className="eMed_ImgPreviewPop_Main">
                    <Box component={'div'} className="eMed_ImgPreviewPop_Header">
                        <Typography variant='h6'>{this.props?.title ? this.props?.title : "Image Preview"}</Typography>
                        <Button onClick={() => { this.props.PopClose() }} >

                            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                        </Button>
                    </Box>
                    <Box component={'div'} className="eMed_ImgPreviewPop_Img_wrapper">
                        {
                            <img src={this.props.src} className="eMed_ImgPreviewPop_img" alt="uploadedimg" />
                        }
                    </Box>
                </Box>
            </Modal>
        )
    }
}

export class ConfirmPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            cnfDialog: true,
            disableBtn: false,
            copiedField: null,
        }
    }

    handleCopy = (text, field) => {
        navigator.clipboard.writeText(text).then(() => {
            this.setState({ copiedField: field });
            setTimeout(() => {
                this.setState({ copiedField: null });
            }, 2000);
        })
    }

    handleClose = () => {
        this.setState({ disableBtn: false })
        this.props.cnfAlertPopupClose();
    };

    saveData = () => {
        this.props.cnfData()
        setTimeout(() => {
            this.setState({ disableBtn: false })
        }, 1500);
    }

    render() {
        let { cnfAbhaRegister } = this.props
        const rows = [
            { label: 'UHID', value: cnfAbhaRegister?.uhid },
            { label: 'Mobile No', value: cnfAbhaRegister?.mobile },
            { label: 'ABHA Address', value: cnfAbhaRegister?.abha_address },
            { label: 'ABHA No', value: cnfAbhaRegister?.abha_id },
          ];
        return (
            <Dialog
                open={this.state.cnfDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <Box component={'div'} className="eMed_cnf_Box">
                    <DialogTitle id="alert-dialog-title">
                        {this.props.cnfTitle ? this.props.cnfTitle : '-'}
                    </DialogTitle>
                    <Box component={'div'} className="eMed_cnf_BtnGr">
                        {this.props.btn1Hide ? null : <IconButton onClick={this.handleClose}>
                            <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' />
                        </IconButton>}
                    </Box>
                </Box>
                <DialogContent dividers sx={{ width: { xs: '90vw', sm: '60vw', md: '40vw' }, maxWidth: '600px'}}>
                    {this.props.showDateTimeError ?
                        <DialogContentText sx={{ fontSize: '1vw', color: 'red' }} id="alert-dialog-description">
                            {"Do you want to continue without discharge date and time ?"}
                        </DialogContentText> : this.props.cnfContent ?
                            <DialogContentText fontWeight={this.props.contentBold} color={'#7a7676'} id="alert-dialog-description">
                                {this.props.cnfContent ? this.props.cnfContent : '-'}
                            </DialogContentText> : null}
                    {this.props.cnfContent1 ?
                        <DialogContentText sx={{ fontSize: '0.9vw', color: '#7a7676' }} id="alert-dialog-description">
                            {this.props.cnfContent1 ? this.props.cnfContent1 : '-'}
                        </DialogContentText> : null}
                    {this.props.cnfAbhaRegister && (
                        <Box sx={{ fontSize: '0.9vw', color: '#7a7676' }}>
                            {rows.map((row, idx) => (
                                <Grid container key={idx} spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                    <Grid item xs={4} sm={3}>
                                        <Typography sx={{ fontWeight: 500 }}>{row.label}</Typography>
                                    </Grid>

                                    <Grid item xs={1}>
                                        <Typography>:</Typography>
                                    </Grid>

                                    <Grid item xs={6} sm={7}>
                                        <Typography sx={{ fontWeight: 600 }}>{row.value}</Typography>
                                    </Grid>

                                    <Grid item xs={1} sm={1}>
                                        <Tooltip title={this.state.copiedField === row.label ? "Copied!" : "Copy"}>
                                            <IconButton
                                                onClick={() => this.handleCopy(row.value, row.label)}
                                                color="primary"
                                                size="small"
                                            >
                                                <ContentCopyIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            ))}
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    {this.props.btn1Hide ? null : <Button variant="outlined" color={this.props.btnType} sx={{ textTransform: 'capitalize' }} onClick={this.handleClose}>{this.props.btnText1 ? this.props.btnText1 : 'Cancel'}</Button>}
                    {this.props.btn2Hide ? null : <Button variant="contained" sx={{ textTransform: 'capitalize' }} disabled={this.props?.cnfDisable ? this.props?.cnfDisable : this.state.disableBtn} onClick={() => { this.setState({ disableBtn: true }, () => this.saveData()) }}>{this.props.btnText2 ? this.props.btnText2 : 'Confirm'}</Button>}
                </DialogActions>
            </Dialog>
        )
    }
}
export class PharmaDiscardPop extends Component {
    constructor(props) {
        super(props)
        this.state = {
            OpenModel: true
        }
    }
    render() {
        return (
            <Dialog
                open={this.state.OpenModel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent dividers sx={{ width: '25vw', height: '5vw' }}>
                    <DialogContentText id="alert-dialog-description" sx={{ fontWeight: 'bold' }}>
                        Are You Sure to Discard the Bill data?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button size="small" variant="outlined" onClick={() => {
                        this.setState({ OpenModel: false }, () => { this.props.SendAction(false) })
                    }}>No</Button>
                    <Button size="small" variant="contained" onClick={() => this.props.SendAction(true, this.props?.IncomingLineItem)}>Yes</Button>
                </DialogActions>
            </Dialog>
        )
    }
}
export class BillSuccessPoPUp extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isPrintClick: false,
            allowSms: false,
            isIssueDrug: false,
            whatsappConfig: false,
            isWhatsAppText: '',
            allowWhatsapp: false,
            WhatsappDis: false,
            smsDis: false,
        }
    }

    componentDidMount = () => {
        let smsConfig = JSON.parse(localGetItem("smsConfig"))
        let allowSms = false
        let allowWhatsapp = false
        const UserData = JSON.parse(localGetItem('loggedInUserInfo'))
        if (this.props.isFromOP && !this.props.isCredit) { allowSms = smsConfig?.op_bill_sms; allowWhatsapp = UserData?.whatsapp_config?.op_invoice }
        else if (this.props.isFromsmsIP) { allowSms = smsConfig?.ip_bill_sms; allowWhatsapp = UserData?.whatsapp_config?.ip_invoice }
        else if (this.props.isFromPharmacy && !this.props.isCredit) { allowSms = smsConfig?.pharmacy_bill_sms; allowWhatsapp = UserData?.whatsapp_config?.pharmacy_invoice }
        else if (this.props?.isFromLab && !this.props.isCredit) { allowSms = smsConfig?.lab_bill_sms; allowWhatsapp = UserData?.whatsapp_config?.lab_invoice }
        else if (this.props?.isFromRad && !this.props.isCredit) { allowSms = smsConfig?.radiology_bill_sms; allowWhatsapp = UserData?.whatsapp_config?.radiology_invoice }
        else if (this.props.isFromHospitalBilling || (UserData?.module_name === "Laboratory" && this.props.isFromHospitalBilling === false) || (UserData?.module_name === "Radiology" && this.props.isFromHospitalBilling === false) && !this.props.isCredit) {allowSms = smsConfig?.op_bill_sms; allowWhatsapp = UserData?.whatsapp_config?.op_invoice }
        this.setState({ allowSms: allowSms, whatsappConfig: UserData?.whatsapp_configuration, allowWhatsapp : allowWhatsapp })
    }

    PrintReceipt = (receiptNum) => {
        let ProfileName = localGetItem("loggedInUserInfo")
        let myUser = JSON.parse(ProfileName)
        console.log(this.props.moduleType);
        
        try {
            if (receiptNum) {
                let Url = ''
                let SafetyDeposit = this.props?.is_safety_deposit ? "&is_safety_deposit=true" : ""
                let fromReservation = this.props?.from_reservation ? "&from_reservation=true" : ""
                if (myUser.module_name === "Laboratory") {
                    Url = ((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_RECEIPT_INDIV_PRINT : Serviceurls.RECEIPT_INDIV_PRINT) + `?receipt_id=` + receiptNum + `&module_type=${this.props.moduleType}` + `&clinic_id=${localGetItem("clinicId")}`
                } else if (myUser.module_name === "Pharmacy") {
                    Url = ((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_RECEIPT_INDIV_PRINT : Serviceurls.RECEIPT_PHARMACY_PRINT) + `?receipt_id=` + receiptNum + `&clinic_id=${localGetItem("clinicId")}` + `&module_type=${this.props.moduleType}`
                } else {
                    Url = ((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_RECEIPT_INDIV_PRINT : Serviceurls.RECEIPT_INDIV_PRINT) + `?receipt_id=` + receiptNum + SafetyDeposit + `&module_type=${this.props.moduleType}` + `&clinic_id=${localGetItem("clinicId")}` + fromReservation
                }
                RestAPIService.PrintPDF(Url)
                    .then((response) => {
                        if (response) {
                            this.props.ClosePopUp()
                            //Create a Blob from the PDF Stream
                            const file = new Blob(
                                [response.data],
                                { type: 'application/pdf' });
                            //Build a URL from the file
                            const fileURL = URL.createObjectURL(file);
                            //Open the URL on new Window
                            window.open(fileURL);
                        }

                    }).catch((error) => {
                        this.props.error(error.message)
                    })
            }
        } catch (e) {
            this.props.ClosePopUp()
        }
    }
    PrintPharmaReceipt = (receiptNum) => {
        try {
            if (receiptNum) {
                RestAPIService.PrintPDF(((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_RECEIPT_INDIV_PRINT : Serviceurls.RECEIPT_INDIV_PRINT) + `?receipt_id=` + receiptNum)
                    .then((response) => {
                        if (response) {
                            this.props.ClosePopUp()
                            //Create a Blob from the PDF Stream
                            const file = new Blob(
                                [response.data],
                                { type: 'application/pdf' });
                            //Build a URL from the file
                            const fileURL = URL.createObjectURL(file);
                            //Open the URL on new Window
                            window.open(fileURL);
                        }

                    }).catch((error) => {
                        console.log(error.message)
                    })
            }
        } catch (e) {
            this.props.ClosePopUp()
        }
    }


    printInvoice() {
        try {
            this.setState({
                isPrintClick: true
            })
            if (this.props.creditreceipt || this.props.phrma_creditreceipt) {
                this.PrintReceipt(this.props.creditreceipt)
                setTimeout(() => {
                    this.PrintPharmaReceipt(this.props.phrma_creditreceipt)
                }, 2000);

            } else {
                let API_URL = ""
                let Receipt_ID = ""
                Receipt_ID = this.props.Receipt_id ? (`&receipt_id=` + this.props.Receipt_id) : ''
               const LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null;
               const moduleName = LoggedData?.module_name ? JSON.parse(JSON.stringify(LoggedData?.module_name)) : "";
               let DocClinicID =  localGetItem("SelectedDoctorClinicId") !== null ? `&clinic_id=${localGetItem("SelectedDoctorClinicId")}`: ""
                if (this.props.isFromOP) {
                    API_URL = ((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_OP_INVOICE_PRINT : Serviceurls.OP_INVOICE_PRINT) + "?invoce_id=" + this.props.InvoiceId + Receipt_ID
                }
                else if (this.props?.isFromPharmacy || this.props?.isFromSubLocation) {
                    API_URL = Serviceurls.PHARMA_BILLS_GET + "?id=" + this.props.InvoiceId + "&export=pdf"
                }
                else if (this.props?.isFromDoctor) {
                    API_URL = ((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_OP_INVOICE_PRINT : Serviceurls.OP_INVOICE_PRINT) + "?invoce_id=" + this.props.InvoiceId + Receipt_ID + "&clinic_id=" + this.props.clinic_id
                } else if (this.props?.isFromCanteen) {
                    API_URL = Serviceurls.CANTEEN_BILLING + `?id=${this.props.InvoiceId}&export_type=pdf`
                } else if (this.props?.MultiBilling) {
                    API_URL = Serviceurls.FO_MULTI_BILLING_POST + `?id=${this.props.InvoiceId}${Receipt_ID}&export_type=pdf`
                }else if (this.props.isFromHospitalBilling){
                    API_URL = ((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_OP_INVOICE_PRINT : Serviceurls.OP_INVOICE_PRINT) + "?invoce_id=" + this.props.InvoiceId + Receipt_ID
                }else if(this.props.finalBill){
                    API_URL = Serviceurls.IP_DETAILED_PRINT_FO + "?ip_admission_id=" + this.props.InvoiceId + "&export_type=pdf"
                }
                else {
                    API_URL = (((localGetItem('isNewBilling') === "true") && ((moduleName === "Laboratory"))) ? Serviceurls.NEW_LAB_CREATE_BILL_COMPLETED_PRINT : ((localGetItem('isNewBilling') === "true") && ((moduleName === "Radiology"))) ? Serviceurls.NEW_RAD_BILL_POST : ((localGetItem('isNewBilling') === "true") && ((moduleName === "Investigation"))) ? Serviceurls.NEW_INVESTIGATION_BILL_POST  : (localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_IP_INVOICE_PRINT : Serviceurls.IP_INVOICE_PRINT) + `${((localGetItem('isNewBilling') === "true") && (moduleName === "Investigation") )  ? "?invoce_id=" : ((localGetItem('isNewBilling') === "true") && (moduleName === "Laboratory" || moduleName === "Radiology")) ? '?bill_summary_id=': "?ip_bill_summary_id="}` + this.props.InvoiceId + Receipt_ID
                }

                if(DocClinicID){
                    API_URL = API_URL + DocClinicID
                }
                RestAPIService.PrintPDF(API_URL)
                    .then((response) => {
                        if (response) {
                            this.props.ClosePopUp()
                            if (this.props.isDirectPrint) {
                                OpenDirectPrint(response)
                            } else {
                                // Create a Blob from the PDF Stream
                                const file = new Blob(
                                    [response.data],
                                    { type: 'application/pdf' });
                                //Build a URL from the file
                                const fileURL = URL.createObjectURL(file);
                                //Open the URL on new Window
                                window.open(fileURL);
                            }
                        }
                    }).catch((error) => {
                        // this.props.error(error.message)
                    })
            }
        } catch (e) {
            this.props.ClosePopUp()
        }
    }

    sendeBill() {
        let loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        try {
            this.setState({ isEbill: true })
            let data = ''
            if (this.props.isFromOP) {
                data = {
                    "patient_id": this.props.patientID,
                    "op_bill_summary_id": this.props.InvoiceId,
                    "op_receipt_id": this.props.Receipt_id,
                    "is_sms": true,
                    "is_email": false
                }
            }
            else if (this.props?.isFromPharmacy) {
                data = {
                    "patient_id": this.props.PatientID,
                    "pharmacy_bill_summary_id": this.props.InvoiceId,
                    "is_sms": true,
                    "is_email": false
                }
            }
            else if (this.props?.isFromsmsIP) {
                data = {
                    "patient_id": this.props.patientID,
                    "ip_bill_summary_id": this.props.InvoiceId,
                    "ip_receipt_id": this.props.Receipt_id,
                    "is_sms": true,
                    "is_email": false
                }
            }
            else if (this.props?.isFromLab) {
                data = {
                    "patient_id": this.props.patientID,
                    "lab_bill_summary_id": this.props.InvoiceId,
                    "is_sms": true,
                    "is_email": false
                }
            }
            else if (this.props?.isFromRad) {
                data = {
                    "patient_id": this.props.patientID,
                    "rad_bill_summary_id": this.props.InvoiceId,
                    "is_sms": true,
                    "is_email": false
                }
            }
            else if (this.props.isFromHospitalBilling || (loggedInUserInfo?.module_name === "Laboratory" && this.props.isFromHospitalBilling === false) || (loggedInUserInfo?.module_name === "Radiology" && this.props.isFromHospitalBilling === false)){
                data = {
                    "patient_id": this.props.patientID || this.props?.patientData?.patient_id,
                    "op_bill_summary_id": this.props.InvoiceId,
                    "is_sms": true,
                    "is_email": false
                }
            }
            RestAPIService.create(data, Serviceurls.SMS_SEND).
                then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            successMsg: true,
                            successMsgText: response.data.message,
                            isEbill: false,
                            isSMSText: 'SMS Sent Successfully !',
                            isWhatsAppText: '',
                            smsDis: true,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.status === 'fail') {
                        this.setState({
                            isErrorMsg: true,
                            isErrorMsgText: error.response.data.message,
                            isEbill: false,
                            isSMSText: '',
                        })
                    } else {
                        this.setState({
                            isErrorMsg: true,
                            isErrorMsgText: error.message,
                            isEbill: false,
                            isSMSText: '',
                        })
                    }
                })
        } catch (e) {
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: e.data.message,
                isEbill: false,
                isSMSText: '',
            })
        }
    }
    sendeWhatsApp() {
        let loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        try {
            this.setState({ isWhatsApp: true })
            let data = ''
            if (this.props.isFromOP) {
                data = {
                    "patient_id": this.props.patientID,
                    "op_bill_summary_id": this.props.InvoiceId,
                    "op_receipt_id": this.props.Receipt_id,
                    "is_whatsapp": true,
                }
            }
            else if (this.props?.isFromPharmacy) {
                data = {
                    "patient_id": this.props.PatientID,
                    "pharmacy_bill_summary_id": this.props.InvoiceId,
                    "is_whatsapp": true,
                }
            }
            else if (this.props?.isFromsmsIP) {
                data = {
                    "patient_id": this.props.patientID,
                    "ip_bill_summary_id": this.props.InvoiceId,
                    "ip_receipt_id": this.props.Receipt_id,
                    "is_whatsapp": true,
                }
            }
            else if (this.props?.isFromLab) {
                data = {
                    "patient_id": this.props.patientID,
                    "lab_bill_summary_id": this.props.InvoiceId,
                    "is_whatsapp": true,
                }
            }
            else if (this.props?.isFromRad) {
                data = {
                    "patient_id": this.props.patientID,
                    "rad_bill_summary_id": this.props.InvoiceId,
                    "is_whatsapp": true,
                }
            }
            else if (this.props.isFromHospitalBilling || (loggedInUserInfo?.module_name === "Laboratory" && this.props.isFromHospitalBilling === false) || (loggedInUserInfo?.module_name === "Radiology" && this.props.isFromHospitalBilling === false)){
                data = {
                    "patient_id": this.props.patientID || this.props?.patientData?.patient_id,
                    "op_bill_summary_id": this.props.InvoiceId,
                    "is_whatsapp": true,
                }
            }
            RestAPIService.create(data, Serviceurls.WHATSAPP_SEND).
                then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            successMsg: true,
                            successMsgText: response.data.message,
                            isWhatsApp: false,
                            isWhatsAppText: 'WhatsApp Message Sent Successfully !',
                            isSMSText: '',
                            WhatsappDis: true,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.status === 'fail') {
                        this.setState({
                            isErrorMsg: true,
                            isErrorMsgText: error.response.data.message,
                            isWhatsApp: false,
                            isWhatsAppText: '',
                        })
                    } else {
                        this.setState({
                            isErrorMsg: true,
                            isErrorMsgText: error.message,
                            isWhatsApp: false,
                            isWhatsAppText: '',
                        })
                    }
                })
        } catch (e) {
            this.setState({
                isErrorMsg: true,
                isErrorMsgText: e.data.message,
                isWhatsApp: false,
                isWhatsAppText: '',
            })
        }
    }


    printOPHomePrint() {
        try {
            this.setState({
                isPrintClick: true
            })
            // this.props.BilllistArray.forEach((item)=>{
            RestAPIService.PrintPDF(((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_OP_INVOICE_PRINT : Serviceurls.OP_INVOICE_PRINT) + "?invoce_id=" + this.props.BilllistArray[0].id)
                .then((response) => {
                    if (response) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                        window.open(fileURL);
                    }
                }).catch((error) => {
                    this.props.error(error.message)
                })
            // })
            this.props.ClosePopUp()

        } catch (e) {
            this.props.ClosePopUp()
        }
    }

    printIssueDrug = () => {
        try {
            this.setState({
                isIssueDrug: true
            })
            RestAPIService.PrintPDF(`${Serviceurls.NEW_BILLING_ISSUE_DRUG_PRINT}?module_type=OP&id=${this.props.InvoiceId}`)
                .then((response) => {
                    if (response) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                        window.open(fileURL);
                    }
                }).catch((error) => {
                    this.props.error(error.message)
                })
            // })
            this.setState({
                isIssueDrug: false
            })
            this.props.ClosePopUp()
        } catch (e) {
            this.setState({
                isIssueDrug: false
            })
            this.props.ClosePopUp()
        }
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    render() {
        let loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
        let testID = this.props.testID ? this.props.testID : "Billsucc";
        let receiveSMS = false;
        let receiveWahtsapp = false;
        // old billing Lab and Rad have induvitual billing
        if(this.props.isFromOP){
            receiveSMS = this.props.patientData?.receive_sms;
            receiveWahtsapp = this.props.patientData?.receive_whatsapp;
        }else if(this.props.isFromsmsIP){
            receiveSMS = this.props.ipPatientData?.receive_sms;
            receiveWahtsapp = this.props.ipPatientData?.receive_whatsapp;
        }else if(this.props.isFromPharmacy){
            receiveSMS = this.props.PatientDetails?.receive_sms;
            receiveWahtsapp = this.props.PatientDetails?.receive_whatsapp;
        }else if(this.props.isFromHospitalBilling || (loggedInUserInfo?.module_name === "Laboratory" && this.props.isFromHospitalBilling === false) || (loggedInUserInfo?.module_name === "Radiology" && this.props.isFromHospitalBilling === false)){
            receiveSMS = this.props.patientData?.receive_sms;
            receiveWahtsapp = this.props.patientData?.receive_whatsapp;
        }else{
            receiveSMS = this.props.patientData?.receive_sms || false;
            receiveWahtsapp = this.props.patientData?.receive_whatsapp || false;
        }
        return (
            <div>
                <Modal open={true}>
                    <Box component={'div'} className="eMed_Bill_Success_Preview_Main" height={'22vw'} >
                        <img className="eMed_Bill_Success_animation" src={ImagePaths.SuccessAnimationGif.default} />
                        <Typography fontWeight={600}>{this.state.isSMSText ? this.state.isSMSText : this.state.isWhatsAppText ? this.state.isWhatsAppText : this.props.successTxt ? this.props.successTxt  : 'Payment Received Successfully !'}</Typography>
                        <Box display={'flex'} width={'100%'} justifyContent={'center'} padding={'1vw'}>
                            <Button emed_tid={`${testID}_next`} sx={{ textTransform: 'capitalize', width: '7vw' }} size="small" variant="outlined" onClick={() => { this.props.ClosePopUp() }}>{this.props?.CloseBtnText ? this.props?.CloseBtnText : "Next Bill"}</Button>
                            {this.props.fromPharmaSaved ?
                                <Box sx={{ display: 'flex', gap: '0.5vw' }}>
                                    <Button emed_tid={`${testID}_next`} sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} size="small" variant="contained" onClick={() => { this.setState({ isPrintClick: true }, () => this.props.printOne()) }}>{this.props?.printOneTxt ? this.props?.printOneTxt : "Print Bill"}</Button>
                                    <Button emed_tid={`${testID}_next`} sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} size="small" variant="contained" onClick={() => { this.setState({ isPrintClick: true }, () => this.props.printTwo()) }}>{this.props?.printTwoTxt ? this.props?.printTwoTxt : "Print Bill"}</Button>
                                </Box>
                                :
                                this.props.finalBill ? 
                                <Button emed_tid={`${testID}_print`} sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} disabled={this.state.isPrintClick} size="small" variant="contained" onClick={() => { this.printInvoice() }}>Print Bill</Button>
                                :
                                <Box sx={{ display: 'flex', gap: '0.5vw', marginLeft: '1vw' }}>
                                    <Button emed_tid={`${testID}_print`} sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} disabled={this.state.isPrintClick} size="small" variant="contained" onClick={() => { this.props.isFromOPHome ? this.printOPHomePrint() : this.printInvoice() }}>Print Bill</Button>
                                    {
                                    (this.props.isFromHospitalBilling && localGetItem('isNewBilling') === "true" && loggedInUserInfo?.show_assorted_inhouse_drug === true && this.props.is_issued_drug)
                                        && <Tooltip title={"Issued Drugs"} placement="top" arrow>
                                            <IconButton emed_tid={`${testID}_issueDrug`} disabled={this.state.isIssueDrug} size="small" onClick={() => { this.printIssueDrug() }}>
                                                <img src={ImagePaths.PrintIcons.default} alt="print" className='eMed_action_img' />
                                            </IconButton>
                                        </Tooltip>}
                                </Box>
                            }
                           {(this.props.isFromQuick || this.props.successTxt === "Bill Saved Successfully") ? null : (this.state.allowSms && receiveSMS) ? <Tooltip title={'SMS'} placement="top">
                                <IconButton emed_tid={`${testID}_ebill`} disabled={this.state.smsDis} sx={{ marginLeft: '1vw' }} size="small" onClick={() => { if (!this.state.isEbill) { this.sendeBill() } }}>
                                    {this.state.isEbill ? <CircularProgress sx={{ color: '#04B7B1' }} size={20} /> : this.state.smsDis ? <img style={{width: '2vw', height: '2vw'}} src={ImagePaths.smsicon_dis.default} alt="sms" /> : <img style={{width: '2vw', height: '2vw'}} src={ImagePaths.smsicon.default} alt="sms" />}
                                </IconButton>
                            </Tooltip>
                            : null}
                            {(this.props.isFromQuick || this.props.successTxt === "Bill Saved Successfully") ? null : (this.state.whatsappConfig && this.state.allowWhatsapp && receiveWahtsapp) ?
                            <Tooltip title={'WhatsApp'} placement="top">
                                <IconButton emed_tid={`${testID}_ebill`} disabled={this.state.WhatsappDis} sx={{ marginLeft: '1vw' }} size="small" onClick={() => { if (!this.state.isWhatsApp) { this.sendeWhatsApp() } }}>
                                    {this.state.isWhatsApp ? <CircularProgress sx={{ color: '#04B7B1' }} size={20} /> : this.state.WhatsappDis ? <img style={{width: '2vw', height: '2vw'}} src={ImagePaths.whatsappicon_dis.default} alt="sms" /> : <img style={{width: '2vw', height: '2vw'}} src={ImagePaths.whatsappicon.default} alt="sms" />}
                                </IconButton>
                            </Tooltip>
                            : null}
                        </Box>
                    </Box>
                </Modal>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </div>
        )
    }
}

export class ChecKoutSuceessPop extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isErrorMsg: false,
            successMsg: false
        }
    }


    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    getIpSummaryBillPrint = () => {
        try {
            RestAPIService.getAllPrint(((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_IP_ADMISSION_BILL_SUMMARY_PRINT  : Serviceurls.IP_ADMISSION_BILL_SUMMARY_PRINT ) + "?ip_admission_id=" + this.props?.ip_admission_id + "&export_type=pdf").
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    this.setState({
                        selectedOption: ""
                    })
                }).catch((error) => {
                    this.errorMessage(error.response?.data?.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getPatientBillDetailedPrint = (params) => {
        try {
            RestAPIService.getAll(((localGetItem('isNewBilling') === "true") ? Serviceurls.IP_DETAILED_PRINT_FO : Serviceurls.IP_PATIENT_BILL_DETAILED_PRINT)  + "?ip_admission_id=" + this.props?.ip_admission_id + "&export_type=pdf").
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    this.setState({ selectedOption: "" })
                }).catch((error) => {
                    this.errorMessage(error.response?.data?.message);
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }


    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    render() {
        let testID = this.props.testID ? this.props.testID : "Billsucc";
        return (
            <div>
                <Modal
                    open={true}
                >
                    <Box component={'div'} className="eMed_Bill_Success_Preview_Main" height={"23vw"}>
                        <img className="eMed_Bill_Success_animation" src={ImagePaths.SuccessAnimationGif.default} />
                        <Typography fontWeight={600}>{"Patient Successfully Checked Out !"}</Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: "center", height: "15vw" }}>
                            <Button sx={{ textTransform: 'capitalize', }} size="small" onClick={() => { this.getIpSummaryBillPrint() }}>Print Summary Bill</Button>
                            <Button sx={{ textTransform: 'capitalize', marginY: "0.5vw" }} size="small" onClick={() => { this.getPatientBillDetailedPrint() }}>Print Detailed Bill</Button>
                            <Button emed_tid={`${testID}_next`} sx={{ textTransform: 'capitalize', }} size="small" onClick={() => {
                                clearCachevalue("IsForCheckedOut");
                                clearCachevalue('IppatientData')
                                this.props.history.push({ pathname: '/IPHome' })
                            }}>{"Move To IP Home"}</Button>
                        </Box>
                        <Box>
                        </Box>
                    </Box>
                </Modal>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </div>
        )
    }
}
export class VacentRoomPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }
    render() {
        return (
            <div>
                <Modal
                    open={true}
                >
                    <Box component={'div'} className="eMed_Bill_Success_Preview_Main" >
                        <img className="eMed_Bill_Success_animation" src={ImagePaths.SuccessAnimationGif.default} />
                        <Typography fontWeight={600}>Patient is Checked-Out.</Typography>
                        <Typography fontWeight={600}>Room is Vacant</Typography>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export class CommonCorporateAndInsuranceDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render() {
        const { data } = this.props
        let brandName = data?.brand_name ? data?.brand_name : data?.drug_name ? data?.drug_name : data?.product_name ? data?.product_name : '-'
        let genericName = data?.generic_name ? data?.generic_name : data?.model_name ? data?.model_name : data?.category_name ? data?.category_name : '-'
        let dosageType = data?.dosage_type ? data?.dosage_type : data?.dosagetype ? data?.dosagetype : data?.iol_type ? data?.iol_type : data?.sub_category_name ? data?.sub_category_name : '-'
        let CompanyName = creditCorpTypes.has(data?.credit_type) ? (data?.employer_name ? data?.employer_name : "-") : (data?.credit_type === "Insurance credit" ? (data?.insurance_name ? data?.insurance_name : "-") : "-")
        let StrengthType = data?.iol_power ? data?.iol_power : data?.dosage_strength ? data?.dosage_strength : '-'
        return (
            <>{
                this.props.fromPharma ?
                    <Box component={'div'}>
                        <Typography component={'div'}>
                            {(brandName?.length) > 10 ?
                                <Tooltip title={brandName} placement={'top'} arrow>
                                    <Typography id='eMed_Com_Patient_Name'>{(brandName ? ((brandName?.slice(0, 10) + '...')) : '-')}</Typography>
                                </Tooltip> : <Typography id='eMed_Com_Patient_Name'>{(brandName ? brandName : '-')}</Typography>}
                        </Typography>
                        {genericName?.length > 10 || dosageType?.length > 10 ?
                            <Box display={"flex"}>
                                <Tooltip placement="top" title={genericName}><Typography id='eMed_Com_Patient_UhidText' component={'div'}>{genericName.slice(0, 8) + '...'}</Typography></Tooltip> |
                                <Tooltip placement="top" title={dosageType}><Typography id='eMed_Com_Patient_UhidText' component={'div'}>{dosageType.slice(0, 8)}</Typography></Tooltip>
                            </Box> :
                            <Typography id='eMed_Com_Patient_UhidText' component={'div'}>{`${genericName} | ${dosageType}`}</Typography>}
                    </Box>
                    :
                    this.props.fromPharmaBilling ?
                        <Box component={'div'}>
                            {brandName?.length > 40 ?
                                <Tooltip placement="top" title={brandName} ><div id='eMed_Com_Patient_Name'>{brandName.slice(0, 40) + '...'}</div></Tooltip> :
                                <Typography id='eMed_Com_Patient_Name'>{brandName}</Typography>}
                            <Box display={'flex'}>
                                {genericName?.length > 18 ? <Tooltip placement="top" title={genericName}><Typography fontSize={'0.8vw'}>{genericName.slice(0, 18) + '...'}</Typography></Tooltip> :
                                    <Typography fontSize={'0.8vw'}>{genericName}</Typography>} {dosageType?.length > 18 ? <Tooltip placement="top" title={dosageType}><Typography fontSize={'0.8vw'}>{`| ${dosageType.slice(0, 17) + '...'}`}</Typography></Tooltip> :
                                        <Typography fontSize={'0.8vw'}>{`| ${dosageType} `}</Typography>} {<Typography fontSize={'0.8vw'}>{`| ${StrengthType}`}</Typography>}
                            </Box>
                        </Box>
                        :
                        (creditCorpTypes.has(data?.credit_type) || data?.credit_type === "Insurance credit") ?
                            <Box component={'div'}>
                                <Typography component={'div'}>
                                    {(data?.credit_type?.length) > 18 ?
                                        <Tooltip title={data?.credit_type} placement={'top'} arrow>
                                            <div><Typography id=''>{(data?.credit_type ? ((data?.credit_type?.slice(0, 18) + '...')) : '-')}</Typography>
                                            </div></Tooltip> :
                                        <Typography id=''>{(
                                            data?.credit_type ? creditCorpTypes.has(data?.credit_type) ? "Corporate Credit" : data?.credit_type : '-')}</Typography>}
                                </Typography>
                                <Box>
                                    {(CompanyName?.length) > 20 ?
                                        <Tooltip title={CompanyName} placement={'top'} arrow>
                                            <Typography id='eMed_Com_Patient_UhidText'>{(CompanyName ? ((CompanyName?.slice(0, 20) + '...')) : '-')}</Typography>
                                        </Tooltip> : <Typography id='eMed_Com_Patient_UhidText'>{(CompanyName ? CompanyName : '-')}</Typography>}
                                </Box>
                            </Box>
                            :
                            this.props.fromStorPurRejec ?
                                <Box component={'div'}>
                                    <Typography component={'div'}>
                                        {(brandName?.length) > 20 ?
                                            <Tooltip title={brandName} placement={'top'} arrow>
                                                <Typography id='eMed_Com_Patient_Name'>{(brandName ? ((brandName?.slice(0, 10) + '...')) : '-')}</Typography>
                                            </Tooltip> : <Typography id='eMed_Com_Patient_Name'>{(brandName ? brandName : '-')}</Typography>}
                                    </Typography>
                                    {genericName?.length > 20 || dosageType?.length > 20 ?
                                        <Box display={"flex"}>
                                            <Tooltip placement="top" title={genericName}><Typography id='eMed_Com_Patient_UhidText' component={'div'}>{genericName.slice(0, 8) + '...'}</Typography></Tooltip> |
                                            <Tooltip placement="top" title={dosageType}><Typography id='eMed_Com_Patient_UhidText' component={'div'}>{dosageType.slice(0, 8)}</Typography></Tooltip>
                                        </Box> :
                                        <Typography id='eMed_Com_Patient_UhidText' component={'div'}>{`${genericName} | ${dosageType}`}</Typography>}
                                </Box>
                                : <Typography>{data?.credit_type}</Typography>
            }</>
        )
    }
}

export class CommonTimeRangePicker extends Component {
    constructor(props) {
        super(props)
        this.state = {
            startTime: this.props.startTime,
            endTime: this.props.endTime,
            fromDate: this.props.FromDate,
            toDate: this.props.ToDate,
            error: null
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                startTime: this.props.startTime,
                endTime: this.props.endTime,
                fromDate: this.props.FromDate,
                toDate: this.props.ToDate,
            })
        }
    }

    render() {
        return (
            <><Box component={'div'} display={'flex'} margin={'0.2vw 1vw'}>
                <Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                            disabled={(this.props.disable || this.props.disableTimer) ? true : false}
                            label={this.props.label1 || 'Start Time'}
                            value={this.state.startTime}
                            onChange={(newStartTime) => this.setState({ startTime: newStartTime },
                                () => {
                                    this.props.selectedTime(this.state.startTime, this.state.endTime)
                                })}
                            renderInput={(props) => <TextField {...props} inputProps={{ ...props.inputProps, placeholder: "HH:MM (AM|PM)" }} style={{ width: "98%" }} size="small" />}
                        />
                    </LocalizationProvider>
                </Box>
                <Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                            label={this.props.label2 || 'End Time'}
                            value={this.state.endTime}
                            minTime={this.state.fromDate === this.state.toDate ? this.state.startTime : null}
                            onError={(error) => this.setState({ error: error }, () => {
                                let Error = false
                                if (this.state.error) {
                                    Error = true
                                } else {
                                    Error = false
                                }
                                this.props.selectedTime(this.state.startTime, this.state.endTime, Error)
                            }
                            )}
                            disabled={this.state.startTime === null || this.props.disableTimer}
                            onChange={(newEndTime) => this.setState({ endTime: newEndTime },
                                () => {
                                    let Error = false
                                    if (this.state.error) {
                                        Error = true
                                    } else {
                                        Error = false
                                    }
                                    this.props.selectedTime(this.state.startTime, this.state.endTime, Error)
                                })}
                            renderInput={(props) => <TextField {...props} inputProps={{ ...props.inputProps, placeholder: "HH:MM (AM|PM)" }} style={{ width: "95%", marginLeft: "0.9vw" }} size="small" />}
                        />
                    </LocalizationProvider>
                </Box>
            </Box>
                {this.state.startTime !== null && this.state.endTime === null ?
                    <Box component={'div'} margin={"0vw 1vw"}>
                        <FormHelperText sx={{ color: 'red', textAlign: 'center' }}>{"Select Both Start Time and End Time"}</FormHelperText>
                    </Box> : null}</>
        )
    }
}

export class CommonTimePicker extends Component {
    constructor(props) {
        super(props)
        this.state = {
            time: this.props.time
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                time: this.props.time
            })
        }
    }

    render() {
        return (
            <Box component={'div'} margin={'1vw'}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                        label={'Select Time'}
                        value={this.state.time}
                        onChange={(setTime) => this.setState({ time: setTime })}
                        renderInput={(props) => <TextField {...props} size="small" sx={{ width: this.props.width }} />}
                    />
                </LocalizationProvider>
            </Box>
        )
    }
}

export class PharmaConfirmPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            OpenConfirm: true,
            disableBtn: this.props.disableBtn,
        }
    }

    render() {
        return (
            <Dialog
                open={this.state.OpenConfirm}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent dividers sx={{ width: '30vw', height: '6vw' }}>
                    <DialogContentText emed_tid='pop_tlt' id="alert-dialog-description">
                        {this.props.popupTitle}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button emed_tid='pop_no' size="small" variant="outlined" onClick={() => {
                        this.setState({ OpenModel: false }, () => { this.props.handleNo() })
                    }}>No</Button>
                    <Button emed_tid='pop_yes' size="small" variant="contained" disabled={this.state.disableBtn} onClick={() => this.setState({ disableBtn: true }, () => { this.props.handleYes() })}>Yes</Button>
                </DialogActions>
            </Dialog>
        )
    }
}
export class AddNewListItemPop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Open: true,
            newName: "",
            newNameError: false,
            problemData: this.props.problemData ? this.props.problemData : ""
        }
    }
    handleChange = (e) => {
        let { value } = e.target;
        value = value.trimStart();
        let isValid = false;

        if (this.props.problemData) {
            if (value === "" || value) {
                this.setState({ problemData: value })
            }
        } else {
            this.setState({ newName: e.target.value })
        }
    }

    render() {
        const { t } = this.props

        return (
            <div>
                <Dialog open={this.state.Open} >
                    <DialogTitle className='eMed_CreditPoP_TitleDiv' sx={{ borderColor: Colors.themeDark }}>
                        <Typography marginLeft={"1vw"}>{`Add New ${this.props.title}`}</Typography>
                        <Button onClick={() => this.props.ClosePopUp(this.state.problemData)} >
                            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                        </Button>
                    </DialogTitle>
                    <DialogContent sx={{ padding: "2vw" }}>
                        <TextField
                            inputProps={{ maxLength: 30 }}
                            sx={{ width: "20vw", marginTop: "2vw" }}
                            size='small'
                            autoComplete="off"
                            label={this.props.title}
                            value={this.state.problemData ? this.state.problemData : this.state.newName}
                            onChange={this.handleChange}
                            error={this.state.newNameError}
                            helperText={this.state.newNameError ? `Enter the ${this.props.title}` : ""}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant='outlined' size='small' className='eMed_Filter_Btns'
                            onClick={() => { this.setState({ newName: "", problemData: "" }) }}>{"Clear"}</Button>
                        <Button variant='contained' size='small' className='eMed_Filter_Btns'
                            onClick={() => {
                                if (CommonValidation.removeSpace(this.state.newName) !== "") {
                                    this.props.sendNewData(CommonValidation.removeSpace(this.state.newName))
                                }
                                else if (CommonValidation.removeSpace(this.state.problemData) !== "") {
                                    this.props.sendproblemData(CommonValidation.removeSpace(this.state.problemData), this.props.title)
                                    this.setState({ problemData: '' })
                                }
                                else {
                                    this.setState({
                                        newNameError: true
                                    })
                                }
                            }}>{"Add"}</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export class NoAccessScreen extends Component {
    render() {
        return <Typography className='eMed_NoAccess_Text' sx={{ paddingTop: "15.65vw" }}>No Access For This Screen</Typography>
    }
}
export class ToolsField extends Component {

    constructor(props) {
        super(props);
        this.editorRef = React.createRef();
        this.uploadPDF = React.createRef();
        this.state = {
            BoldFont: false,
            italic: false,
            underline: false,
            justifyLeft: false,
            justifyCenter: false,
            justifyRight: false,
            isDisableDataDispatch: true,
            status: this.props.selectedServiceData?.result_status,
            isdispatch: this.props.isDispatchshown ? true : false,
            pdfUploadList: this.props.ResultPDF ? this.props.ResultPDF : [],
        }
    }

    componentDidMount() {
        this.editorRef.current.innerHTML = this.props.EditorRef
    }

    componentDidUpdate(preProps) {
        if (this.props !== preProps && this.props.EditorRef) {
            this.editorRef.current.innerHTML = this.props.EditorRef
        }
    }

    componentWillUnmount() {
        // this.editorRef.current.removeEventListener('paste', this.handlePaste);
    }

    handleStyleChange = (command) => {
        document.execCommand(command, false, null);
        this.editorRef.current.focus();
        switch (command) {
            case 'bold': this.setState({ BoldFont: !this.state.BoldFont })
                break
            case 'italic': this.setState({ italic: !this.state.italic })
                break
            case 'underline': this.setState({ underline: !this.state.underline })
                break
            default: this.setState(prevState => ({
                justifyLeft: command === 'justifyLeft' ? !prevState["justifyLeft"] : false,
                justifyCenter: command === 'justifyCenter' ? !prevState["justifyCenter"] : false,
                justifyRight: command === 'justifyRight' ? !prevState['justifyRight'] : false,
            }), () => {
                if (this.state.justifyCenter === false && this.state.justifyRight === false) {
                    this.setState({
                        justifyLeft: true
                    })
                    document.execCommand('justifyLeft', false, null);
                }

            });
                break

        }

    };

    handlePaste = (event) => {
        event.preventDefault();
        const plainText = event.clipboardData.getData('text/plain');
        const normalizedText = plainText.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
        document.execCommand('insertText', false, normalizedText);
    };

    getTextStylesAtCursor = () => {
        this.setState({
            italic: false,
            BoldFont: false,
            underline: false,
            justifyLeft: false,
            justifyCenter: false,
            justifyRight: false,
            disable: false,
        }, () => {
            const selection = window.getSelection();
            if (!selection.rangeCount) return null;

            const range = selection.getRangeAt(0);
            const node = range.commonAncestorContainer;
            const textNode = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
            const computedStyle = window.getComputedStyle(textNode);

            const textStyle = {
                fontWeight: computedStyle.fontWeight,
                fontStyle: computedStyle.fontStyle,
                textDecoration: computedStyle.textDecoration,
                textAlign: computedStyle.textAlign
            };

            if (textStyle.fontStyle === "italic") {
                this.setState({ italic: true });
            }
            if (textStyle.fontWeight === '700') {
                this.setState({ BoldFont: true });
            }
            if (textStyle.textDecoration.includes("underline") || document.queryCommandState('underline')) {
                this.setState({ underline: true });
            }
            if (textStyle.textAlign === 'left') {
                this.setState({ justifyLeft: true });
            }
            if (textStyle.textAlign === 'center') {
                this.setState({ justifyCenter: true });
            }
            if (textStyle.textAlign === 'right') {
                this.setState({ justifyRight: true });
            }
        })
    }

    onUploadPDF = async (event) => {
        const file = event.target.files[0];
        if (!file) {
            this.props.errorMsg("No file selected.");
            return;
        }
        if (file.type !== 'application/pdf') {
            this.props.errorMsg("Only PDF files are allowed.");
            return;
        }
        const maxSize = 3 * 1024 * 1024; // 3 MB
        if (file.size > maxSize) {
            this.props.errorMsg("File size exceeds 3 MB.");
            return;
        }
        const reader = new FileReader();
        reader.onload = (event) => {
            const arrayBuffer = event.target.result; // Binary data
            const blob = new Blob([arrayBuffer], { type: file.type });
            let pdfDetails = [{
                document_file: blob,
                document_name: file.name
            }]
            this.setState({
                pdfUploadList: pdfDetails,
            });
            this.uploadPDF.current.value = "";
        };
        reader.onerror = () => {
            this.props.errorMsg("Error reading the file.");
        };
        reader.readAsArrayBuffer(file); // Read the file as binary data
    }

    arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    };

    handleKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            document.execCommand('insertHTML', false, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'); // Insert 5 non-breaking spaces
        }
    };

    render() {
        return (
            <Paper component={'div'} className='rad_tst_tmp_content' sx={{ height: this.props.overallHeight }} elevation={1}>
                <Box component={'div'} borderBottom={'1px solid lightgray'} pl={'0.5vw'} height={'2.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'flex-start'}>
                    <Typography fontWeight={600}>{this.props.Title}</Typography>
                    <div className="toolbar" style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}>
                        <ButtonGroup variant="text" aria-label="Basic button group" sx={{ visibility: this.props?.EditorDisable ? 'hidden' : "visible" }}>
                            <Tooltip title={"Bold"} placement={'top'} arrow><IconButton disabled={!this.editorRef?.current?.innerHTML || this.props?.EditorDisable} onClick={() => this.handleStyleChange('bold')}><FormatBoldIcon color={this.state.BoldFont ? "primary" : "black"} /></IconButton></Tooltip>
                            <Tooltip title={"Italic"} placement={'top'} arrow><IconButton disabled={!this.editorRef?.current?.innerHTML || this.props?.EditorDisable} onClick={() => this.handleStyleChange('italic')} ><FormatItalicOutlinedIcon color={this.state.italic ? "primary" : "black"} /></IconButton></Tooltip>
                            <Tooltip title={"Underline"} placement={'top'} arrow><IconButton disabled={!this.editorRef?.current?.innerHTML || this.props?.EditorDisable} onClick={() => this.handleStyleChange('underline')}><FormatUnderlinedOutlinedIcon color={this.state.underline ? "primary" : "black"} /></IconButton></Tooltip>
                            <Tooltip title={"Left Align"} placement={'top'} arrow><IconButton disabled={!this.editorRef?.current?.innerHTML || this.props?.EditorDisable} onClick={() => this.handleStyleChange('justifyLeft')}><FormatAlignLeftOutlinedIcon color={this.state.justifyLeft ? "primary" : "black"} /></IconButton></Tooltip>
                            <Tooltip title={"Center Align"} placement={'top'} arrow><IconButton disabled={!this.editorRef?.current?.innerHTML || this.props?.EditorDisable} onClick={() => this.handleStyleChange('justifyCenter')}><FormatAlignCenterOutlinedIcon color={this.state.justifyCenter ? "primary" : "black"} /></IconButton></Tooltip>
                            <Tooltip title={"Right Align"} placement={'top'} arrow><IconButton disabled={!this.editorRef?.current?.innerHTML || this.props?.EditorDisable} onClick={() => this.handleStyleChange('justifyRight')}><FormatAlignRightOutlinedIcon color={this.state.justifyRight ? "primary" : "black"} /></IconButton></Tooltip>
                        </ButtonGroup>
                    </div>
                </Box>
                <Box component={'div'} height={this.props.height}>
                    <Box
                        onMouseUp={this.getTextStylesAtCursor}
                        onSelect={this.getTextStylesAtCursor}
                        component={'div'}
                        ref={this.editorRef}
                        contentEditable={this.props?.EditorDisable ? false : true}
                        className= {"editor"}
                        sx={{ height: this.props.EditorHeight, overflow: "scroll" }}
                        spellcheck="false"
                        onPaste={this.handlePaste}
                        {...(this.props.addSpaceOnTab && { onKeyDown: this.handleKeyDown })}>
                    </Box>
                </Box>
                <Box display={'flex'} justifyContent={this.props?.FromTestReport ? 'space-between' : 'flex-end'} alignItems={'center'}>
                    {this.props?.FromTestReport ?
                        <Box sx={{ marginLeft: '0.5vw', display: 'flex', gap: '0.5vw' }}>
                            <input
                                type="file"
                                accept="application/pdf"
                                ref={this.uploadPDF}
                                id="pdfInput"
                                style={{ display: 'none' }}
                                onChange={this.onUploadPDF}
                            />
                            {this.state.status === "Dispatched" ? null : <Button size="small" variant="contained" disabled={this.state.pdfUploadList?.length > 0 || this.state.status === "Completed"} onClick={() => this.uploadPDF.current.click()}>
                                Upload Pdf
                            </Button>}
                            {this.state.pdfUploadList?.length > 0 ?
                                <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                    {(this.state.status === "Completed" || this.state.isdispatch || this.props?.EditorDisable) ? null : <IconButton onClick={() => { this.setState({ pdfUploadList: [] }) }}><img src={ImagePaths.CancelIcon.default} height={'15vw'} width={'15vw'} /></IconButton>}
                                    <Typography color={'#04B7B1'} display={'flex'} flexDirection={'row'} alignItems={'center'}><img src={ImagePaths.DocumentGreen.default} height={'12.5vw'} width={'12.5vw'} alt="document" color={'#04B7B1'} />
                                        {this.state.pdfUploadList[0]?.document_name ?
                                            this.state.pdfUploadList[0]?.document_name?.length > 23 ?
                                                <Tooltip title={this.state.pdfUploadList[0]?.document_name} placement='top'><div>{this.state.pdfUploadList[0]?.document_name.slice(0, 20) + '...'}</div></Tooltip>
                                                : this.state.pdfUploadList[0]?.document_name
                                            : '-'}
                                    </Typography>
                                </Box>
                                : null}
                        </Box>
                        : null}
                    <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} height={'8vh'} visibility={this.state.status === "Dispatched" ? 'hidden' : "visible"}>
                        <Button disabled={(this.state.status === "Completed" ? true : false) || (CheckAccessFunc('Radiology', "Home", 'Reports', 'Test Reports', "SubTab")?.editAccess ? false : CheckAccessFunc('Radiology', "Home", 'Reports', 'Notes', "SubTab")?.editAccess  
                            ? false :  CheckAccessFunc('Radiology','Settings', 'Service Template', null, "Tab")?.editAccess ? false : true)}
                            variant='outlined' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }}
                            onClick={() => { this.editorRef.current.innerHTML = ""; this.setState({pdfUploadList: []}) }}
                        >Clear</Button>
                        {
                            this.props?.FromTestReport ?
                                <Box>
                                    <Button disabled={(this.state.status === "Completed" ? true : false) || (!CheckAccessFunc('Radiology', "Home", 'Reports', 'Test Reports', "SubTab")?.editAccess)} variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }}
                                        onClick={() => { this.props.handleSaveResult(this.editorRef.current.innerHTML, true, false, this.state.pdfUploadList); }}
                                    >Save</Button>
                                    <Button disabled={(this.state.status === "Completed" ? true : false) || (!CheckAccessFunc('Radiology', "Home", 'Reports', 'Test Reports', "SubTab")?.editAccess)} variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }}
                                        onClick={() => { this.props.handlePostResult(this.editorRef.current.innerHTML, false, true, this.state.pdfUploadList); }}
                                    >Complete</Button>
                                    <Button disabled={(this.state.status === "Completed" ? true : false) || (!CheckAccessFunc('Radiology', "Home", 'Reports', 'Test Reports', "SubTab")?.editAccess)} variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }}
                                        onClick={() => { this.props.handleDispatchResult(this.editorRef.current.innerHTML,); }}
                                    >Dispatch</Button>
                                </Box>
                                :
                                <Button variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }}
                                    disabled ={(CheckAccessFunc('Radiology', "Home", 'Reports', 'Test Reports', "SubTab")?.editAccess ? false : CheckAccessFunc('Radiology', "Home", 'Reports', 'Notes', "SubTab")?.editAccess  
                                        ? false :  CheckAccessFunc('Radiology','Settings', 'Service Template', null, "Tab")?.editAccess ? false : true)}
                                    onClick={() => { this.props.handlePost(this.editorRef.current.innerHTML); }}
                                >Complete</Button>
                        }

                    </Box>
                </Box>
            </Paper>
        );
    }

}

export class ToolsFieldWithMic extends Component {
    constructor(props) {
        super(props);
        this.editorRef = React.createRef();
        this.uploadPDF = React.createRef();
        this.maxChar = this.props.maxChar;
        const parsedDate = DateTime.fromFormat(String(props.date_time || ""), "dd-MM-yyyy hh:mm a").isValid
            ? DateTime.fromFormat(String(props.date_time), "dd-MM-yyyy hh:mm a").toJSDate()
            : new Date();
        this.state = {
            // toolbar state
            bold: false,
            italic: false,
            underline: false,
            justifyLeft: false,
            justifyCenter: false,
            justifyRight: false,
            bulletList: false,
            orderedList: false,

            // editor state
            disableEdit: true,
            editedContent: '',
            isOutFocus: false,

            // mic
            listenPopUp: false,
            ClickKey: false,

            // upload file
            isDisableDataDispatch: true,
            status: this.props.selectedServiceData?.result_status,
            isdispatch: this.props.isDispatchshown ? true : false,
            pdfUploadList: this.props.ResultPDF ? this.props.ResultPDF : [],
            imgCapClked: false,
            CapturedImg: null,
            dateTime: parsedDate,
        }
    }

    componentDidMount() {
        this.editorRef.current.innerHTML = this.props.EditorRef
    }

    componentDidUpdate(preProps) {
        const editorRefChanged = this.props.EditorRef !== preProps.EditorRef;
        if (editorRefChanged && checkSetFrom.has(this.props.isFrom) && this.state.editedContent !== this.props.EditorRef) {
            this.editorRef.current.innerHTML = this.props.EditorRef || ''
        }
        else if (editorRefChanged && this.props.EditorRef && !this.props.isFrom) {
            this.editorRef.current.innerHTML = this.props.EditorRef || ''
        }

        // Refocus editor when listenPopUp is closed
        if (preProps.listenPopUp && !this.state.listenPopUp) {
            this.editorRef.current.focus();
        }

        if (preProps.date_time !== this.props.date_time) {
            const parsedDate = DateTime.fromFormat(String(this.props.date_time || ""), "dd-MM-yyyy hh:mm a").isValid
                ? DateTime.fromFormat(String(this.props.date_time), "dd-MM-yyyy hh:mm a").toJSDate()
                : new Date();

            this.setState({ dateTime: parsedDate });
        }
    }

    componentWillUnmount() {
        // this.editorRef.current.removeEventListener('paste', this.handlePaste);
    }

    handleStyleChange = (command) => {
        document.execCommand(command, false, null);
        this.editorRef.current.focus();
        switch (command) {
            case 'bold': this.setState({ bold: !this.state.bold })
                break
            case 'italic': this.setState({ italic: !this.state.italic })
                break
            case 'underline': this.setState({ underline: !this.state.underline })
                break
            case 'insertUnorderedList': this.setState({ bulletList: !this.state.bulletList });
                break;
            case 'insertOrderedList': this.setState({ orderedList: !this.state.orderedList });
                break;
            default: this.setState(prevState => ({
                justifyLeft: command === 'justifyLeft' ? !prevState["justifyLeft"] : false,
                justifyCenter: command === 'justifyCenter' ? !prevState["justifyCenter"] : false,
                justifyRight: command === 'justifyRight' ? !prevState['justifyRight'] : false,
            }), () => {
                if (this.state.justifyCenter === false && this.state.justifyRight === false) {
                    this.setState({
                        justifyLeft: true
                    })
                    document.execCommand('justifyLeft', false, null);
                }

            });
                break
        }
    };

    handleBeforeInput = (e) => {
        const editor = this.editorRef.current;
        if (!editor) return;

        // Allow delete operations
        if (e.inputType && e.inputType.includes("delete")) return;

        // Normalize whitespace to avoid false limit triggers from block element newlines
        const currentLength = editor.innerText.replace(/\n+/g, '\n').trim().length;

        if (this.maxChar && currentLength >= this.maxChar) {
            e.preventDefault();
            this.props.errorMsg(`You have reached the ${this.maxChar}-character limit`);
        }
    };

    handleInput = () => {
        const editor = this.editorRef.current;
        if (!editor) return;

        // Get text length, normalizing whitespace to avoid counting extra newlines from block elements
        const textLength = editor.innerText.replace(/\n+/g, '\n').trim().length;

        // Only show warning, don't slice content as that destroys formatting (bold, alignment, etc.)
        if (this.maxChar && textLength > this.maxChar) {
            this.props.errorMsg(`You have reached the ${this.maxChar}-character limit`);
        }

        // Call onInputChange callback if provided for real-time character count
        if (this.props.onInputChange) {
            this.props.onInputChange(textLength);
        }
    };

    handlePaste = (event) => {
        event.preventDefault();
        const editor = this.editorRef.current;
        if (!editor) return;

        const plainText = event.clipboardData.getData('text/plain');
        const normalizedText = plainText.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
        
        // Check character limit before pasting
        if (this.maxChar) {
            const currentLength = editor.innerText.replace(/\n+/g, '\n').trim().length;
            const remainingChars = this.maxChar - currentLength;
            
            if (remainingChars <= 0) {
                this.props.errorMsg(`You have reached the ${this.maxChar}-character limit`);
                return;
            }
            
            // Trim pasted text to fit within limit
            const textToInsert = normalizedText.slice(0, remainingChars);
            if (textToInsert.length < normalizedText.length) {
                this.props.errorMsg(`Text trimmed to fit ${this.maxChar}-character limit`);
            }
            document.execCommand('insertText', false, textToInsert);
        } else {
            document.execCommand('insertText', false, normalizedText);
        }
        // e.preventDefault();

        // const dt = e.clipboardData || window.clipboardData;
        // let html = dt.getData("text/html");
        // const text = dt.getData("text/plain") || "";

        // // If no HTML (e.g., copied from a text field) but it looks like HTML, treat it as HTML
        // if (!html && /<[^>]+>/.test(text)) {
        //     html = text;
        // }

        // // If still no HTML, convert plain text newlines to <br>
        // if (!html) {
        //     html = text.replace(/\n/g, "<br>");
        // }

        // // ---- minimal sanitizer (allow basic formatting + inline styles) ----
        // const container = document.createElement("div");
        // container.innerHTML = html;

        // const ALLOWED_TAGS = new Set([
        //     "DIV","P","BR","SPAN","STRONG","B","EM","I","U","UL","OL","LI","H1","H2","H3","H4","H5","H6"
        // ]);
        // const ALLOWED_ATTRS = new Set(["style"]);

        // [...container.querySelectorAll("*")].forEach((node) => {
        //     if (!ALLOWED_TAGS.has(node.tagName)) {
        //     // unwrap unknown tags
        //     const parent = node.parentNode;
        //     while (node.firstChild) parent.insertBefore(node.firstChild, node);
        //     parent.removeChild(node);
        //     return;
        //     }
        //     // strip disallowed attributes
        //     [...node.attributes].forEach((a) => {
        //     if (!ALLOWED_ATTRS.has(a.name)) node.removeAttribute(a.name);
        //     });
        // });

        // const sanitizedHTML = container.innerHTML;

        // // ---- insert at caret using Range API (more reliable than execCommand) ----
        // const sel = window.getSelection();
        // if (!sel || sel.rangeCount === 0) return;

        // const range = sel.getRangeAt(0);
        // range.deleteContents();

        // // create a fragment from sanitizedHTML and insert
        // const frag = range.createContextualFragment(sanitizedHTML);
        // range.insertNode(frag);

        // // move caret to the end of inserted content
        // sel.removeAllRanges();
        // const newRange = document.createRange();
        // const ed = this.editorRef.current;
        // newRange.selectNodeContents(ed);
        // newRange.collapse(false);
        // sel.addRange(newRange);
    };
    

    clearStyleState = () => {
        this.setState({
            disableEdit: true,
            italic: false,
            bold: false,
            underline: false,
            justifyLeft: false,
            justifyCenter: false,
            justifyRight: false,
            bulletList: false,
            orderedList: false,
        })
    }

    sendSavedData = () => {
        function removeEmptyStyleTagsAndReplaceSpan(content) {
            const div = document.createElement('div');
            div.innerHTML = content;

            // Iterate through all elements with style attributes
            const elements = div.querySelectorAll('*[style]');
            elements.forEach((element) => {
                const style = element.getAttribute('style');

                // Retain only `text-align` properties (center, left, right)
                const retainedStyles = style
                    .split(';')
                    .map((rule) => rule.trim())
                    .filter((rule) => {
                        const [property, value] = rule.split(':').map((item) => item.trim());
                        return (
                            property === 'text-align' &&
                            (value === 'center' || value === 'left' || value === 'right')
                        );
                    })
                    .join('; ');

                if (retainedStyles) {
                    element.setAttribute('style', retainedStyles);
                } else {
                    // Remove the style attribute if no valid styles remain
                    element.removeAttribute('style');
                }
            });

            // Replace <span> tags with <div>
            const spans = div.querySelectorAll('span');
            spans.forEach((span) => {
                const newDiv = document.createElement('div');
                // Transfer all child nodes and attributes to the new <div>
                Array.from(span.attributes).forEach((attr) => {
                    newDiv.setAttribute(attr.name, attr.value);
                });
                while (span.firstChild) {
                    newDiv.appendChild(span.firstChild);
                }
                span.parentNode.replaceChild(newDiv, span);
            });

            // ❌👎don't try to uncomment this below code anymore or redo this code (this code will affect every div tags)
            // Flatten nested divs properly: <div><div>content</div></div> → <div>content</div>
            // div.querySelectorAll('div div').forEach(innerDiv => {
            //     // Ensure text-align style is not lost
            //     if (innerDiv.hasAttribute('style')) {
            //         innerDiv.parentNode.setAttribute('style', innerDiv.getAttribute('style'));
            //     }
            //     innerDiv.parentNode.replaceChild(innerDiv, innerDiv.parentNode);
            // });

            // Get the first (outermost) <div> element
            const firstDiv = div.firstElementChild;

            if (firstDiv && firstDiv.tagName.toLowerCase() === 'div') {
                // Check if the div has a text-align style
                const style = firstDiv.getAttribute('style');

                if (style && style.includes('text-align')) {
                    // Preserve text-align styles but remove any other styles
                    const alignValue = style.match(/text-align:\s*(left|right|center)/);
                    if (alignValue) {
                        firstDiv.setAttribute('style', alignValue[0]); // Keep only text-align
                    } else {
                        firstDiv.removeAttribute('style'); // If no valid text-align, remove style
                    }
                } else {
                    // If no style exists, set text-align to 'left' (or whatever you prefer)
                    firstDiv.setAttribute('style', 'text-align: left;');
                }
            }

            // Ensure inline elements (`b`, `i`, `u`) do not remove text-align from block elements
            div.querySelectorAll('b, i, u').forEach(inlineElement => {
                inlineElement.querySelectorAll('div').forEach(blockElement => {
                    const fragment = document.createDocumentFragment();

                    // Retain text-align if present
                    if (blockElement.hasAttribute('style')) {
                        inlineElement.setAttribute('style', blockElement.getAttribute('style'));
                    }

                    while (blockElement.firstChild) {
                        fragment.appendChild(blockElement.firstChild);
                    }
                    blockElement.replaceWith(fragment); // Replace div with its inner content
                });
            });

            if (div.innerHTML === "<br>") {
                return ""
            } else {
                return div.innerHTML; // Return sanitized HTML
            }
        }

        if (this.state.isOutFocus) {
            this.clearStyleState();
        }

        const cleanedContent = removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML);
        this.setState({ editedContent: cleanedContent }, () => {
            // Get the editor content and clean it before saving
            if (this.props.isFrom === "NoNeedButton") {
                this.props.saveData(cleanedContent);
            } else {
                this.props.saveData(this.props.stateName, cleanedContent, this.props.postState);
            }
        });
    };

    getTextStylesAtCursor = () => {
        this.setState({
            italic: false,
            bold: false,
            underline: false,
            justifyLeft: false,
            justifyCenter: false,
            justifyRight: false,
            disableEdit: false,
        }, () => {
            const selection = window.getSelection();
            if (!selection.rangeCount) return null;

            const range = selection.getRangeAt(0);
            const node = range.commonAncestorContainer;
            const textNode = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
            const computedStyle = window.getComputedStyle(textNode);

            const textStyle = {
                fontWeight: computedStyle.fontWeight,
                fontStyle: computedStyle.fontStyle,
                textDecoration: computedStyle.textDecoration,
                textAlign: computedStyle.textAlign
            };

            if (textStyle.fontStyle === "italic" || document.queryCommandState('italic')) {
                this.setState({ italic: true });
            }
            if (textStyle.fontWeight === '700' || document.queryCommandState('bold')) {
                this.setState({ bold: true });
            }
            if (textStyle.textDecoration.includes("underline") || document.queryCommandState('underline')) {
                this.setState({ underline: true });
            }
            if (textStyle.textAlign === 'left') {
                this.setState({ justifyLeft: true });
            }
            if (textStyle.textAlign === 'center') {
                this.setState({ justifyCenter: true });
            }
            if (textStyle.textAlign === 'right') {
                this.setState({ justifyRight: true });
            }
        })
    }

    // mic
    listenPopUp = () => {
        this.setState({
            listenPopUp: false,
        });
    };

    voiceToTextgetter = (textStorage) => {
        if (!textStorage || !this.state.ClickKey) return;

        setTimeout(() => {
            const editor = this.editorRef.current;
            if (!editor) return;

            editor.focus();
            if (!this.maxChar) {
                document.execCommand("insertText", false, ` ${textStorage}`);
                return;
            }

            const currentLength = editor.innerText.length;
            const remaining = this.maxChar - currentLength;

            if (remaining <= 0) {
                this.props.errorMsg(`You have reached the ${this.maxChar}-character limit`);
                return;
            }

            const allowedText = textStorage.slice(0, remaining);

            document.execCommand("insertText", false, ` ${allowedText}`);

            if (textStorage.length > remaining) {
                this.props.errorMsg(`You have reached the ${this.maxChar}-character limit`);
            }
        }, 0);
    };

    handleMicClick = () => {
        this.setState({ ClickKey: true, listenPopUp: true, isOutFocus: true });
    };

    // upload file
    onUploadPDF = async (event) => {
        const files = Array.from(event.target.files);

        if (!files.length) {
            this.props.errorMsg("No file selected.");
            return;
        }
        const maxSize = 5 * 1024 * 1024; // 5 MB
        const pdfType = "application/pdf";

        // Count already uploaded PDFs
        const existingCount = (this.state.pdfUploadList || [])?.length;

        const uploadList = [];

        for (let file of files) {

            // Check type
            if (file.type !== pdfType) {
                this.props.errorMsg(`"${file.name}" is not a PDF file.`);
                continue;
            }

            // Check maximum PDF limit
            if (existingCount + uploadList.length >= 5) {
                this.props.errorMsg("You can upload a maximum of 5 PDF files.");
                break;
            }

            // Check size
            if (file.size > maxSize) {
                this.props.errorMsg(`"${file.name}" exceeds 5 MB.`);
                continue;
            }

            // Read as array buffer
            const arrayBuffer = await file.arrayBuffer();
            const blob = new Blob([arrayBuffer], { type: pdfType });

            uploadList.push({
                document_file: blob,
                document_name: file.name
            });
        }

        if (!uploadList.length) {
            this.props.errorMsg("No valid PDF files selected.");
            return;
        }

        // Add to existing list
        this.setState(prev => ({
            pdfUploadList: [...prev.pdfUploadList, ...uploadList]
        }));

        this.uploadPDF.current.value = ""; // Reset input
    };

    arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    };

    removeEmptyStyleTagsAndReplaceSpan = (content) => {
        const div = document.createElement('div');
        div.innerHTML = content;

        // Iterate through all elements with style attributes
        const elements = div.querySelectorAll('*[style]');
        elements.forEach((element) => {
            const style = element.getAttribute('style');

            // Retain only `text-align` properties (center, left, right)
            const retainedStyles = style
                .split(';')
                .map((rule) => rule.trim())
                .filter((rule) => {
                    const [property, value] = rule.split(':').map((item) => item.trim());
                    return (
                        property === 'text-align' &&
                        (value === 'center' || value === 'left' || value === 'right')
                    );
                })
                .join('; ');

            if (retainedStyles) {
                element.setAttribute('style', retainedStyles);
            } else {
                // Remove the style attribute if no valid styles remain
                element.removeAttribute('style');
            }
        });

        // Replace <span> tags with <div>
        const spans = div.querySelectorAll('span');
        spans.forEach((span) => {
            const newDiv = document.createElement('div');
            // Transfer all child nodes and attributes to the new <div>
            Array.from(span.attributes).forEach((attr) => {
                newDiv.setAttribute(attr.name, attr.value);
            });
            while (span.firstChild) {
                newDiv.appendChild(span.firstChild);
            }
            span.parentNode.replaceChild(newDiv, span);
        });

        // ❌👎don't try to uncomment this below code anymore or redo this code (this code will affect every div tags)
        // Flatten nested divs properly: <div><div>content</div></div> → <div>content</div>
        // div.querySelectorAll('div div').forEach(innerDiv => {
        //     // Ensure text-align style is not lost
        //     if (innerDiv.hasAttribute('style')) {
        //         innerDiv.parentNode.setAttribute('style', innerDiv.getAttribute('style'));
        //     }
        //     innerDiv.parentNode.replaceChild(innerDiv, innerDiv.parentNode);
        // });

        // Get the first (outermost) <div> element
        const firstDiv = div.firstElementChild;

        if (firstDiv && firstDiv.tagName.toLowerCase() === 'div') {
            // Check if the div has a text-align style
            const style = firstDiv.getAttribute('style');

            if (style && style.includes('text-align')) {
                // Preserve text-align styles but remove any other styles
                const alignValue = style.match(/text-align:\s*(left|right|center)/);
                if (alignValue) {
                    firstDiv.setAttribute('style', alignValue[0]); // Keep only text-align
                } else {
                    firstDiv.removeAttribute('style'); // If no valid text-align, remove style
                }
            } else {
                // If no style exists, set text-align to 'left' (or whatever you prefer)
                firstDiv.setAttribute('style', 'text-align: left;');
            }
        }

        // Ensure inline elements (`b`, `i`, `u`) do not remove text-align from block elements
        div.querySelectorAll('b, i, u').forEach(inlineElement => {
            inlineElement.querySelectorAll('div').forEach(blockElement => {
                const fragment = document.createDocumentFragment();

                // Retain text-align if present
                if (blockElement.hasAttribute('style')) {
                    inlineElement.setAttribute('style', blockElement.getAttribute('style'));
                }

                while (blockElement.firstChild) {
                    fragment.appendChild(blockElement.firstChild);
                }
                blockElement.replaceWith(fragment); // Replace div with its inner content
            });
        });

        if (div.innerHTML === "<br>") {
            return ""
        } else {
            return div.innerHTML; // Return sanitized HTML
        }
       
        
    }

    closeWebCamPop = () => {
        this.setState({
            imgCapClked: false,
            CapturedImg: null
        })
    }

    addImgCapture = (data) => {
        if (data) {
            const file = dataURItoFile(data, `result_image_${Date.now()}.jpg`);
            this.setState((prevState) => {
                return {
                    pdfUploadList: [...prevState.pdfUploadList, { document_file: file, document_name: file.name }],
                    imgCapClked: false
                };
            });
        }
    }

    handleKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            document.execCommand('insertHTML', false, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
        }
    };

    render() {
        let disable = false
        if (this.props.isFrom === "dischargeSummary" && this.state.disableEdit) {
            disable = true
        } else {
            disable = false
        }
        const disableBtn = (this.state.pdfUploadList?.length === 5 || this.state.status === "Completed");
        return (
            <Paper component={'div'} className={this.props.isFrom === 'dischargeSummary' ? 'discharge_Sum_inner_container' : 'rad_tst_tmp_content'} sx={{ height: this.props.overallHeight }} elevation={1}>
                <Box component={'div'} className={this.props.isFrom === 'dischargeSummary' ? 'discharge_Sum_header_container' : ''} borderBottom={'1px solid lightgray'} pl={'0.5vw'} height={'3.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={this.props.isFrom === "dischargeSummary" ? 'space-betweeen' : 'flex-start'} onMouseLeave={() => { this.setState({ isOutFocus: true }) }} onMouseOver={() => { this.setState({ isOutFocus: false }) }}>
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", width: "100%" }}>
                        <Typography fontWeight={600}>{this.props.Title}</Typography>
                        <div className="toolbar" style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }} onMouseLeave={() => { this.setState({ isOutFocus: true }) }} onMouseOver={() => { this.setState({ isOutFocus: false }) }}>
                            <ButtonGroup variant="text" aria-label="Basic button group" sx={{ visibility: this.props?.EditorDisable ? 'hidden' : "visible" }}>
                                <Tooltip title={"Bold"} placement={'top'} arrow><IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('bold')}><FormatBoldIcon color={this.state.bold ? "primary" : "black"} /></IconButton></Tooltip>
                                <Tooltip title={"Italic"} placement={'top'} arrow><IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('italic')} ><FormatItalicOutlinedIcon color={this.state.italic ? "primary" : "black"} /></IconButton></Tooltip>
                                <Tooltip title={"Underline"} placement={'top'} arrow><IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('underline')}><FormatUnderlinedOutlinedIcon color={this.state.underline ? "primary" : "black"} /></IconButton></Tooltip>
                                <Tooltip title={"Left Align"} placement={'top'} arrow><IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('justifyLeft')}><FormatAlignLeftOutlinedIcon color={this.state.justifyLeft ? "primary" : "black"} /></IconButton></Tooltip>
                                <Tooltip title={"Center Align"} placement={'top'} arrow><IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('justifyCenter')}><FormatAlignCenterOutlinedIcon color={this.state.justifyCenter ? "primary" : "black"} /></IconButton></Tooltip>
                                <Tooltip title={"Right Align"} placement={'top'} arrow><IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('justifyRight')}><FormatAlignRightOutlinedIcon color={this.state.justifyRight ? "primary" : "black"} /></IconButton></Tooltip>
                                {/* <Box sx={{ borderLeft: 1, display: 'flex', borderColor: 'grey.500'}}>
                                    <Tooltip title={"Bullet List"} placement={"top"} arrow><IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('insertUnorderedList')}><FormatListBulletedIcon color={this.state.bulletList ? "primary" : "black"} /></IconButton></Tooltip>
                                    <Tooltip title={"Numbered List"} placement={"top"} arrow><IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('insertOrderedList')}><FormatListNumberedIcon color={this.state.orderedList ? "primary" : "black"} /></IconButton></Tooltip>
                                </Box> */}
                            </ButtonGroup>
                        </div>
                    </div>
                    <Tooltip title={"Mic"} placement={"top"} arrow><IconButton disabled={disable || this.props?.EditorDisable} onClick={this.handleMicClick}><MicIcon sx={{ color: grey[1000], cursor: "pointer", visibility: this.props?.EditorDisable ? 'hidden' : "visible" }} /></IconButton></Tooltip>
                </Box>
                <Box component={'div'} borderBottom={'1px solid lightgray'} height={this.props.height}>
                    <Box
                        onMouseUp={this.getTextStylesAtCursor}
                        onSelect={this.getTextStylesAtCursor}
                        component={'div'}
                        ref={this.editorRef}
                        contentEditable={this.props?.EditorDisable ? false : true}
                        className={this.props.isFrom === "NurseNotes" ? "otherEditor":"editor"}
                        sx={{ height: this.props.EditorHeight, overflow: "scroll", minHeight: this.props?.minHeight ? this.props.minHeight : 'auto',outline:"none" }}
                        onBlur={(this.props.isFrom === "dischargeSummary" || this.props.isFrom === "NoNeedButton" || this.props.isFrom === "nurseAssessment") ? this.sendSavedData : null}
                        spellcheck="false"
                        onPaste={this.handlePaste}
                        onBeforeInput={this.handleBeforeInput}
                        onInput={this.handleInput}
                        {...(this.props.addSpaceOnTab && { onKeyDown: this.handleKeyDown })}
                    >
                    </Box>
                </Box>
                {(this.props.isFrom === "dischargeSummary" || this.props.isFrom === "CollabSummary" || this.props.isFrom === "nurseAssessment") ? null :
                    <Box display={'flex'} marginBottom={'0.5vw'} justifyContent={(this.props?.FromTestReport || (JSON.parse(localGetItem("loggedInUserInfo"))?.enable_nurse_notes_datetime && this.props.isFrom === "NurseNotes")) ? 'space-between' : 'flex-end'}
                        alignItems={'center'} sx={{ margin: "0.3vh" }}>
                        {this.props?.FromTestReport ?
                            <Box sx={{ marginLeft: '0.5vw', display: 'flex', gap: '0.5vw' }}>
                                <input
                                    type="file"
                                    multiple
                                    accept="application/pdf"
                                    ref={this.uploadPDF}
                                    id="pdfInput"
                                    style={{ display: 'none' }}
                                    onChange={this.onUploadPDF}
                                />
                                {this.state.status === "Dispatched" ? null :
                                    <Box>
                                        <Button size="small" variant="contained" disabled={disableBtn} onClick={() => this.uploadPDF.current.click()}>
                                            Upload Pdf
                                        </Button>
                                        <Button size='small' disabled={disableBtn} onClick={() => { this.setState({ imgCapClked: true }) }}>
                                            <img className='eMed_imgCap_btn' src={disableBtn ? ImagePaths.captureImgOff.default : ImagePaths.captureImg.default} alt="" />
                                        </Button>
                                    </Box>}
                                {this.state.pdfUploadList?.length > 0 ? (
                                    <Box
                                        component="div"
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        gap={1}
                                    >

                                        {/* List of uploaded files */}
                                        {this.state.pdfUploadList?.map((file, index) => (
                                            <Box key={index}  display="flex" alignItems="center" justifyContent="center" position="relative" > 
                                                {/* Icon */}
                                                <Tooltip title={file.document_name} placement="top">
                                                    <img
                                                        src={ImagePaths.DocumentGreen.default}
                                                        height={'25vw'}
                                                        width={'25vw'}
                                                        alt="document"
                                                    />
                                                </Tooltip>

                                                {/* Individual Delete Button */}
                                                {(this.state.status === "Completed" || this.state.isdispatch || this.props?.EditorDisable)
                                                    ? null
                                                    : (
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                const updatedList = [...this.state.pdfUploadList];
                                                                const deletedItem = updatedList[index];
                                                                updatedList.splice(index, 1);
                                                                const isBlobOrFile =  deletedItem?.document_file instanceof Blob || deletedItem?.document_file instanceof File || deletedItem?.url?.startsWith("blob:");; 
                                                                if (isBlobOrFile === undefined && deletedItem?.document_file) {
                                                                    this.props.deletedLineItem(deletedItem?.document_file)
                                                                }
                                                                this.setState({ pdfUploadList: updatedList });
                                                            }}
                                                            sx={{
                                                                position: 'absolute',
                                                                top: -2, 
                                                                right: -6, 
                                                                padding: 0
                                                            }}
                                                        >
                                                            <img
                                                                src={ImagePaths.CancelIcon.default}
                                                                height={'15vw'}
                                                                width={'15vw'}
                                                                alt="delete"
                                                            />
                                                        </IconButton>
                                                    )
                                                }
                                            </Box>
                                        ))}
                                    </Box>
                                ) : null}

                            </Box>
                            : (JSON.parse(localGetItem("loggedInUserInfo"))?.enable_nurse_notes_datetime && this.props.isFrom === "NurseNotes") ?
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        inputFormat='DD-MM-YYYY & hh:mm A'
                                        value={this.state.dateTime || new Date()}
                                        disabled={this.props?.EditorDisable && this.props.Title === "Nurse Notes" ? true : false}
                                        name={"dateTime"}
                                        minDate={(this.props.Title === "Nurse Notes") ? this.props.admissionDate : null}
                                        maxDate={(this.props.Title === "Nurse Notes") ? this.props.dischargeDate : null}
                                        onChange={(newDate) => {
                                            if (newDate === null) {
                                                this.setState({
                                                    dateTime: new Date()
                                                })
                                            } else {
                                                this.setState({ dateTime: newDate })
                                            }
                                        }}
                                        renderInput={(params) =>
                                            <TextField size='small'
                                                {...params}
                                                variant='standard'
                                                sx={{ marginLeft: "1vw", width: "15vw" }}
                                            />}
                                    />
                                </LocalizationProvider>
                                : null}
                        <Box component={'div'} display={'flex'}  justifyContent={'flex-end'} alignItems={'center'} height={'8vh'} visibility={(this.state.status === "Dispatched" || this.props.isFrom === "NoNeedButton") ? 'hidden' : "visible"}>
                            <Button className = "eMed_imgCap_btn" disabled={this.state.status === "Completed" || (this.props?.EditorDisable && this.props.Title === "Nurse Notes") ? true : false} variant='outlined' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }}
                                onClick={() => { 
                                    if(this.props.Title ==="Nurse Notes"){
                                        this.props.clearEditorText()
                                        this.editorRef.current.innerHTML = ""
                                        this.clearStyleState()  
                                    }
                                    this.editorRef.current.innerHTML = ""; this.setState({ pdfUploadList: [], dateTime: new Date()  }) }}
                            >Clear</Button>
                            {
                                this.props?.FromTestReport ?
                                    <Box>
                                        <Button disabled={(this.state.status === "Completed" || this.props.isSaved) ? true : false} variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }}
                                            onClick={() => { this.props.handleSaveResult(this.removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML), true, false, this.state.pdfUploadList, this.state.CapturedImg); }}
                                        >Save</Button>
                                        <Button disabled={(this.state.status === "Completed" || this.props.isSaved) ? true : (((!this?.editorRef?.current?.innerHTML && !this.props.EditorRef) || this?.editorRef?.current?.innerHTML === "<br>") && this.state.pdfUploadList?.length === 0)} variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }}
                                            onClick={() => { this.props.handlePostResult(this.removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML), false, true, this.state.pdfUploadList, this.state.CapturedImg); }}
                                        >Complete</Button>
                                        <Button disabled={this.state.status === "Completed" ? false : true} variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }}
                                            onClick={() => { this.props.handleDispatchResult(this.removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML),); }}
                                        >Dispatch</Button>
                                    </Box>
                                    :
                                    <Button variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw' }} disabled = {this.props.disableSave || false}
                                        onClick={() => {
                                            this.props.isFrom === "NurseNotes" ?
                                            this.props.handlePostdata(this.removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML),
                                                () => {this.setState({dateTime: new Date()}, () => {this.editorRef.current.innerHTML = ""; this.clearStyleState()})}, this.state.dateTime)
                                            : this.props.handlePost(this.removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML));
                                        }}
                                    >{(this.props.isFrom === "NurseNotes" || this.props.isFrom === "Doctor Notes") ? "Save" : "Complete"}</Button>
                            }

                        </Box>
                    </Box>
                }
                {this.state.listenPopUp ?
                    <VoiceToText
                        voiceTextConverter={this.voiceToTextgetter.bind(this)}
                        listenPopUp={this.listenPopUp.bind(this)}
                        micTextEditDisabled={this.props.micTextEditDisabled}
                    /> : null
                }
                {
                    this.state.imgCapClked && <OpenWebCamPopUP
                        capturedImg = {this.state.CapturedImg}
                        closePopup={this.closeWebCamPop.bind(this)}
                        addImgCapture={this.addImgCapture.bind(this)}
                    />
                }
            </Paper>
        );
    }
}
 export class NewToolsFieldWithMic extends Component {
    constructor(props) {
        super(props);
        this.editorRef = React.createRef();
        this.uploadPDF = React.createRef();
        const parsedDate = DateTime.fromFormat(String(props.date_time || ""), "dd-MM-yyyy hh:mm a").isValid
            ? DateTime.fromFormat(String(props.date_time), "dd-MM-yyyy hh:mm a").toJSDate()
            : new Date();
        this.state = {
            // toolbar state
            bold: false,
            italic: false,
            underline: false,
            justifyLeft: false,
            justifyCenter: false,
            justifyRight: false,
            bulletList: false,
            orderedList: false,

            // editor state
            disableEdit: true,
            editedContent: '',
            isOutFocus: false,

            // mic
            listenPopUp: false,
            ClickKey: false,

            // upload file
            isDisableDataDispatch: true,
            status: this.props.selectedServiceData?.result_status,
            isdispatch: this.props.isDispatchshown ? true : false,
            pdfUploadList: this.props.ResultPDF ? this.props.ResultPDF : [],
            imgCapClked: false,
            CapturedImg: null,
            dateTime: parsedDate,

            // table
            tableMenuAnchor: null,
            tableRows: 3,
            tableCols: 3,
        }
    }

    componentDidMount() {
        this.editorRef.current.innerHTML = this.props.EditorRef;
    }

    componentDidUpdate(preProps) {
        const editorRefChanged = this.props.EditorRef !== preProps.EditorRef;
        if (editorRefChanged && checkSetFrom.has(this.props.isFrom) && this.state.editedContent !== this.props.EditorRef) {
            this.editorRef.current.innerHTML = this.props.EditorRef || ''
        }
        else if (editorRefChanged && this.props.EditorRef && !this.props.isFrom) {
            this.editorRef.current.innerHTML = this.props.EditorRef || ''
        }

        // Refocus editor when listenPopUp is closed
        if (preProps.listenPopUp && !this.state.listenPopUp) {
            this.editorRef.current.focus();
        }

        if (preProps.date_time !== this.props.date_time) {
            const parsedDate = DateTime.fromFormat(String(this.props.date_time || ""), "dd-MM-yyyy hh:mm a").isValid
                ? DateTime.fromFormat(String(this.props.date_time), "dd-MM-yyyy hh:mm a").toJSDate()
                : new Date();

            this.setState({ dateTime: parsedDate });
        }
    }

    componentWillUnmount() {
        // Cleanup if needed
    }

    handleStyleChange = (command) => {
        document.execCommand(command, false, null);
        this.editorRef.current.focus();
        switch (command) {
            case 'bold': 
                this.setState({ bold: !this.state.bold })
                break
            case 'italic': 
                this.setState({ italic: !this.state.italic })
                break
            case 'underline': 
                this.setState({ underline: !this.state.underline })
                break
            case 'insertUnorderedList': 
                this.setState({ 
                    bulletList: !this.state.bulletList,
                    orderedList: false // Ensure only one list type is active
                });
                break;
            case 'insertOrderedList': 
                this.setState({ 
                    orderedList: !this.state.orderedList,
                    bulletList: false // Ensure only one list type is active
                });
                break;
            default: 
                this.setState(prevState => ({
                    justifyLeft: command === 'justifyLeft' ? !prevState["justifyLeft"] : false,
                    justifyCenter: command === 'justifyCenter' ? !prevState["justifyCenter"] : false,
                    justifyRight: command === 'justifyRight' ? !prevState['justifyRight'] : false,
                }), () => {
                    if (this.state.justifyCenter === false && this.state.justifyRight === false) {
                        this.setState({
                            justifyLeft: true
                        })
                        document.execCommand('justifyLeft', false, null);
                    }
                });
                break
        }
    };

    // Table Functions
    handleTableMenuOpen = (event) => {
        this.setState({ tableMenuAnchor: event.currentTarget });
    };

    handleTableMenuClose = () => {
        this.setState({ tableMenuAnchor: null });
    };

    handleTableInsert = () => {
        const { tableRows, tableCols } = this.state;
        this.insertTable(tableRows, tableCols);
        this.handleTableMenuClose();
    };

    insertTable = (rows, cols) => {
        const tableHTML = this.generateTableHTML(rows, cols);
        document.execCommand('insertHTML', false, tableHTML);
        this.editorRef.current.focus();
    };

    generateTableHTML = (rows, cols) => {
        let tableHTML = '<table style="border-collapse: collapse; width: 100%; margin: 10px 0; border: 1px solid #ccc;">';
        
        for (let i = 0; i < rows; i++) {
            tableHTML += '<tr>';
            for (let j = 0; j < cols; j++) {
                tableHTML += `<td style="border: 1px solid #ccc; padding: 8px; min-width: 60px; vertical-align: top;">&nbsp;</td>`;
            }
            tableHTML += '</tr>';
        }
        
        tableHTML += '</table>';
        return tableHTML;
    };

    handleTableRowsChange = (event) => {
        const value = Math.max(1, Math.min(10, parseInt(event.target.value) || 1));
        this.setState({ tableRows: value });
    };

    handleTableColsChange = (event) => {
        const value = Math.max(1, Math.min(8, parseInt(event.target.value) || 1));
        this.setState({ tableCols: value });
    };

    // Table context menu and editing functions
    showTableContextMenu = (event) => {
        // You can extend this to show context menu for table operations
        // like add row, delete row, add column, delete column, etc.
    };

    handlePaste = (event) => {
        event.preventDefault();
        const plainText = event.clipboardData.getData('text/plain');
        const normalizedText = plainText.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
        document.execCommand('insertText', false, normalizedText);
    };

    clearStyleState = () => {
        this.setState({
            disableEdit: true,
            italic: false,
            bold: false,
            underline: false,
            justifyLeft: false,
            justifyCenter: false,
            justifyRight: false,
            bulletList: false,
            orderedList: false,
        })
    }

    sendSavedData = () => {
        const removeEmptyStyleTagsAndReplaceSpan = (content) => {
            const div = document.createElement('div');
            div.innerHTML = content;

            // Iterate through all elements with style attributes
            const elements = div.querySelectorAll('*[style]');
            elements.forEach((element) => {
                const style = element.getAttribute('style');

                // Retain only `text-align` properties (center, left, right)
                const retainedStyles = style
                    .split(';')
                    .map((rule) => rule.trim())
                    .filter((rule) => {
                        const [property, value] = rule.split(':').map((item) => item.trim());
                        return (
                            property === 'text-align' &&
                            (value === 'center' || value === 'left' || value === 'right')
                        );
                    })
                    .join('; ');

                if (retainedStyles) {
                    element.setAttribute('style', retainedStyles);
                } else {
                    // Remove the style attribute if no valid styles remain
                    element.removeAttribute('style');
                }
            });

            // Replace <span> tags with <div>
            const spans = div.querySelectorAll('span');
            spans.forEach((span) => {
                const newDiv = document.createElement('div');
                // Transfer all child nodes and attributes to the new <div>
                Array.from(span.attributes).forEach((attr) => {
                    newDiv.setAttribute(attr.name, attr.value);
                });
                while (span.firstChild) {
                    newDiv.appendChild(span.firstChild);
                }
                span.parentNode.replaceChild(newDiv, span);
            });

            // Preserve table styles but clean up unnecessary styles
            const tables = div.querySelectorAll('table');
            tables.forEach((table) => {
                // Keep only essential table styles
                table.setAttribute('style', 'border-collapse: collapse; width: 100%; margin: 10px 0; border: 1px solid #ccc;');
                
                // Clean up td styles but keep borders
                const tds = table.querySelectorAll('td');
                tds.forEach((td) => {
                    td.setAttribute('style', 'border: 1px solid #ccc; padding: 8px; vertical-align: top;');
                });
            });

            // Get the first (outermost) <div> element
            const firstDiv = div.firstElementChild;

            if (firstDiv && firstDiv.tagName.toLowerCase() === 'div') {
                // Check if the div has a text-align style
                const style = firstDiv.getAttribute('style');

                if (style && style.includes('text-align')) {
                    // Preserve text-align styles but remove any other styles
                    const alignValue = style.match(/text-align:\s*(left|right|center)/);
                    if (alignValue) {
                        firstDiv.setAttribute('style', alignValue[0]); // Keep only text-align
                    } else {
                        firstDiv.removeAttribute('style'); // If no valid text-align, remove style
                    }
                } else {
                    // If no style exists, set text-align to 'left' (or whatever you prefer)
                    firstDiv.setAttribute('style', 'text-align: left;');
                }
            }

            // Ensure inline elements (`b`, `i`, `u`) do not remove text-align from block elements
            div.querySelectorAll('b, i, u').forEach(inlineElement => {
                inlineElement.querySelectorAll('div').forEach(blockElement => {
                    const fragment = document.createDocumentFragment();

                    // Retain text-align if present
                    if (blockElement.hasAttribute('style')) {
                        inlineElement.setAttribute('style', blockElement.getAttribute('style'));
                    }

                    while (blockElement.firstChild) {
                        fragment.appendChild(blockElement.firstChild);
                    }
                    blockElement.replaceWith(fragment); // Replace div with its inner content
                });
            });

            if (div.innerHTML === "<br>") {
                return ""
            } else {
                return div.innerHTML; // Return sanitized HTML
            }
        }

        if (this.state.isOutFocus) {
            this.clearStyleState();
        }

        const cleanedContent = removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML);
        this.setState({ editedContent: cleanedContent }, () => {
            // Get the editor content and clean it before saving
            if(this.props.isFrom === "NoNeedButton"){
                this.props.saveData(cleanedContent);
            }else{
                this.props.saveData(this.props.stateName, cleanedContent, this.props.postState);
            }
        });
    };

    getTextStylesAtCursor = () => {
        this.setState({
            italic: false,
            bold: false,
            underline: false,
            justifyLeft: false,
            justifyCenter: false,
            justifyRight: false,
            bulletList: false,
            orderedList: false,
            disableEdit: false,
        }, () => {
            const selection = window.getSelection();
            if (!selection.rangeCount) return null;

            const range = selection.getRangeAt(0);
            const node = range.commonAncestorContainer;
            
            // Traverse up the DOM tree to find list parents
            let currentElement = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
            while (currentElement && currentElement !== this.editorRef.current) {
                if (currentElement.tagName === 'UL') {
                    this.setState({ bulletList: true });
                    break;
                }
                if (currentElement.tagName === 'OL') {
                    this.setState({ orderedList: true });
                    break;
                }
                currentElement = currentElement.parentElement;
            }

            const textNode = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
            const computedStyle = window.getComputedStyle(textNode);

            const textStyle = {
                fontWeight: computedStyle.fontWeight,
                fontStyle: computedStyle.fontStyle,
                textDecoration: computedStyle.textDecoration,
                textAlign: computedStyle.textAlign
            };

            if (textStyle.fontStyle === "italic" || document.queryCommandState('italic')) {
                this.setState({ italic: true });
            }
            if (textStyle.fontWeight === '700' || document.queryCommandState('bold')) {
                this.setState({ bold: true });
            }
            if (textStyle.textDecoration.includes("underline") || document.queryCommandState('underline')) {
                this.setState({ underline: true });
            }
            if (textStyle.textAlign === 'left') {
                this.setState({ justifyLeft: true });
            }
            if (textStyle.textAlign === 'center') {
                this.setState({ justifyCenter: true });
            }
            if (textStyle.textAlign === 'right') {
                this.setState({ justifyRight: true });
            }
        })
    }

    // mic
    listenPopUp = () => {
        this.setState({
            listenPopUp: false,
        });
    };

    voiceToTextgetter = (textStorage) => {
        if (textStorage !== '') {
            if (this.state.ClickKey) {
                // Append or insert the text into the editor's content
                const newContent = this.props.EditorRef + " " + textStorage;
                this.setState({ editedContent: newContent }, () => {
                    setTimeout(() => {
                        if (this.editorRef.current) {
                            this.editorRef.current.innerHTML = newContent;

                            // Ensure contentEditable is active and force focus
                            this.editorRef.current.setAttribute("contentEditable", "true");
                            this.editorRef.current.focus();

                            // Optionally ensure the cursor is at the end of the content
                            const range = document.createRange();
                            const sel = window.getSelection();
                            range.selectNodeContents(this.editorRef.current);
                            range.collapse(false);
                            sel.removeAllRanges();
                            sel.addRange(range);
                        }
                    }, 0);
                });
            }
        }
    };

    handleMicClick = () => {
        this.setState({ ClickKey: true, listenPopUp: true, isOutFocus: true });
    };

     onUploadPDF = async (event) => {
         const fileList = Array.from(event.target.files);
         let finallist = [];
         let processedCount = 0;

         if (!fileList.length) {
             this.props.errorMsg("No file selected.");
             return;
         }

         fileList.forEach((file) => {
             if (!file) {
                 this.props.errorMsg("No file selected.");
                 return;
             }

             const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/webp'];
             if (!allowedTypes.includes(file.type)) {
                 this.props.errorMsg("Only image files are allowed (JPEG, JPG, PNG, GIF, BMP, WEBP).");
                 return;
             }

             const maxSize = 3 * 1024 * 1024; // 3 MB
             if (file.size > maxSize) {
                 this.props.errorMsg("File size exceeds 3 MB.");
                 return;
             }

             const reader = new FileReader();
             reader.onload = (event) => {
                 const arrayBuffer = event.target.result;
                 const blob = new Blob([arrayBuffer], { type: file.type });
                 finallist.push({
                     document_file: blob,
                     document_name: file.name
                 });

                 processedCount++;

                 if (processedCount === fileList.length) {
                     this.setState({
                         pdfUploadList: [...this.state.pdfUploadList, ...finallist],
                     });
                     this.uploadPDF.current.value = "";
                 }
             };

             reader.onerror = () => {
                 this.props.errorMsg("Error reading the file.");
                 processedCount++;

                 if (processedCount === fileList.length && finallist.length > 0) {
                     this.setState({
                         pdfUploadList: [...this.state.pdfUploadList, ...finallist],
                     });
                     this.uploadPDF.current.value = "";
                 }
             };

             reader.readAsArrayBuffer(file);
         });
     }

    arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    };

    removeEmptyStyleTagsAndReplaceSpan = (content) => {
        const div = document.createElement('div');
        div.innerHTML = content;

        // Iterate through all elements with style attributes
        const elements = div.querySelectorAll('*[style]');
        elements.forEach((element) => {
            const style = element.getAttribute('style');

            // Retain only `text-align` properties (center, left, right)
            const retainedStyles = style
                .split(';')
                .map((rule) => rule.trim())
                .filter((rule) => {
                    const [property, value] = rule.split(':').map((item) => item.trim());
                    return (
                        property === 'text-align' &&
                        (value === 'center' || value === 'left' || value === 'right')
                    );
                })
                .join('; ');

            if (retainedStyles) {
                element.setAttribute('style', retainedStyles);
            } else {
                // Remove the style attribute if no valid styles remain
                element.removeAttribute('style');
            }
        });

        // Replace <span> tags with <div>
        const spans = div.querySelectorAll('span');
        spans.forEach((span) => {
            const newDiv = document.createElement('div');
            // Transfer all child nodes and attributes to the new <div>
            Array.from(span.attributes).forEach((attr) => {
                newDiv.setAttribute(attr.name, attr.value);
            });
            while (span.firstChild) {
                newDiv.appendChild(span.firstChild);
            }
            span.parentNode.replaceChild(newDiv, span);
        });

        // Preserve table styles
        const tables = div.querySelectorAll('table');
        tables.forEach((table) => {
            table.setAttribute('style', 'border-collapse: collapse; width: 100%; margin: 10px 0; border: 1px solid #ccc;');
            
            const tds = table.querySelectorAll('td');
            tds.forEach((td) => {
                td.setAttribute('style', 'border: 1px solid #ccc; padding: 8px; vertical-align: top;');
            });
        });

        // Get the first (outermost) <div> element
        const firstDiv = div.firstElementChild;

        if (firstDiv && firstDiv.tagName.toLowerCase() === 'div') {
            // Check if the div has a text-align style
            const style = firstDiv.getAttribute('style');

            if (style && style.includes('text-align')) {
                // Preserve text-align styles but remove any other styles
                const alignValue = style.match(/text-align:\s*(left|right|center)/);
                if (alignValue) {
                    firstDiv.setAttribute('style', alignValue[0]); // Keep only text-align
                } else {
                    firstDiv.removeAttribute('style'); // If no valid text-align, remove style
                }
            } else {
                // If no style exists, set text-align to 'left' (or whatever you prefer)
                firstDiv.setAttribute('style', 'text-align: left;');
            }
        }

        // Ensure inline elements (`b`, `i`, `u`) do not remove text-align from block elements
        div.querySelectorAll('b, i, u').forEach(inlineElement => {
            inlineElement.querySelectorAll('div').forEach(blockElement => {
                const fragment = document.createDocumentFragment();

                // Retain text-align if present
                if (blockElement.hasAttribute('style')) {
                    inlineElement.setAttribute('style', blockElement.getAttribute('style'));
                }

                while (blockElement.firstChild) {
                    fragment.appendChild(blockElement.firstChild);
                }
                blockElement.replaceWith(fragment); // Replace div with its inner content
            });
        });

        if (div.innerHTML === "<br>") {
            return ""
        } else {
            return div.innerHTML; // Return sanitized HTML
        }
    }

    closeWebCamPop = () => {
        this.setState({
            imgCapClked: false,
            CapturedImg: null
        })
    }

    addImgCapture = (data) => {
       if(data){
        this.setState({
            CapturedImg: data,
            imgCapClked: false
        })
       }  
    }

    handleKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            document.execCommand('insertHTML', false, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
        }
    };

    render() {
        let disable = false
        if (this.props.isFrom === "dischargeSummary" && this.state.disableEdit) {
            disable = true
        } else {
            disable = false
        }
        const disableBtn = (this.state.status === "Completed" || this.state.CapturedImg);
        
        return (
            <Paper component={'div'} className={this.props.isFrom === 'dischargeSummary' ? 'discharge_Sum_inner_container' : 'rad_tst_tmp_content'} sx={{ height: this.props.overallHeight }} elevation={1}>
                <Box component={'div'} className={this.props.isFrom === 'dischargeSummary' ? 'discharge_Sum_header_container' : ''} borderBottom={'1px solid lightgray'} pl={'0.5vw'} height={'3.5vw'} display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={this.props.isFrom === "dischargeSummary" ? 'space-betweeen' : 'flex-start'} onMouseLeave={() => { this.setState({ isOutFocus: true }) }} onMouseOver={() => { this.setState({ isOutFocus: false }) }}>
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", width: "100%" }}>
                        <Typography fontWeight={600}>{this.props.Title}</Typography>
                        <div className="toolbar" style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }} onMouseLeave={() => { this.setState({ isOutFocus: true }) }} onMouseOver={() => { this.setState({ isOutFocus: false }) }}>
                            <ButtonGroup variant="text" aria-label="Basic button group" sx={{ visibility: this.props?.EditorDisable ? 'hidden' : "visible" }}>
                                <Tooltip title={"Bold"} placement={'top'} arrow>
                                    <IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('bold')}>
                                        <FormatBoldIcon color={this.state.bold ? "primary" : "black"} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={"Italic"} placement={'top'} arrow>
                                    <IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('italic')}>
                                        <FormatItalicOutlinedIcon color={this.state.italic ? "primary" : "black"} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={"Underline"} placement={'top'} arrow>
                                    <IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('underline')}>
                                        <FormatUnderlinedOutlinedIcon color={this.state.underline ? "primary" : "black"} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={"Left Align"} placement={'top'} arrow>
                                    <IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('justifyLeft')}>
                                        <FormatAlignLeftOutlinedIcon color={this.state.justifyLeft ? "primary" : "black"} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={"Center Align"} placement={'top'} arrow>
                                    <IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('justifyCenter')}>
                                        <FormatAlignCenterOutlinedIcon color={this.state.justifyCenter ? "primary" : "black"} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title={"Right Align"} placement={'top'} arrow>
                                    <IconButton disabled={disable || this.props?.EditorDisable} onClick={() => this.handleStyleChange('justifyRight')}>
                                        <FormatAlignRightOutlinedIcon color={this.state.justifyRight ? "primary" : "black"} />
                                    </IconButton>
                                </Tooltip>
                                
                                {/* List Buttons */}
                                <Box sx={{ borderLeft: 1, display: 'flex', borderColor: 'grey.500', ml: 1, pl: 1 }}>
                                    <Tooltip title={"Bullet List"} placement={"top"} arrow>
                                        <IconButton 
                                            disabled={disable || this.props?.EditorDisable} 
                                            onClick={() => this.handleStyleChange('insertUnorderedList')}
                                        >
                                            <FormatListBulletedIcon color={this.state.bulletList ? "primary" : "black"} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={"Numbered List"} placement={"top"} arrow>
                                        <IconButton 
                                            disabled={disable || this.props?.EditorDisable} 
                                            onClick={() => this.handleStyleChange('insertOrderedList')}
                                        >
                                            <FormatListNumberedIcon color={this.state.orderedList ? "primary" : "black"} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>

                                {/* Table Button */}
                                <Box sx={{ borderLeft: 1, display: 'flex', borderColor: 'grey.500', ml: 1, pl: 1 }}>
                                    <Tooltip title={"Insert Table"} placement={"top"} arrow>
                                        <IconButton 
                                            disabled={disable || this.props?.EditorDisable} 
                                            onClick={this.handleTableMenuOpen}
                                        >
                                            <TableChartIcon color="black" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </ButtonGroup>
                        </div>
                    </div>
                    <Tooltip title={"Mic"} placement={"top"} arrow>
                        <IconButton disabled={disable || this.props?.EditorDisable} onClick={this.handleMicClick}>
                            <MicIcon sx={{ color: grey[1000], cursor: "pointer", visibility: this.props?.EditorDisable ? 'hidden' : "visible" }} />
                        </IconButton>
                    </Tooltip>
                </Box>

                {/* Table Insert Menu */}
                <Menu
                    anchorEl={this.state.tableMenuAnchor}
                    open={Boolean(this.state.tableMenuAnchor)}
                    onClose={this.handleTableMenuClose}
                    PaperProps={{
                        style: {
                            padding: '16px',
                            minWidth: '200px',
                        },
                    }}
                >
                    <MenuItem disabled>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Insert Table
                        </Typography>
                    </MenuItem>
                    <MenuItem >
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={6}>
                                <Typography variant="body2">Rows:</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    type="number"
                                    size="small"
                                    value={this.state.tableRows}
                                    onChange={this.handleTableRowsChange}
                                    inputProps={{ 
                                        min: 1, 
                                        max: 10,
                                        style: { padding: '8px' }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </MenuItem>
                    <MenuItem>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={6}>
                                <Typography variant="body2">Columns:</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    type="number"
                                    size="small"
                                    value={this.state.tableCols}
                                    onChange={this.handleTableColsChange}
                                    inputProps={{ 
                                        min: 1, 
                                        max: 8,
                                        style: { padding: '8px' }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </MenuItem>
                    <MenuItem onClick={this.handleTableInsert}>
                        <Button variant="contained" fullWidth>
                            Insert Table ({this.state.tableRows}x{this.state.tableCols})
                        </Button>
                    </MenuItem>
                </Menu>

                <Box component={'div'} borderBottom={'1px solid lightgray'} height={this.props.height}>
                    <Box
                        onMouseUp={this.getTextStylesAtCursor}
                        onSelect={this.getTextStylesAtCursor}
                        component={'div'}
                        ref={this.editorRef}
                        contentEditable={this.props?.EditorDisable ? false : true}
                        className={this.props.isFrom === "NurseNotes" ? "otherEditor":"editor"}
                        sx={{ 
                            height: this.props.EditorHeight, 
                            overflow: "scroll", 
                            minHeight: this.props?.minHeight ? this.props.minHeight : 'auto', 
                            outline: "none",
                            padding: '8px',
                            '& ul, & ol': {
                                margin: 0,
                                paddingLeft: '24px'
                            },
                            '& li': {
                                marginBottom: '2px'
                            },
                            '& table': {
                                borderCollapse: 'collapse',
                                width: '100%',
                                margin: '10px 0',
                                border: '1px solid #ccc'
                            },
                            '& td': {
                                border: '1px solid #ccc',
                                padding: '8px',
                                minWidth: '60px',
                                verticalAlign: 'top'
                            },
                            '& th': {
                                border: '1px solid #ccc',
                                padding: '8px',
                                backgroundColor: '#f5f5f5',
                                fontWeight: 'bold',
                                textAlign: 'left'
                            }
                        }}
                        onBlur={(this.props.isFrom === "dischargeSummary" || this.props.isFrom === "nurseAssessment" || this.props.isFrom === "NoNeedButton") ? this.sendSavedData : null}
                        spellCheck="false"
                        onPaste={this.handlePaste}
                        {...(this.props.addSpaceOnTab && { onKeyDown: this.handleKeyDown })}
                    >
                    </Box>
                </Box>
                <Box>
                {(this.props.isFrom === "dischargeSummary" || this.props.isFrom === "CollabSummary" || this.props.isFrom === "nurseAssessment") ? null :
                    <Box display={'flex'} justifyContent={(this.props?.FromTestReport || (JSON.parse(localStorage.getItem("loggedInUserInfo"))?.enable_nurse_notes_datetime && this.props.isFrom === "NurseNotes")) ? 'space-between' :'flex-end'}
                        alignItems={'center'} sx={{ margin: "0.3vh" }}>
                        {this.props?.FromTestReport ?
                            <Box sx={{ marginLeft: '0.5vw', display: 'flex', gap: '0.5vw' }}>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={this.uploadPDF}
                                    id="pdfInput"
                                    style={{ display: 'none' }}
                                    onChange={this.onUploadPDF}
                                    multiple
                                />
                                {this.state.status === "Dispatched" ? null :
                                    <Box>
                                        <Button size="small" variant="contained" disabled={disableBtn} onClick={() => this.uploadPDF.current.click()}>
                                            {/* Upload Pdf */}
                                            Upload Image
                                        </Button>
                                        <Button size='small' disabled={disableBtn} onClick = {() => {this.setState({imgCapClked: true})}}>
                                            <img className='eMed_imgCap_btn' src={disableBtn ? ImagePaths.captureImgOff.default : ImagePaths.captureImg.default} alt="" />
                                        </Button>
                                    </Box>}                                
                            </Box>
                            : (JSON.parse(localStorage.getItem("loggedInUserInfo"))?.enable_nurse_notes_datetime && this.props.isFrom === "NurseNotes") ?
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        inputFormat='DD-MM-YYYY & hh:mm A'
                                        value={this.state.dateTime || new Date()}
                                        name={"dateTime"}
                                        minDate={(this.props.Title === "Nurse Notes") ? this.props.admissionDate : null}
                                        maxDate={(this.props.Title === "Nurse Notes") ? this.props.dischargeDate : null}
                                        onChange={(newDate) => {
                                            if (newDate === null) {
                                                this.setState({
                                                    dateTime: new Date()
                                                })
                                            } else {
                                                this.setState({ dateTime: newDate })
                                            }
                                        }}
                                        renderInput={(params) =>
                                            <TextField size='small'
                                                {...params}
                                                variant='standard'
                                                sx={{ marginLeft: "1vw", width: "15vw" }}
                                            />}
                                    />
                                </LocalizationProvider>
                                : null}
                        <Box component={'div'} display={'flex'}  justifyContent={'flex-end'} alignItems={'center'} height={'8vh'} visibility={(this.state.status === "Dispatched" || this.props.isFrom === "NoNeedButton") ? 'hidden' : "visible"}>
                            <Button className = "eMed_imgCap_btn" disabled={this.state.status === "Completed" ? true : false} variant='outlined' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw',mb: '1.5vw' }}
                                onClick={() => { 
                                    if(this.props.Title ==="Nurse Notes"){
                                        this.props.clearEditorText()
                                        this.editorRef.current.innerHTML = ""
                                    }
                                    this.editorRef.current.innerHTML = ""; this.setState({ pdfUploadList: [] }) }}
                            >Clear</Button>
                            {
                                this.props?.FromTestReport ?
                                    <Box>
                                        <Button disabled={this.state.status === "Completed" ? true : false} variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw', mb: '1.5vw' }}
                                            onClick={() => { this.props.handleSaveResult(this.removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML), true, false, this.state.pdfUploadList, this.state.CapturedImg); }}
                                        >Save</Button>
                                        <Button disabled={this.state.status === "Completed" ? true : ((!this?.editorRef?.current?.innerHTML || this?.editorRef?.current?.innerHTML === "<br>") && this.state.pdfUploadList?.length === 0)} variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw', marginBottom: '1.5vw' }}
                                            onClick={() => { this.props.handlePostResult(this.removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML), false, true, this.state.pdfUploadList, this.state.CapturedImg); }}
                                        >Complete</Button>
                                        <Button disabled={this.state.status === "Completed" ? false : true} variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw', mb: '1.5vw' }}
                                            onClick={() => { this.props.handleDispatchResult(this.removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML),); }}
                                        >Dispatch</Button>
                                    </Box>
                                    :
                                    <Button variant='contained' sx={{ textTransform: 'capitalize', height: '2vw', mr: '1vw', marginBottom: '1.5vw' }}
                                        disabled = {this.props.disableSave || false}
                                        onClick={() => {
                                            this.props.isFrom === "NurseNotes" ?
                                            this.props.handlePostdata(this.removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML),
                                                () => {this.setState({dateTime: new Date()}, () => {this.editorRef.current.innerHTML = ""})}, this.state.dateTime)
                                            : this.props.handlePost(this.removeEmptyStyleTagsAndReplaceSpan(this.editorRef.current.innerHTML));
                                        }}
                                    >{(this.props.isFrom === "NurseNotes" || this.props.isFrom === "Doctor Notes") ? "Save" : "Complete"}</Button>
                            }
                        </Box>
                    </Box>
                }
                </Box>
                <Box>
                    {
                        this.state.pdfUploadList?.length > 0 ? (
                            <Box
                                component={'div'}
                                sx={{
                                    display: 'flex',
                                    maxHeight: '150px',
                                    overflowY: 'auto',
                                    padding: '5px',
                                }}
                            >
                                {this.state.pdfUploadList.map((fileDetails, index) => (
                                    <Box
                                        key={index}
                                        display={'flex'}
                                        alignItems={'center'}
                                        justifyContent={'space-between'}
                                        sx={{ minWidth: 0, padding: '2px 0' }}
                                    >
                                        <Typography
                                            color={'#04B7B1'}
                                            display={'flex'}
                                            alignItems={'center'}
                                            sx={{ flexShrink: 1, minWidth: 0, overflow: 'hidden' }}
                                        >
                                            📄
                                            {fileDetails?.document_name ? (
                                                fileDetails.document_name.length > 23 ? (
                                                    <Tooltip title={fileDetails.document_name} placement='top'>
                                                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            {fileDetails.document_name.slice(0, 20) + '...'}
                                                        </div>
                                                    </Tooltip>
                                                ) : (
                                                    fileDetails.document_name
                                                )
                                            ) : ('-')}
                                        </Typography>
                                        {(this.state.status === "Completed" || this.state.isdispatch || this.props?.EditorDisable) ? null :
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    this.setState(prevState => ({
                                                        pdfUploadList: prevState.pdfUploadList.filter((_, i) => i !== index)
                                                    }));
                                                }}
                                                sx={{ padding: '4px', marginRight: '5px' }}
                                            >
                                                ✕
                                            </IconButton>
                                        }

                                    </Box>
                                ))}
                            </Box>
                        ) : (
                            this.state.CapturedImg ?
                                <Box component={'div'} justifyContent={'center'} alignItems={'center'}>
                                    <Typography color={'#04B7B1'} flexDirection={'column'} alignItems={'center'}>
                                        📄 result_document.jpg
                                    </Typography>
                                    {(this.state.status === "Completed" || this.state.isdispatch || this.props?.EditorDisable) ? null :
                                        <IconButton onClick={() => { this.setState({ CapturedImg: null }) }}>
                                            ✕
                                        </IconButton>}
                                </Box>
                                : null
                        )
                    }
                </Box>
                {this.state.listenPopUp ?
                    <VoiceToText
                        voiceTextConverter={this.voiceToTextgetter.bind(this)}
                        listenPopUp={this.listenPopUp.bind(this)}
                        micTextEditDisabled={this.props.micTextEditDisabled}
                    /> : null
                }
                {
                    this.state.imgCapClked && <OpenWebCamPopUP
                        capturedImg = {this.state.CapturedImg}
                        closePopup={this.closeWebCamPop.bind(this)}
                        addImgCapture={this.addImgCapture.bind(this)}
                    />
                }
            </Paper>
        );
    }
}

export class OpenWebCamPopUP extends Component {
    constructor(props) {
        super(props);
        this.webcamRef = React.createRef();
        this.state = {
            isFrontCamera: true,
            devices: [],
            facingMode: 'user',
            tempCaptureImg: null,
            captureImg: null,
        }
    }
    componentDidMount() {
        this.getConnectedDevices();
    }
    getConnectedDevices = () => {
        navigator.mediaDevices.enumerateDevices()
            .then(devices => {
                const videoDevices = devices?.filter(device => device.kind === 'videoinput');
                this.setState({
                    devices: videoDevices,
                });
            })
            .catch(error => {
                console.error('Error enumerating devices:', error);
            });
    }
    videoConstraints = () => ({
        facingMode: this.state.isFrontCamera ? 'user' : 'environment',
    });

    toggleCameraButton = () => {
        this.setState((prevState) => ({
            isFrontCamera: !prevState.isFrontCamera,
            tempCaptureImg: null
        }), () => { this.videoConstraints() })
    }
    render() {
        return (
            <Box>
                <Modal open={true}>
                    <Box className="eMed_WebCamPop_Main">
                        <Box component={'div'} className="eMed_WebCam_Header">
                            <Typography variant='h6'>{"Capture Image"}</Typography>
                            <Button onClick={() => {
                                this.setState({
                                    tempCaptureImg: this.props.capturedImg
                                }, () => { this.props.closePopup() })
                            }} >
                                <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                            </Button>
                        </Box>
                        <Box component={'div'}>
                            {
                                this.state.tempCaptureImg === null ?
                                    <Webcam
                                        className='eMed_WebCam_Div'
                                        audio={false}
                                        mirrored={this.state.isFrontCamera}
                                        ref={this.webcamRef}
                                        screenshotFormat="image/jpeg"
                                        videoConstraints={this.videoConstraints()}
                                    /> :
                                    <img className='eMed_WebCam_Img_Div' src={this.state.tempCaptureImg} />
                            }
                        </Box>
                        <Box component={'div'} className="eMed_WebCam_Btn_div" width={"70%"} mr={"3vw"} ml={"7vw"}>
                            <Button disabled={this.state.tempCaptureImg !== null} variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ tempCaptureImg: this.webcamRef.current.getScreenshot() }) }}>Capture</Button>
                            <Button variant='contained' size='small' id="eMed_Config_btn" onClick={() => { this.setState({ tempCaptureImg: null }) }}>Retake</Button>
                            <Button disabled={this.state.tempCaptureImg === null} variant='contained' size='small' id="eMed_Config_btn"
                                onClick={() => { this.props.addImgCapture(this.state.tempCaptureImg) }}>
                                Add Image</Button>
                            {this.state.devices?.length > 1 && <Button variant='contained' size='small' id="eMed_Config_btn" sx={{ width: '10.5vw' }} onClick={() => { this.toggleCameraButton() }} >
                                Switch to {this.state.isFrontCamera ? "Back" : "Front"} Camera
                            </Button>}
                        </Box>
                    </Box>
                </Modal>
            </Box>
        );
    }
}

export class PovEditPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            povEditTxt: this.props.povEditText,
            povData: this.props.povData,
            povList: [],
            isBtnClked: false,
        }
    }

    componentDidMount = () => {
        const pov_list = JSON.parse(localGetItem("PurposeOfVisit") || '[]');
        const arr = [...new Set(pov_list.map(item => item.reason))];

        if (arr.length) {
            this.setState({ povList: arr });
        }
    }

    closePopup = () => {
        this.props.AlertPopupClose();
    };

    btnDisable = (flag) => {
        this.setState({
            isBtnClked: flag
        });
    };

    postPovChange = () => {
        let { povData, povEditTxt } = this.state
        let clinicId = localGetItem('SelectedDoctorClinicId');
        if (CommonValidation.removeSpace(povEditTxt) !== "") {
            let datas = {
                "purpose_of_visit": CommonValidation.removeSpace(povEditTxt),
                "appointment_id": povData.appointment_id
            }
            if (clinicId) {
                datas["clinic_id"] = clinicId;
            }

            try {
                this.btnDisable(true);
                RestAPIService.create(datas, Serviceurls.FO_HOME_OP_POV_UPDATE)
                    .then(response => {
                        if (response.data.status === "success") {
                            this.closePopup();
                            this.props.getTableData();
                            this.btnDisable(false);
                            this.props.successMsg(response.data.message);
                        }
                    })
                    .catch(error => {
                        if (error?.response?.data?.status === "fail") {
                            this.btnDisable(false);
                            this.props.errorMsg(error.response.data.message);
                        }
                    });
            } catch (e) {
                this.btnDisable(false);
                this.props.errorMsg(e.message);
            }
        }
    }

    render() {
        let testID = this.props.testID ? this.props.testID : "test";
        let { povList, povEditTxt } = this.state;
        return (
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div className="eMed_DialogBox_Title" style={{ padding: '0.5dvw' }}>
                    <div>{"Change Purpose Of Visit"}</div>
                    <div className="eMed_DialogBox_Close">
                        <img emed_tid={`povPop_${testID}_close`} className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={this.closePopup} />
                    </div>
                </div>
                <DialogContent sx={{ width: "30dvw" }}>
                    <Autocomplete
                        inputProps={{ maxLength: 250 }}
                        options={povList}
                        getOptionLabel={(options) => options}
                        onChange={(e, value) => {
                            this.setState({
                                povEditTxt: value
                            })
                        }}
                        clearIcon={false}
                        size='small'
                        sx={{ width: '26dvw' }}
                        value={povEditTxt}
                        renderInput={(params) => <TextField
                            sx={{ width: "26dvw" }}
                            autoComplete="off"
                            onChange={(event) => {
                                this.setState({
                                    povEditTxt: event.target.value
                                })
                            }}
                            {...params}
                            placeholder="Purpose Of Visit *"
                        />}
                    />
                </DialogContent>
                <DialogActions id="eMed_DialogBox_Btn">
                    <Button emed_tid={`povPop_${testID}_cancel`} size="small"
                        variant="outlined" id="eMed_Dia_Btn"
                        onClick={this.closePopup}>
                        Cancel
                    </Button>
                    <Button emed_tid={`povPop_${testID}_change`}
                        disabled={this.state.isBtnClked} size="small"
                        variant="contained" id="eMed_Dia_Btn" onClick={() => {
                            this.postPovChange();
                        }}>
                        Change
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}
export class NewCommonPatientDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const StyledBadge = styled(Badge)(({ theme }) => ({
            '& .MuiBadge-badge': {
                backgroundColor: 'red',
                color: 'red',
                boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
                '&::after': {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    animation: 'ripple 1.2s infinite ease-in-out',
                    border: '1px solid currentColor',
                    content: '""',
                },
            },
            '@keyframes ripple': {
                '0%': {
                    transform: 'scale(.8)',
                    opacity: 1,
                },
                //   '100%': {
                //     transform: 'scale(2.4)',
                //     opacity: 0,
                //   },
            },
        }));
        const { data } = this.props
        let fullName = this.props.fromPurchase ? `${data.first_name} ${data.last_name}` : data?.login_fname + " " + data?.login_lname;
        let admission_date = data?.admission_date ? formatDate(data?.admission_date) : data?.approx_check_in_date ? formatDate(data?.approx_check_in_date) : data?.appointment_date ? formatDate(data?.appointment_date) : "-";
        let surgery_date = data?.surgery_date ? formatDate(data?.surgery_date) : "-";
        let admissionDetails = `${admission_date} | ${data?.admission_time ? data?.admission_time : "-"}`
        let SurgeryDetails = `${surgery_date} | ${data?.surgery_time ? this.props.isFromOTList === true ? timeOnlyConvert(data?.surgery_time) : data?.surgery_time : "-"}`
        let PatientAccNumber = data?.patient_account_numbers ? data?.patient_account_numbers : data?.patient_account_number ? data?.patient_account_number : data?.uhid ? data?.uhid : data?.patient_acc_no ? data?.patient_acc_no : data?.patient_uhid ? data?.patient_uhid : data?.patient__patient_account_number ? data?.patient__patient_account_number : "-";
        let photo_url = data?.patient_photo_url || data?.photo_url;
        let patient_name = data?.patient_name ? data?.patient_name : data?.first_name ? data?.first_name : data?.patient_names ? data?.patient_names : data?.name ? data?.name : "-";
        let mobile_number = data?.patient_mobile_number || data?.patient__mobile_number || data?.mobile_number || data?.patients_mobile_number || data?.patient_mobile_no || data?.patients_mobile;
        let patient_age = data?.patient_age?.toString()?.includes("Y") ? data?.patient_age : data?.age?.toString()?.includes("Y") ? data?.age : data?.patient_age_str;
        let patient_gender = data?.patient_gender || data?.gender || data?.patient__gender;
        let whatGender = ((data?.patient_gender === 'Male' || data?.patient_gender === 'm' || data?.gender === "m" || data?.gender === "M" || data?.gender === 'Male' || data?.patient__gender === "m") ? "M" : (data?.patient_gender === 'Female' || data?.patient_gender === 'f' || data?.gender === "f" || data?.gender === "Female" || data?.gender === "F" || data?.patient__gender === "f") ? "F" : (data?.patient_gender === "Trans" || data?.patient_gender === 't' || data?.gender === "t" || data?.gender === "T" || data?.patient__gender === "t") ? "T" : "-");
        let branchName = data?.branch_name ? data?.branch_name : null
        return (
            <div className="eMed_Com_Patient_Details">
                {this.props.disablePhoto ? null :
                    <div>
                        {this.props.fromUserAccess ?
                            <div className="eMed_Com_Patient_Avatar">
                                {data?.comments ?
                                    <Tooltip title={data?.comments} placement="top" arrow>
                                        <StyledBadge
                                            overlap="circular"
                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            variant="dot"
                                        >
                                            <img className="eMed_Com_Patient_AvaIcon" style={{ borderColor: (data?.patient_type === "new_patient" || data?.patient__patient_type === 1) ? "#F1584A" : (data?.patient_type === "old_patient") || (data?.patient_type === "establish_patient") || (data?.patient__patient_type === 3) ? "#800080" : '#29B6F6' }}
                                                src={data?.user_image ? data?.user_image : ImagePaths.Male.default} alt={'Avatar'} />
                                        </StyledBadge></Tooltip> :
                                    <img className="eMed_Com_Patient_AvaIcon" style={{ borderColor: (data?.patient_type === "new_patient" || data?.patient__patient_type === 1) ? "#F1584A" : (data?.patient_type === "old_patient") || (data?.patient_type === "establish_patient") || (data?.patient__patient_type === 3) ? "#800080" : '#29B6F6' }}
                                        src={data?.user_image ? data?.user_image : ImagePaths.Male.default} alt={'Avatar'} />}
                            </div> :
                            <div className="eMed_Com_Patient_Avatar">
                                {data?.comments ?
                                    <Tooltip title={data?.comments} placement="top" arrow>
                                        <StyledBadge
                                            overlap="circular"
                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            variant="dot"
                                        >
                                            <img className="eMed_Com_Patient_AvaIcon" style={{ borderColor: (data?.patient_type === "new_patient" || data?.patient__patient_type === 1) ? "#F1584A" : (data?.patient_type === "old_patient") || (data?.patient_type === "establish_patient") || (data?.patient__patient_type === 3) ? "#800080" : '#29B6F6' }}
                                                src={photo_url === null || photo_url === "" || photo_url === undefined ? data?.patient_gender === "Male" || data?.patient_gender === "m" || data?.gender === "m" || data?.gender === "Male" ? ImagePaths.Male.default : ImagePaths.Female.default : photo_url} alt={'Avatar'} />
                                        </StyledBadge></Tooltip> :
                                    <img className="eMed_Com_Patient_AvaIcon" style={{ borderColor: (data?.patient_type === "new_patient" || data?.patient__patient_type === 1) ? "#F1584A" : (data?.patient_type === "old_patient") || (data?.patient_type === "establish_patient") || (data?.patient__patient_type === 3) ? "#800080" : '#29B6F6' }}
                                        src={photo_url === null || photo_url === "" || photo_url === undefined ? data?.patient_gender === "Male" || data?.patient_gender === "m" || data?.gender === "m" || data?.gender === "Male" ? ImagePaths.Male.default : ImagePaths.Female.default : photo_url} alt={'Avatar'} />}
                            </div>}
                    </div>
                }
                <div>
                    <Box component={'div'} className="eMed_Pateint_Detail_LongData">
                        {this.props.fromUserAccess ?
                            <Box component={'div'}>
                                <Typography component={'div'}>
                                    {(fullName?.length) > 20 ?
                                        <Tooltip title={fullName} placement={'top'}>
                                            <div><Typography id='eMed_Com_Patient_Name' style={{ fontSize: this.props.packageDetail ? "1.25vw" : "0.8vw" }}>{((fullName) ? ((fullName.slice(0, 20) + '...')) : '-')}</Typography>
                                            </div></Tooltip> : <Typography id='eMed_Com_Patient_Name' style={{ fontSize: this.props.packageDetail ? "1.25vw" : "0.8vw" }}>{(fullName ? fullName : '-')}</Typography>}
                                </Typography>
                                <Typography id='eMed_Com_Patient_UhidText'>{(data?.phone_number ? data?.phone_number : "-")}</Typography>
                            </Box> :
                            <Box component={'div'}>
                                <Typography component={'div'}>
                                    {(patient_name?.length) > 20 ?
                                        <Tooltip title={patient_name} placement={'top'} arrow>
                                            <div style={{ display: "flex", flexDirection: "row" }}>
                                                <Typography id='eMed_Com_Patient_Name' style={{ fontSize: this.props.packageDetail ? "1.25vw" : "0.8vw" }}>{(patient_name ? ((patient_name?.slice(0, 20) + '...')) : '-') + ' ' + (patient_age ? patient_age : '-') + '/' + (patient_gender ? whatGender : '-')}</Typography>
                                                {this.props.icon ? <div style={{ marginLeft: "0.5vw" }}>
                                                    {whatGender === "M" ? <MaleIcon sx={{ fontSize: "1vw", color: '#616161' }} /> : whatGender === "F" ? <FemaleIcon sx={{ fontSize: "1vw", color: '#616161' }} /> : null}
                                                </div> : null}
                                            </div>
                                        </Tooltip> :
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            <Typography id='eMed_Com_Patient_Name' style={{ fontSize: this.props.packageDetail ? "1.25vw" : "0.8vw" }}>{(patient_name ? patient_name : '-') + ' ' + (patient_age ? patient_age : '-') + '/' + (patient_gender ? whatGender : '-')}</Typography>
                                            {this.props.icon ? <div style={{ marginLeft: "0.5vw" }}>
                                                {whatGender === "M" ? <MaleIcon sx={{ fontSize: "1vw", color: '#616161' }} /> : whatGender === "F" ? <FemaleIcon sx={{ fontSize: "1vw", color: '#616161' }} /> : null}
                                            </div> : null}
                                        </div>
                                    }
                                </Typography>
                                <Typography id='eMed_Com_Patient_UhidText'>{(PatientAccNumber) + ' | ' + (mobile_number ? mobile_number : '-')}</Typography>
                                {this.props.isCommonUhid ? <Typography id='eMed_Com_Patient_UhidText'>Branch Name: {branchName?.length > 22 ? <Tooltip placement="top" title={branchName} arrow><span id='eMed_Com_Patient_UhidText'>{branchName?.slice(0, 19) + "..."}</span></Tooltip> : branchName ? branchName : "-"}</Typography> : null}
                            </Box>
                        }

                        {this.props.showDetailed === true ?
                            <Box component={'div'}>
                                {this.props?.fromDoctor ?
                                    <Typography id='eMed_Com_Patient_Name'>
                                        {data?.op_number?.length > 15 ?
                                            <Tooltip title={data?.op_number} placement={'top'} arrow>
                                                <Typography id='eMed_Com_Patient_Name'>{data?.op_number ? data?.op_number?.length > 9 ? ('...' + data?.op_number.slice(10)) : data?.op_number : '-'}</Typography>
                                            </Tooltip> : <Typography id='eMed_Com_Patient_Name'>{data?.op_number ? data?.op_number : '-'}</Typography>}
                                    </Typography>
                                    :
                                    <Typography id='eMed_Com_Patient_Name'>
                                        {(data?.ip_number?.length > 15) || (data?.op_number?.length > 15) ?
                                            <Tooltip title={data?.ip_number ? data?.ip_number : data?.op_number} placement={'top'} arrow>
                                                <Typography id='eMed_Com_Patient_Name'>{data?.ip_number ? (data?.ip_number?.length > 9 ? ('...' + data?.ip_number.slice(14)) : data?.ip_number) : data?.op_number ? data?.op_number?.length > 9 ? ('...' + data?.op_number.slice(10)) : data?.op_number : '-'}</Typography>
                                            </Tooltip> : <Typography id='eMed_Com_Patient_Name'>{data?.ip_number ? data?.ip_number : data?.op_number ? data?.op_number : '-'}</Typography>}
                                    </Typography>
                                }
                                <Typography id='eMed_Com_Patient_UhidText'>{admission_date ? `| ${admission_date}` : '-'}</Typography>
                            </Box> : null}
                    </Box>
                    {
                        this.props.showTag === true ?
                            <Typography component={'div'}>
                                {data?.patient_tag_name?.length > 15 ?
                                    <Tooltip title={data?.patient_tag_name} placement={'top'} arrow>
                                        <Typography id='eMed_Com_Patient_UhidText' style={{ fontSize: '0.8vw', fontWeight: "bold", color: data?.patient_tag_color ? data?.patient_tag_color : "#000000" }}>{'Tag: ' + (data?.patient_tag_name ? data?.patient_tag_name.slice(0, 15) + '...' : '-')}</Typography>
                                    </Tooltip> : <Typography id='eMed_Com_Patient_UhidText' style={{ fontSize: '0.8vw', fontWeight: "bold", color: data?.patient_tag_color ? data?.patient_tag_color : "#000000" }}>{'Tag: ' + (data?.patient_tag_name ? data?.patient_tag_name : '-')}</Typography>}
                            </Typography> : null
                    }
                    {
                        this.props.showAdmission === true ?
                            <Typography component={'div'}>
                                {admissionDetails?.length > 15 ?
                                    <Tooltip title={admissionDetails} placement={'top'} arrow>
                                        <Typography id='eMed_Com_Patient_UhidText'>{this.props.showAproxDate ? `Approx.Admission:` : `Admission Date&Time: `}<span id='eMed_Com_Patient_admissionTxt'>{admissionDetails ? admissionDetails.slice(0, 13) + '...' : '-'}</span></Typography>
                                    </Tooltip> : <Typography id='eMed_Com_Patient_UhidText'>{this.props.showAproxDate ? `Approx.Admission:` : `Admission Date&Time: `}<span id='eMed_Com_Patient_admissionTxt'>{admissionDetails ? admissionDetails : '-'}</span></Typography>}
                            </Typography> : null
                    }
                    {
                        this.props.isFromOTList === true ?
                            <Typography component={'div'}>
                                {SurgeryDetails?.length > 15 ?
                                    <Tooltip title={SurgeryDetails} placement={'top'} arrow>
                                        <Typography id='eMed_Com_Patient_UhidText'>{`Surgery Date&Time: `}<span id='eMed_Com_Patient_admissionTxt'>{SurgeryDetails ? SurgeryDetails.slice(0, 13) + '...' : '-'}</span></Typography>
                                    </Tooltip> : <Typography id='eMed_Com_Patient_UhidText'>{`Surgery Date&Time: `}<span id='eMed_Com_Patient_admissionTxt'>{SurgeryDetails ? SurgeryDetails : '-'}</span></Typography>}
                            </Typography> : null
                    }
                </div>
            </div>
        )
    }
}

export const useDebounce = (value, delay = 300) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}

export const DiscardPopup = (props) => {
    return (
        <Dialog
            open={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent dividers sx={{ width: '25vw', height: '5vw' }}>
                <DialogContentText id="alert-dialog-description" sx={{ fontWeight: 'bold' }}>
                    {`Do you want to save the data for ${props.component}`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button size="small" variant="outlined" color='error' onClick={() => { props.no() }}>No</Button>
                <Button size="small" variant="contained" onClick={() => { props.yes() }}>Yes</Button>
            </DialogActions>
        </Dialog>
    )
}
export class RefundReceivePopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dialogBox: true,
            isCash: false,
            isUPI: false,
            isBankTranfer: false,
            CashAmount: "",
            UPINumber: "",
            UPIAmount: "",
            BankTfrAmount: "",
            BankTfrNumber: "",
            RefundableAmt: this?.props?.MaxRefundAmount ? this?.props?.MaxRefundAmount : "",
            BtnDisable: false
        }
    }

    closePopup = () => {
        this.props.AlertPopupClose();
    };

    renderAmountTextFields = (label, key, Icon) => {
        var states = this.state
        let { t } = this.props;
        return (
            <TextField
                sx={{ padding: 0, margin: 0, width: "10vw" }}
                className='eMed_CrdPop_Amount_TextFields'
                size='small'
                // disabled={this.state.forCancel}
                label={label}
                autoComplete='off'
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <img src={Icon} alt={label} className='eMed_action_img_small' />
                        </InputAdornment>
                    ),
                }}
                value={states[key]}
                onChange={(e) => {
                    let number = CommonValidation.NumberWithDot(e.target.value);
                    if ((number && +e.target.value > 0) || e.target.value === "") {
                        states[key] = e.target.value
                        this.setState({
                            states,
                        })
                    }
                }}
            />
        )
    }

    renderNumberTextFields = (label, key, Right = false) => {
        var states = this.state
        let { t } = this.props;
        return (
            <TextField
                className='eMed_CrdPop_Amount_TextFields'
                sx={{ marginLeft: Right ? "1vw" : 0, width: "10vw" }}
                inputProps={{ maxLength: 20 }}
                // disabled={this.state.forCancel}
                size='small'
                label={label}
                value={states[key]}
                autoComplete='off'
                onChange={(e) => {
                    let number = CommonValidation.gstnumberValidation(e.target.value);
                    if (number || e.target.value === "") {
                        states[key] = e.target.value.toUpperCase()
                        this.setState({
                            states,
                            ReasonError: ""
                        })
                    }
                }}
            />
        )
    }

    handleCheckBox = (e, key) => {
        var states = this.state
        states[key] = e.target.checked
        this.setState({ states }, () => {
            if (!states.isCash) { this.setState({ CashAmount: "" }) }
            if (!states.isUPI) { this.setState({ UPIAmount: "", UPINumber: "" }) }
            if (!states.isBankTranfer) { this.setState({ BankTfrAmount: "", BankTfrNumber: "" }) }
                let FetchingAccess = localGetItem("auto_fetch_bill_amount_to_payment")
                if (FetchingAccess === "true") {
                    if (states.isCash && !states.isUPI && !states.isBankTranfer) {
                        this.setState({ CashAmount: this.state.RefundableAmt })
                    } else if (!states.isCash && states.isUPI && !states.isBankTranfer) {
                        this.setState({ UPIAmount: this.state.RefundableAmt })
                    } else if (!states.isCash && !states.isUPI && states.isBankTranfer) {
                        this.setState({ BankTfrAmount: this.state.RefundableAmt })
                    }
                }
        })
    }

    FullAmountEntered() {
        try {
            let states = this.state;
            let CashAmt = states.CashAmount === "" ? 0 : +states.CashAmount;
            let UPIAmt = states.UPIAmount === "" ? 0 : +states.UPIAmount;
            let bankTransferAmt = states.BankTfrAmount === "" ? 0 : +states.BankTfrAmount;
            if (((CashAmt + UPIAmt + bankTransferAmt) == +states.RefundableAmt)) {
                if (
                    (states.UPINumber !== "" && states.UPINumber?.length < TXN_MSG_MAX_LEN) ||
                    (states.BankTfrNumber !== "" && states.BankTfrNumber?.length < TXN_MSG_MAX_LEN)
                ) {
                    this.setState({
                        BtnDisable: false,
                        ReasonError: TXN_MSG_MAX
                    })
                } else if ((UPIAmt !== 0 && states.UPINumber === "") ||
                    (bankTransferAmt !== 0 && states.BankTfrNumber === "")) {
                    this.setState({
                        BtnDisable: false,
                        ReasonError: "Enter Transaction Details"
                    });
                } else {
                    this.props.refundPost(this.state)
                }
            } else if (
                (states.UPINumber !== "" && states.UPINumber?.length < TXN_MSG_MAX_LEN) ||
                (states.BankTfrNumber !== "" && states.BankTfrNumber?.length < TXN_MSG_MAX_LEN)
            ) {
                this.setState({
                    BtnDisable: false,
                    ReasonError: TXN_MSG_MAX
                })
            } else {
                this.setState({
                    BtnDisable: false,
                    ReasonError: "Amount Not Matched"
                })
            }
        }
        catch (e) {
            console.log(e?.message);
        }
    }

    render() {
        return (
            <Dialog
                open={this.state.dialogBox}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div className="eMed_DialogBox_Title" style={{ padding: '0.5vw' }}>
                    <Typography sx={{ fontSize: '1vw', fontWeight: "bold" }}>
                        {this.props.title}
                    </Typography>
                    <div className="eMed_DialogBox_Close">
                        <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={this.closePopup} />
                    </div>
                </div>
                <DialogContent sx={{ width: "30vw" }}>
                    <TextField
                        sx={{ width: '26vw' }}
                        inputProps={{ maxLength: 10 }}
                        placeholder={this.props.label}
                        variant="outlined"
                        value={this.state.RefundableAmt || ""}
                        onChange={(e) => {
                            let value = e.target.value
                            if ((CommonValidation.NumberWithDot(value) && (this?.props?.MaxRefundAmount === null || (+value <= this?.props?.MaxRefundAmount))) || value === '') {
                                this.setState({ RefundableAmt: e.target.value, })
                            }
                        }} />

                    <Box component={'div'}>
                        <Box ml={"0.5vw"}>
                            <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' control={<Checkbox checked={this.state.isCash} onChange={(e) => { this.handleCheckBox(e, "isCash") }} size='small' />} label={"Cash"} />
                            <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' control={<Checkbox checked={this.state.isUPI} onChange={(e) => { this.handleCheckBox(e, "isUPI") }} size='small' />} label={"UPI"} />
                            <FormControlLabel className='eMed_CrdPop_CheckBoxDiv' sx={{ width: "10vw" }} control={<Checkbox checked={this.state.isBankTranfer} onChange={(e) => { this.handleCheckBox(e, "isBankTranfer") }} size='small' />} label={"Bank Transfer"} />
                        </Box>

                        <Box component={'div'} display={'flex'} flexDirection={'column'} ml={'0.5vw'} overflow={'scroll'} mt={'-0.3vw'}>
                            {
                                this.state.isCash ?
                                    <Box component={"div"} display={"flex"} flexDirection={"row"} ml={"0.5vw"}>
                                        {this.renderAmountTextFields("CashAmount", "CashAmount", ImagePaths.CashIcon.default)}
                                    </Box> : null
                            }
                            {
                                this.state.isUPI ?
                                    <Box component={"div"} display={"flex"} flexDirection={"row"} ml={"0.5vw"}>
                                        {this.renderAmountTextFields("UPIAmount", "UPIAmount", ImagePaths.UPIIcon.default)}
                                        {this.renderNumberTextFields("UPITransactionNumber", "UPINumber", true)}
                                    </Box>
                                    : null
                            }
                            {
                                this.state.isBankTranfer ?
                                    <Box component={"div"} display={"flex"} flexDirection={"row"} ml={"0.5vw"}>
                                        {this.renderAmountTextFields("BankTransferAmount", "BankTfrAmount", ImagePaths.BankTransferIcon.default)}
                                        {this.renderNumberTextFields("BankTransactionNumber", "BankTfrNumber", true)}
                                    </Box>
                                    : null
                            }
                        </Box>
                    </Box>
                    <Box height={'1vw'} marginTop={'0.5vw'} width={'100%'} textAlign={'center'}>
                        <Typography color={'red'} fontSize={'0.8vw'}>{this.state.ReasonError !== "" ? this.state.ReasonError : ""}</Typography>
                    </Box>
                </DialogContent>
                <DialogActions id="eMed_DialogBox_Btn">
                    <Button size="small" variant={this.props.btnvarient} id="eMed_Dia_Btn" color="error" onClick={this.closePopup}>
                        {this.props.btntext}
                    </Button>
                    <Button color={this.props.btncolor} size="small" variant={this.props.btnvarient1} id="eMed_Dia_Btn" disabled={this.state.BtnDisable} onClick={() => {
                            this.setState({
                                BtnDisable: true
                            }, () => {
                                    this.FullAmountEntered()
                            })
                    }}>
                        {this.props.btntext1}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export class HighAlertDrugPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            disableBtn: false,
        };
    }

    handleConfirm = () => {
        this.setState({ disableBtn: true });
        if (this.props.onConfirm) this.props.onConfirm();
        setTimeout(() => this.setState({ disableBtn: false }), 1500);
    };

    handleCancel = () => {
        if (this.props.onCancel) this.props.onCancel();
    };

    handleOk = () => {
        if (this.props.onOk) this.props.onOk();
    };

    render() {
        const { selectedDrug, is_high_alert, is_lookAlike, is_soundAlike, lookAlikeDrugs, soundAlikeDrugs, onlyWarning, allData } = this.props;

        const highAlertList = allData?.filter(d => d.is_high_alert);
        const lookAlikeList = allData?.filter(d => d.is_look_alike);
        const soundAlikeList = allData?.filter(d => d.is_sound_alike);

        return (
            <Dialog
                open={this.state.open}
                aria-labelledby="high-alert-dialog-title"
                aria-describedby="high-alert-dialog-description"
            >
                <DialogTitle id="high-alert-dialog-title" sx={{ fontSize: "1.05rem", color: 'red', fontWeight: 700, padding: '0.5vw', textAlign: "center", backgroundColor: "#e4e4e4", lineHeight: 1.5 }}>
                    HIGH ALERT: LOOK-ALIKE/SOUND-ALIKE WARNING
                </DialogTitle>
                <DialogContent 
                sx={{
                    maxHeight: "60vh",
                    overflowY: "auto",
                    paddingRight: "0.5vw",
                }}>
                    <DialogContentText id="high-alert-dialog-description" sx={{ fontSize: '1vw', marginBottom: '1vw', wordBreak:'break-word' }}>
                        {onlyWarning ? (
                            <div style={{ marginTop: "1vw" }}>
                                {highAlertList?.length > 0 && (
                                    <>
                                        <Typography
                                            sx={{
                                                color: 'red',
                                                fontWeight: 600,
                                                fontSize: '1vw',
                                                mb: 0.5
                                            }}
                                        >
                                            High Alert Drugs:
                                        </Typography>
                                        <ul style={{ marginTop: 0 }}>
                                            {highAlertList.map((drug, i) => (
                                                <li key={`ha-${i}`}>
                                                    <b>{drug.brand_name}</b>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}

                                {lookAlikeList?.length > 0 && (
                                    <>
                                        <Typography
                                            sx={{
                                                color: '#d17b00',
                                                fontWeight: 600,
                                                fontSize: '1vw',
                                                mb: 0.5,
                                                mt: 1
                                            }}
                                        >
                                            Look-Alike Drugs:
                                        </Typography>
                                        <ul style={{ marginTop: 0, paddingLeft:"1.2vw", wordBreak:'break-word' }}>
                                            {lookAlikeList.map((drug, i) => (
                                                <li key={`la-${i}`}>
                                                    <b>{drug.brand_name}</b> →{" "}
                                                    {drug.look_alike_drugs?.join(", ")}
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}

                                {soundAlikeList?.length > 0 && (
                                    <>
                                        <Typography
                                            sx={{
                                                color: '#0078d4',
                                                fontWeight: 600,
                                                fontSize: '1vw',
                                                mb: 0.5,
                                                mt: 1
                                            }}
                                        >
                                            Sound-Alike Drugs:
                                        </Typography>
                                        <ul style={{ marginTop: 0, paddingLeft:"1.2vw", wordBreak:'break-word' }}>
                                            {soundAlikeList.map((drug, i) => (
                                                <li key={`sa-${i}`}>
                                                    <b>{drug.brand_name}</b> →{" "}
                                                    {drug.sound_alike_drugs?.join(", ")}
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}

                                <Typography sx={{ mt: 2 }}>
                                    Please verify all high-alert medications before proceeding.
                                </Typography>
                            </div>) 
                            :
                            <>
                                {is_high_alert && (
                                    <>
                                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', my: '0.5vw' }}>
                                            <Typography sx={{ color: 'red', fontSize: '1vw', fontWeight: 600 }}>
                                                High Risk Medications
                                            </Typography>
                                        </Box>
                                        {!is_lookAlike && !is_soundAlike ? <>
                                            You have selected <b>{selectedDrug}</b>. This is a high-risk drug.<br />
                                            <br />
                                            <b>Confirm the Patient’s Drug, Route, Quantity before proceeding.</b>
                                        </> : null}
                                    </>
                                )}

                                {(is_lookAlike || is_soundAlike) && (
                                    <div style={{ marginTop: is_high_alert ? null : '1vw' }}>
                                        You have selected <b>{selectedDrug}</b>. This drug is{' '}
                                        {is_lookAlike && is_soundAlike ? (
                                            <> look-alike with{' '}
                                                {lookAlikeDrugs?.map((drug, i) => (
                                                    <b key={`look-${i}`}>
                                                        {drug}
                                                        {i < lookAlikeDrugs.length - 1 && ', '}
                                                    </b>
                                                ))}{' '} and sound-alike with{' '}
                                                {soundAlikeDrugs?.map((drug, i) => (
                                                    <b key={`sound-${i}`}>
                                                        {drug}
                                                        {i < soundAlikeDrugs.length - 1 && ', '}
                                                    </b>
                                                ))}
                                            </>
                                        ) : is_lookAlike ? (
                                            <>
                                                look-alike with{' '}
                                                {lookAlikeDrugs?.map((drug, i) => (
                                                    <b key={`look-${i}`}>
                                                        {drug}
                                                        {i < lookAlikeDrugs.length - 1 && ', '}
                                                    </b>
                                                ))}
                                            </>
                                        ) : (
                                            <>
                                                sound-alike with{' '}
                                                {soundAlikeDrugs?.map((drug, i) => (
                                                    <b key={`sound-${i}`}>
                                                        {drug}
                                                        {i < soundAlikeDrugs.length - 1 && ', '}
                                                    </b>
                                                ))}
                                            </>
                                        )}.
                                        <br />
                                        <br />
                                        <b>Confirm the Patient’s Drug, Route, Quantity before proceeding.</b>
                                    </div>
                                )}
                            </>}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {onlyWarning ?
                        <div>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={this.handleOk}
                                size="small"
                                sx={{ textTransform: 'capitalize' }}
                            >
                                ok
                            </Button>
                        </div>
                        :
                        <div>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={this.handleCancel}
                                size="small"
                                sx={{ textTransform: 'capitalize' }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={this.state.disableBtn}
                                onClick={this.handleConfirm}
                                size='small'
                                sx={{ textTransform: 'capitalize', marginLeft:"0.75vw" }}
                            >
                                Confirm
                            </Button>
                        </div>}
                </DialogActions>
            </Dialog>
        );
    }
}